import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type AccessToken = {
  __typename?: 'AccessToken';
  accessToken: Scalars['String'];
};

export enum AgeRange {
  Middle = 'MIDDLE',
  Senior = 'SENIOR',
  Young = 'YOUNG'
}

export type AuthLoginInput = {
  password: Scalars['String'];
  phone: Scalars['String'];
};

export type AuthRegisterInput = {
  password: Scalars['String'];
  phone: Scalars['String'];
};

export enum BodyDisorder {
  CatchColdEasily = 'CATCH_COLD_EASILY',
  ColdSensitivity = 'COLD_SENSITIVITY',
  DisorderAutonomicNerve = 'DISORDER_AUTONOMIC_NERVE',
  Fatigue = 'FATIGUE',
  MenstrualPain = 'MENSTRUAL_PAIN',
  PainNumbness = 'PAIN_NUMBNESS',
  SleepState = 'SLEEP_STATE',
  StomachCondition = 'STOMACH_CONDITION',
  UnstableMood = 'UNSTABLE_MOOD'
}

export enum BodyPart {
  ButtocksHip = 'BUTTOCKS_HIP',
  ChestBack = 'CHEST_BACK',
  Elbow = 'ELBOW',
  Face = 'FACE',
  Feet = 'FEET',
  Hands = 'HANDS',
  HeadEyesEars = 'HEAD_EYES_EARS',
  Knees = 'KNEES',
  LowerExtremity = 'LOWER_EXTREMITY',
  MouseJaw = 'MOUSE_JAW',
  Neck = 'NECK',
  Other = 'OTHER',
  Shoulders = 'SHOULDERS',
  Stomach = 'STOMACH',
  Thighs = 'THIGHS',
  Waist = 'WAIST',
  WholeBody = 'WHOLE_BODY'
}

export enum BodyStiff {
  Eye = 'EYE',
  Jaw = 'JAW',
  Lowerjaw = 'LOWERJAW',
  Mouth = 'MOUTH',
  Nose = 'NOSE'
}

export enum CalfThickness {
  Just = 'JUST',
  Loose = 'LOOSE',
  Tight = 'TIGHT',
  Veryloose = 'VERYLOOSE',
  Verytight = 'VERYTIGHT'
}

export type CheckOnetimePasswordInput = {
  id: Scalars['ID'];
  onetimePassword: Scalars['String'];
};

export type Checklist = {
  __typename?: 'Checklist';
  /** 怒りを感じる */
  angry?: Maybe<MentalStatus>;
  /** 腹立たしい気分だ */
  annoyingMood?: Maybe<MentalStatus>;
  /** 身体の硬さ */
  bodyStiff?: Maybe<BodyStiff>;
  /** ふくらはぎの太さ */
  calfThickness?: Maybe<CalfThickness>;
  /** 一つのことに集中することができない */
  concentrateOneThing?: Maybe<MentalStatus>;
  /** 勉強（仕事）が手に付かない */
  concentrateWork?: Maybe<MentalStatus>;
  createdAt: Scalars['DateTime'];
  /** しゃがみ込み */
  crouching?: Maybe<Crouching>;
  /** 泣きたい気分だ */
  cry?: Maybe<MentalStatus>;
  /** 心が暗い */
  depressed?: Maybe<MentalStatus>;
  /** 難しいことを考えることができない */
  difficultThinking?: Maybe<MentalStatus>;
  /** 身体がだるい */
  feelingHeavy?: Maybe<MentalStatus>;
  /** 頭が痛い */
  headache?: Maybe<MentalStatus>;
  holdBreathTime?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** よく眠れない */
  insomnia?: Maybe<MentalStatus>;
  /** いらいらする */
  irritated?: Maybe<MentalStatus>;
  /** 根気がない */
  lackPatience?: Maybe<MentalStatus>;
  loggedAt: Scalars['DateTime'];
  /** さみしい気持ちだ */
  lonely?: Maybe<MentalStatus>;
  oneFootTime?: Maybe<Scalars['Float']>;
  /** 誰かに怒りをぶつけたい */
  outburstAnger?: Maybe<MentalStatus>;
  pulse?: Maybe<Scalars['Float']>;
  /** 悲しい */
  sad?: Maybe<MentalStatus>;
  tandemTime?: Maybe<Scalars['Float']>;
  /** 疲れやすい */
  tiringEasily?: Maybe<MentalStatus>;
  /** 舌の色 */
  tongueColor?: Maybe<TongueColor>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['ID'];
};

export type ChecklistWhereDateUniqueInput = {
  loggedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type ChecklistWhereUniqueInput = {
  id: Scalars['ID'];
};

export type ComoUser = {
  __typename?: 'ComoUser';
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  nameFurigana: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CreateDepartmentInput = {
  managerId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type CreateDepartmentsOnUsersInput = {
  departmentId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type CreateMessageInput = {
  body: Scalars['String'];
  roomId: Scalars['ID'];
  sentAt: Scalars['DateTime'];
  sentBy: Scalars['ID'];
};

export enum Crouching {
  Floatheel = 'FLOATHEEL',
  Not = 'NOT',
  Sinkheel = 'SINKHEEL'
}

export enum CurrentDisease {
  Adiposity = 'ADIPOSITY',
  Arteriosclerosis = 'ARTERIOSCLEROSIS',
  BedriddenPrevention = 'BEDRIDDEN_PREVENTION',
  Cancer = 'CANCER',
  Dementia = 'DEMENTIA',
  Depression = 'DEPRESSION',
  Diabetic = 'DIABETIC',
  Hypertension = 'HYPERTENSION',
  MetabolicSyndrome = 'METABOLIC_SYNDROME',
  MyocardialInfarction = 'MYOCARDIAL_INFARCTION',
  Osteoporosis = 'OSTEOPOROSIS',
  Stroke = 'STROKE'
}

export enum Cyanosis {
  Bothchangecolor = 'BOTHCHANGECOLOR',
  Bothcold = 'BOTHCOLD',
  Eitherchangecolor = 'EITHERCHANGECOLOR',
  Eithercold = 'EITHERCOLD',
  None = 'NONE'
}

export type DashboardScore = {
  __typename?: 'DashboardScore';
  /** 評価項目 */
  evaluations?: Maybe<Array<Evaluation>>;
  /** 前月との比較得点 */
  monthToMonthComparison?: Maybe<Scalars['Int']>;
  /** スコア名称 */
  scoreName: Scalars['String'];
};

export type DeleteDepartmentsOnUsersInput = {
  departmentId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type DeleteManyDepartmentsOnUsersInput = {
  departments: Array<DeleteDepartmentsOnUsersInput>;
};

export type Department = {
  __typename?: 'Department';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  invitationCode?: Maybe<Scalars['String']>;
  manager?: Maybe<Manager>;
  managerId: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DepartmentsOnUsers = {
  __typename?: 'DepartmentsOnUsers';
  department?: Maybe<Department>;
  departmentId: Scalars['ID'];
  user: User;
  userId: Scalars['ID'];
};

export type Diagnose = {
  __typename?: 'Diagnose';
  /** 該当箇所 */
  bodyPart?: Maybe<BodyPart>;
  createdAt: Scalars['DateTime'];
  disease?: Maybe<Disease>;
  diseaseId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  /** 最初に回答した「主となる症状」と関連がある症状ですか？ */
  isRelated: Scalars['Boolean'];
  /** 発症時期 */
  onsetTiming?: Maybe<OnsetTiming>;
  /** その他の症状の自由入力メモ */
  otherSymptomMemo?: Maybe<Scalars['String']>;
  priority: Scalars['Int'];
  /** 問診メモ(患者公開) */
  questionMemo?: Maybe<Scalars['String']>;
  /** 問診メモ(患者非公開) */
  questionSecretMemo?: Maybe<Scalars['String']>;
  symptom?: Maybe<Symptom>;
  /** 思い当たる原因 */
  symptomCause?: Maybe<SymptomCause>;
  treatmentTherapeuticPoints: Array<TreatmentTherapeuticPoint>;
  updatedAt: Scalars['DateTime'];
};

export type Disease = {
  __typename?: 'Disease';
  acupunctureTreatmentMethod: Scalars['String'];
  antiGravityMuscle: Scalars['Boolean'];
  cause: Scalars['String'];
  commonPatient: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  differentialDiagnosisName: Scalars['String'];
  earAcupuncture: Scalars['Boolean'];
  examMethod: Scalars['String'];
  faceAcupuncture: Scalars['Boolean'];
  fourLimb: Scalars['Boolean'];
  id: Scalars['ID'];
  lifestyleGuidance: Scalars['String'];
  majorSymptom: Scalars['String'];
  name: Scalars['String'];
  nameFurigana: Scalars['String'];
  other: Scalars['String'];
  scalpAcupuncture: Scalars['Boolean'];
  scratch: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  westernTreatmentMethod: Scalars['String'];
};

export type EcoChecklist = {
  __typename?: 'EcoChecklist';
  airConditionerUsage?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  daytimeExercise?: Maybe<Scalars['Float']>;
  domesticFood?: Maybe<Scalars['Float']>;
  eatingOutFood?: Maybe<Scalars['Float']>;
  electronicDeviceUsage?: Maybe<Scalars['Float']>;
  equipmentExercise?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  indoorHoliday?: Maybe<Scalars['Float']>;
  localFood?: Maybe<Scalars['Float']>;
  loggedAt: Scalars['DateTime'];
  outdoorExercise?: Maybe<Scalars['Float']>;
  publicTransportUsage?: Maybe<Scalars['Float']>;
  seasonalFood?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['ID'];
};

export type EcoChecklistScore = {
  __typename?: 'EcoChecklistScore';
  data: Scalars['Int'];
  label: Scalars['String'];
};

export type EcoChecklistTotalScore = {
  __typename?: 'EcoChecklistTotalScore';
  ecoChecklistId: Scalars['ID'];
  scores: Array<EcoChecklistScore>;
  totalScore: Scalars['Int'];
};

export type EcoChecklistWhereDateUniqueInput = {
  loggedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type EcoChecklistWhereUniqueInput = {
  id: Scalars['ID'];
};

export type EngagementChecklist = {
  __typename?: 'EngagementChecklist';
  bat1?: Maybe<Scalars['Float']>;
  bat2?: Maybe<Scalars['Float']>;
  bat3?: Maybe<Scalars['Float']>;
  bat4?: Maybe<Scalars['Float']>;
  bat5?: Maybe<Scalars['Float']>;
  bat6?: Maybe<Scalars['Float']>;
  bat7?: Maybe<Scalars['Float']>;
  bat8?: Maybe<Scalars['Float']>;
  bat9?: Maybe<Scalars['Float']>;
  bat10?: Maybe<Scalars['Float']>;
  bat11?: Maybe<Scalars['Float']>;
  bat12?: Maybe<Scalars['Float']>;
  bat13?: Maybe<Scalars['Float']>;
  bat14?: Maybe<Scalars['Float']>;
  bat15?: Maybe<Scalars['Float']>;
  bat16?: Maybe<Scalars['Float']>;
  bat17?: Maybe<Scalars['Float']>;
  bat18?: Maybe<Scalars['Float']>;
  bat19?: Maybe<Scalars['Float']>;
  bat20?: Maybe<Scalars['Float']>;
  bat21?: Maybe<Scalars['Float']>;
  bat22?: Maybe<Scalars['Float']>;
  bat23?: Maybe<Scalars['Float']>;
  bat24?: Maybe<Scalars['Float']>;
  bat25?: Maybe<Scalars['Float']>;
  bat26?: Maybe<Scalars['Float']>;
  bat27?: Maybe<Scalars['Float']>;
  bat28?: Maybe<Scalars['Float']>;
  bat29?: Maybe<Scalars['Float']>;
  bat30?: Maybe<Scalars['Float']>;
  bat31?: Maybe<Scalars['Float']>;
  bat32?: Maybe<Scalars['Float']>;
  bat33?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  fssb1?: Maybe<Scalars['Float']>;
  fssb2?: Maybe<Scalars['Float']>;
  fssb3?: Maybe<Scalars['Float']>;
  fssb4?: Maybe<Scalars['Float']>;
  fssb5?: Maybe<Scalars['Float']>;
  fssb6?: Maybe<Scalars['Float']>;
  fssb7?: Maybe<Scalars['Float']>;
  fssb8?: Maybe<Scalars['Float']>;
  fssb9?: Maybe<Scalars['Float']>;
  fssb10?: Maybe<Scalars['Float']>;
  fssb11?: Maybe<Scalars['Float']>;
  fssb12?: Maybe<Scalars['Float']>;
  fssb13?: Maybe<Scalars['Float']>;
  fssb14?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  loggedAt: Scalars['DateTime'];
  mos1?: Maybe<Scalars['Float']>;
  mos2?: Maybe<Scalars['Float']>;
  mos3?: Maybe<Scalars['Float']>;
  mos4?: Maybe<Scalars['Float']>;
  mos5?: Maybe<Scalars['Float']>;
  mos6?: Maybe<Scalars['Float']>;
  mos7?: Maybe<Scalars['Float']>;
  mos8?: Maybe<Scalars['Float']>;
  mos9?: Maybe<Scalars['Float']>;
  mos10?: Maybe<Scalars['Float']>;
  mos11?: Maybe<Scalars['Float']>;
  mos12?: Maybe<Scalars['Float']>;
  mos13?: Maybe<Scalars['Float']>;
  mos14?: Maybe<Scalars['Float']>;
  mos15?: Maybe<Scalars['Float']>;
  mos16?: Maybe<Scalars['Float']>;
  mos17?: Maybe<Scalars['Float']>;
  mos18?: Maybe<Scalars['Float']>;
  mos19?: Maybe<Scalars['Float']>;
  mos20?: Maybe<Scalars['Float']>;
  mos21?: Maybe<Scalars['Float']>;
  mos22?: Maybe<Scalars['Float']>;
  mos23?: Maybe<Scalars['Float']>;
  mos24?: Maybe<Scalars['Float']>;
  mos25?: Maybe<Scalars['Float']>;
  mos26?: Maybe<Scalars['Float']>;
  mos27?: Maybe<Scalars['Float']>;
  mos28?: Maybe<Scalars['Float']>;
  mos29?: Maybe<Scalars['Float']>;
  mos30?: Maybe<Scalars['Float']>;
  mos31?: Maybe<Scalars['Float']>;
  mos32?: Maybe<Scalars['Float']>;
  mos33?: Maybe<Scalars['Float']>;
  mos34?: Maybe<Scalars['Float']>;
  mos35?: Maybe<Scalars['Float']>;
  mos36?: Maybe<Scalars['Float']>;
  mos37?: Maybe<Scalars['Float']>;
  mos38?: Maybe<Scalars['Float']>;
  mos39?: Maybe<Scalars['Float']>;
  mos40?: Maybe<Scalars['Float']>;
  mos41?: Maybe<Scalars['Float']>;
  mos42?: Maybe<Scalars['Float']>;
  mos43?: Maybe<Scalars['Float']>;
  mos44?: Maybe<Scalars['Float']>;
  mos45?: Maybe<Scalars['Float']>;
  mos46?: Maybe<Scalars['Float']>;
  mos47?: Maybe<Scalars['Float']>;
  mos48?: Maybe<Scalars['Float']>;
  mos49?: Maybe<Scalars['Float']>;
  mos50?: Maybe<Scalars['Float']>;
  mos51?: Maybe<Scalars['Float']>;
  req1?: Maybe<Scalars['Float']>;
  req2?: Maybe<Scalars['Float']>;
  req3?: Maybe<Scalars['Float']>;
  req4?: Maybe<Scalars['Float']>;
  req5?: Maybe<Scalars['Float']>;
  req6?: Maybe<Scalars['Float']>;
  req7?: Maybe<Scalars['Float']>;
  req8?: Maybe<Scalars['Float']>;
  req9?: Maybe<Scalars['Float']>;
  req10?: Maybe<Scalars['Float']>;
  req11?: Maybe<Scalars['Float']>;
  req12?: Maybe<Scalars['Float']>;
  req13?: Maybe<Scalars['Float']>;
  req14?: Maybe<Scalars['Float']>;
  req15?: Maybe<Scalars['Float']>;
  req16?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['ID'];
  uwes1?: Maybe<Scalars['Float']>;
  uwes2?: Maybe<Scalars['Float']>;
  uwes3?: Maybe<Scalars['Float']>;
  workSpace1?: Maybe<Scalars['Float']>;
  workSpace2?: Maybe<Scalars['Float']>;
};

export type EngagementChecklistScore = {
  __typename?: 'EngagementChecklistScore';
  data: Scalars['Int'];
  label: Scalars['String'];
};

export type EngagementChecklistTotalScore = {
  __typename?: 'EngagementChecklistTotalScore';
  engagementChecklistId: Scalars['ID'];
  scores: Array<EngagementChecklistScore>;
  totalScore: Scalars['Int'];
};

export type EngagementChecklistWhereDateUniqueInput = {
  loggedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type EngagementChecklistWhereUniqueInput = {
  id: Scalars['ID'];
};

export type Evaluation = {
  __typename?: 'Evaluation';
  /** 平均点 */
  average?: Maybe<Scalars['Float']>;
  /** 評価対象範囲名称 */
  coverageName: Scalars['String'];
  /** 悪化率(対象月と前月比で数値が低下した人数の割合) */
  decreaseRate?: Maybe<Scalars['Int']>;
  /** 在籍人数 */
  headcount?: Maybe<Scalars['Int']>;
  /** 改善率(対象月と前月比で数値が向上した人数の割合) */
  increaseRate?: Maybe<Scalars['Int']>;
  /** 最高点 */
  max?: Maybe<Scalars['Int']>;
  /** 最低点 */
  min?: Maybe<Scalars['Int']>;
  /** 対象月アクティブユーザー数 */
  monthActiveHeadcount?: Maybe<Scalars['Int']>;
  /** 対象前月アクティブユーザー数 */
  previousMonthActiveHeadcount?: Maybe<Scalars['Int']>;
  /** 標準偏差 */
  standardDeviation?: Maybe<Scalars['Float']>;
  /** 対象2ヶ月間の継続アクティブユーザー数 */
  twoMonthsActiveHeadcount?: Maybe<Scalars['Int']>;
};

export type Exercise = {
  __typename?: 'Exercise';
  createdAt: Scalars['DateTime'];
  exerciseGroup: ExerciseGroup;
  exerciseGroupId: Scalars['ID'];
  id: Scalars['ID'];
  lifestyles: Array<ExercisesOnLifestyles>;
  /** Mets(運動強度) */
  mets: Scalars['Float'];
  /** 運動名 */
  name: Scalars['String'];
  /** 順番 */
  placedAt: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type ExerciseGroup = {
  __typename?: 'ExerciseGroup';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** 運動グループ名 */
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ExerciseGroupWhereUniqueInput = {
  id: Scalars['ID'];
};

export type ExerciseWhereUniqueInput = {
  id: Scalars['ID'];
};

export type ExercisesOnLifestyles = {
  __typename?: 'ExercisesOnLifestyles';
  exercise: Exercise;
  exerciseAmount: Scalars['Int'];
  exerciseId: Scalars['ID'];
  lifestyle: Lifestyle;
  lifestyleId: Scalars['ID'];
};

export type FindDepartmentByInvitationCodeWhereInput = {
  invitationCode: Scalars['String'];
};

export type FindDepartmentWhereInput = {
  id: Scalars['ID'];
};

export type Food = {
  __typename?: 'Food';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  meals: Array<FoodsOnMeals>;
  /** 品目名 */
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type FoodWhereUniqueInput = {
  id: Scalars['ID'];
};

export type FoodsOnMeals = {
  __typename?: 'FoodsOnMeals';
  food: Food;
  foodId: Scalars['ID'];
  meal: Meal;
  mealId: Scalars['ID'];
};

export enum HabitFrequency {
  Everyday = 'EVERYDAY',
  HalfAWeek = 'HALF_A_WEEK',
  Less = 'LESS',
  OnceAWeek = 'ONCE_A_WEEK',
  Others = 'OTHERS',
  SeveralAMonth = 'SEVERAL_A_MONTH'
}

export enum HasHabit {
  Had = 'HAD',
  No = 'NO',
  Yes = 'YES'
}

export type Hashtag = {
  __typename?: 'Hashtag';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum HealthGoal {
  Diet = 'DIET',
  Normal = 'NORMAL'
}

export enum HealthHabit {
  Aroma = 'AROMA',
  Bathing = 'BATHING',
  DietaryManagement = 'DIETARY_MANAGEMENT',
  Gymnastics = 'GYMNASTICS',
  Others = 'OTHERS',
  SleepManagement = 'SLEEP_MANAGEMENT',
  SportsGym = 'SPORTS_GYM',
  Stretch = 'STRETCH',
  Supplemented = 'SUPPLEMENTED',
  ThermalTherapy = 'THERMAL_THERAPY',
  Yoga = 'YOGA'
}

export enum HealthScoreRange {
  Danger = 'DANGER',
  Mild = 'MILD',
  Moderate = 'MODERATE',
  Serious = 'SERIOUS'
}

export type InvoiceResult = {
  __typename?: 'InvoiceResult';
  clientSecret: Scalars['String'];
  invoiceId: Scalars['ID'];
  priceId: Scalars['ID'];
};

export type Kokokara = {
  __typename?: 'Kokokara';
  characteristicL: YomogiProCharacteristicL;
  characteristicS: YomogiProCharacteristicS;
  checklistId: Scalars['ID'];
  scores: Array<KokokaraScore>;
  totalScore: Scalars['Int'];
};

export type KokokaraScore = {
  __typename?: 'KokokaraScore';
  characteristicL: YomogiProCharacteristicL;
  characteristicS: YomogiProCharacteristicS;
  data: Scalars['Int'];
  label: Scalars['String'];
};

export type LicenseTest = {
  __typename?: 'LicenseTest';
  /** 回答 */
  answer: Array<Scalars['String']>;
  /** 選択肢 */
  choice: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** 解説 */
  explanation?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** 関連する動画 */
  licenseTestContentId?: Maybe<Scalars['String']>;
  /** 検定の種類 */
  licenseType: LicenseType;
  /** 問題 */
  question: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LicenseTestContent = {
  __typename?: 'LicenseTestContent';
  createdAt: Scalars['DateTime'];
  /** 詳細 */
  description: Scalars['String'];
  /** mp4ファイル */
  file: Scalars['String'];
  id: Scalars['ID'];
  /** 検定の種類 */
  licenseType: LicenseType;
  placedAt?: Maybe<Scalars['Int']>;
  /** サムネイル */
  thumbnail?: Maybe<Scalars['String']>;
  /** タイトル */
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LicenseTestUniqueInput = {
  id: Scalars['ID'];
};

export type LicenseTestWhereInput = {
  /** 関連する動画 */
  licenseTestContentId?: InputMaybe<Scalars['ID']>;
  /** 検定の種類 */
  licenseType?: InputMaybe<LicenseType>;
};

/** 検定の種類 */
export enum LicenseType {
  YojyoInstructor = 'YOJYO_INSTRUCTOR',
  YojyoLicense = 'YOJYO_LICENSE'
}

export type Lifestyle = {
  __typename?: 'Lifestyle';
  bedtime?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  dream?: Maybe<Scalars['Boolean']>;
  duringMenstruation?: Maybe<Scalars['Boolean']>;
  exercisesOnLifestyles: Array<ExercisesOnLifestyles>;
  fatigue?: Maybe<Scalars['Float']>;
  feeling?: Maybe<Scalars['Float']>;
  healthStatus?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lifestyleMemo?: Maybe<Scalars['String']>;
  loggedAt: Scalars['DateTime'];
  meals: Array<Meal>;
  menstruationCondition?: Maybe<MenstruationCondition>;
  sleepDisruption?: Maybe<SleepDisruption>;
  sleepQuality?: Maybe<SleepQuality>;
  stoolCondition?: Maybe<StoolCondition>;
  symptom?: Maybe<Symptom>;
  symptomMemo?: Maybe<Scalars['String']>;
  symptomOnset?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['ID'];
  wakeupTime?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['String']>;
};

export type LifestyleByUserIdWhereUniqueInput = {
  loggedAt?: InputMaybe<Scalars['DateTime']>;
  userId: Scalars['ID'];
};

export type LifestyleScore = {
  __typename?: 'LifestyleScore';
  data: Scalars['Int'];
  label: Scalars['String'];
};

export type LifestyleWhereDateUniqueInput = {
  loggedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type Manager = {
  __typename?: 'Manager';
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  loginedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ManagerAuthLoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type ManagerAuthRegisterInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
};

export type ManagerMe = {
  __typename?: 'ManagerMe';
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  loginedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Me = {
  __typename?: 'Me';
  address?: Maybe<Scalars['String']>;
  birth?: Maybe<Scalars['DateTime']>;
  bodyDisorder?: Maybe<BodyDisorder>;
  comoId?: Maybe<Scalars['String']>;
  completedYojyoInstructorTestIds?: Maybe<Array<Scalars['String']>>;
  completedYojyoLicenseTestIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['DateTime'];
  currentDisease?: Maybe<CurrentDisease>;
  departments?: Maybe<Array<DepartmentsOnUsers>>;
  hadYojyoInstructorTestAt?: Maybe<Scalars['DateTime']>;
  hadYojyoLicenseTestAt?: Maybe<Scalars['DateTime']>;
  healthGoal?: Maybe<HealthGoal>;
  height?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isOnetimePasswordChecked: Scalars['Boolean'];
  loginedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nameFurigana?: Maybe<Scalars['String']>;
  onetimePassword?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  sex?: Maybe<Sex>;
  updatedAt: Scalars['DateTime'];
  usingPurpose?: Maybe<UsingPurpose>;
  weight?: Maybe<Scalars['String']>;
  yojyoInstructorTestNumber?: Maybe<Scalars['String']>;
  yojyoLicenseTestNumber?: Maybe<Scalars['String']>;
};

export type Meal = {
  __typename?: 'Meal';
  createdAt: Scalars['DateTime'];
  foodsOnMeals: Array<FoodsOnMeals>;
  id: Scalars['ID'];
  lifestyle: Lifestyle;
  lifestyleId: Scalars['ID'];
  mealTiming: MealTiming;
  nutrientsOnMeals: Array<NutrientsOnMeals>;
  snacksOnMeals: Array<SnacksOnMeals>;
  updatedAt: Scalars['DateTime'];
};

export enum MealTiming {
  Dinner = 'DINNER',
  Lunch = 'LUNCH',
  Morning = 'MORNING',
  Snack = 'SNACK'
}

export enum MedicalHistory {
  Cancer = 'CANCER',
  CerebrovascularDisorder = 'CEREBROVASCULAR_DISORDER',
  Depression = 'DEPRESSION',
  DiabetesMellitus = 'DIABETES_MELLITUS',
  HereditaryDisease = 'HEREDITARY_DISEASE',
  HighBloodPressure = 'HIGH_BLOOD_PRESSURE',
  Hyperlipidaemia = 'HYPERLIPIDAEMIA',
  Others = 'OTHERS'
}

export enum MenstruationCondition {
  Backache = 'BACKACHE',
  Blood = 'BLOOD',
  Headache = 'HEADACHE',
  Malaise = 'MALAISE',
  Pain = 'PAIN'
}

export enum MentalStatus {
  Agree = 'AGREE',
  Littleagree = 'LITTLEAGREE',
  Stronglyagree = 'STRONGLYAGREE',
  Stronglydisagree = 'STRONGLYDISAGREE'
}

export type Message = {
  __typename?: 'Message';
  body: Scalars['String'];
  id: Scalars['ID'];
  room: Room;
  roomId: Scalars['ID'];
  sentAt: Scalars['DateTime'];
  sentBy: Scalars['ID'];
};

export type MicroCmsImage = {
  __typename?: 'MicroCmsImage';
  height: Scalars['Float'];
  url: Scalars['String'];
  width: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  checkOnetimePassword: OnetimePasswordStatus;
  createDepartment: Department;
  createDepartmentsOnUsers: DepartmentsOnUsers;
  createInvoice: InvoiceResult;
  createMessage: Message;
  createSetupIntent: SetupIntentResult;
  deleteDepartmentsOnUsers: DepartmentsOnUsers;
  deleteManyDepartmentsOnUsers: Array<DepartmentsOnUsers>;
  login: AccessToken;
  managerLogin: AccessToken;
  managerRegister: AccessToken;
  register: AccessToken;
  removeUser: User;
  requestResetPassword: ResetPasswordStatus;
  resetPassword: AccessToken;
  updateChecklistByDate: Checklist;
  updateChecklistByMonth: Checklist;
  updateCompletedYojyoTestIds: Scalars['Boolean'];
  updateDepartment: Department;
  updateEcoChecklistByDate: EcoChecklist;
  updateEcoChecklistByMonth: EcoChecklist;
  updateEngagementChecklist: EngagementChecklist;
  updateLifestyleByDate: Lifestyle;
  updateManager: Manager;
  updatePaymentMethod: Scalars['Boolean'];
  updateUser: User;
  updateYojyoTestNumber: Scalars['Boolean'];
};


export type MutationCheckOnetimePasswordArgs = {
  input: CheckOnetimePasswordInput;
};


export type MutationCreateDepartmentArgs = {
  input: CreateDepartmentInput;
};


export type MutationCreateDepartmentsOnUsersArgs = {
  input: CreateDepartmentsOnUsersInput;
};


export type MutationCreateInvoiceArgs = {
  email: Scalars['String'];
  priceId: Scalars['String'];
};


export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationCreateSetupIntentArgs = {
  email: Scalars['String'];
};


export type MutationDeleteDepartmentsOnUsersArgs = {
  input: CreateDepartmentsOnUsersInput;
};


export type MutationDeleteManyDepartmentsOnUsersArgs = {
  input: DeleteManyDepartmentsOnUsersInput;
};


export type MutationLoginArgs = {
  input: AuthLoginInput;
};


export type MutationManagerLoginArgs = {
  input: ManagerAuthLoginInput;
};


export type MutationManagerRegisterArgs = {
  input: ManagerAuthRegisterInput;
};


export type MutationRegisterArgs = {
  input: AuthRegisterInput;
};


export type MutationRemoveUserArgs = {
  id: Scalars['ID'];
};


export type MutationRequestResetPasswordArgs = {
  phone: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationUpdateChecklistByDateArgs = {
  input: UpdateChecklistInput;
};


export type MutationUpdateChecklistByMonthArgs = {
  input: UpdateChecklistInput;
};


export type MutationUpdateCompletedYojyoTestIdsArgs = {
  input: UpdateCompletedYojyoTestInput;
};


export type MutationUpdateDepartmentArgs = {
  input: UpdateDepartmentInput;
};


export type MutationUpdateEcoChecklistByDateArgs = {
  input: UpdateEcoChecklistInput;
};


export type MutationUpdateEcoChecklistByMonthArgs = {
  input: UpdateEcoChecklistInput;
};


export type MutationUpdateEngagementChecklistArgs = {
  input: UpdateEngagementChecklistInput;
};


export type MutationUpdateLifestyleByDateArgs = {
  input: UpdateLifestyleInput;
};


export type MutationUpdateManagerArgs = {
  input: UpdateManagerInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateYojyoTestNumberArgs = {
  input: UpdateYojyoTestNumberInput;
};

export type Nutrient = {
  __typename?: 'Nutrient';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  meals: Array<NutrientsOnMeals>;
  /** 栄養素名 */
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum NutrientIntake {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  None = 'NONE',
  Small = 'SMALL'
}

export type NutrientWhereUniqueInput = {
  id: Scalars['ID'];
};

export type NutrientsOnMeals = {
  __typename?: 'NutrientsOnMeals';
  meal: Meal;
  mealId: Scalars['ID'];
  nutrient: Nutrient;
  nutrientId: Scalars['ID'];
  nutrientIntake: NutrientIntake;
};

export type Office = {
  __typename?: 'Office';
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameFurigana?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type Okotoba = {
  __typename?: 'Okotoba';
  characteristicL: YomogiProCharacteristicL;
  content: Scalars['String'];
  eyecatch: MicroCmsImage;
  healthScoreRange: HealthScoreRange;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type Omikuji = {
  __typename?: 'Omikuji';
  /** 身体の状況 */
  bodyCondition: Scalars['String'];
  /** 健康へのアドバイス */
  healthAdvice: Scalars['String'];
  id: Scalars['ID'];
  /** 心の状況 */
  mentalCondition: Scalars['String'];
  /** 順番 */
  omikujiNumber: Scalars['Int'];
  /** おすすめの食材 */
  recommendedFood: Scalars['String'];
  /** おすすめのツボ */
  recommendedPressurePoint: Scalars['String'];
  /** あなたの季節 */
  season: Scalars['String'];
  /** 全体の状況 */
  totalCondition: Scalars['String'];
  /** あなたの二十四節気 */
  twentyFourSolarTerms: Scalars['String'];
};

export type OmikujiWhereUniqueInput = {
  id: Scalars['ID'];
};

export type OnetimePasswordStatus = {
  __typename?: 'OnetimePasswordStatus';
  isValid: Scalars['Boolean'];
};

export enum OnsetTiming {
  DontRemember = 'DONT_REMEMBER',
  MoreThanAYear = 'MORE_THAN_A_YEAR',
  ThreeDaysAgo = 'THREE_DAYS_AGO',
  TwoDaysAgo = 'TWO_DAYS_AGO',
  WithinAMonth = 'WITHIN_A_MONTH',
  WithinAWeek = 'WITHIN_A_WEEK',
  WithinAYear = 'WITHIN_A_YEAR',
  WithinSixMonth = 'WITHIN_SIX_MONTH',
  WithinThreeMonth = 'WITHIN_THREE_MONTH',
  Yesterday = 'YESTERDAY'
}

export type Participant = {
  __typename?: 'Participant';
  name: Scalars['String'];
  participantId: Scalars['ID'];
  room: Room;
  roomId: Scalars['ID'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card: PaymentMethodCard;
  id: Scalars['ID'];
};

export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  brand: Scalars['String'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  last4: Scalars['String'];
};

export enum Personality {
  Both = 'BOTH',
  Indoor = 'INDOOR',
  Outdoor = 'OUTDOOR'
}

export enum Pregnancy {
  No = 'NO',
  Possible = 'POSSIBLE',
  Yes = 'YES'
}

export enum Pulse {
  Floating = 'FLOATING',
  Normal = 'NORMAL',
  Sinking = 'SINKING'
}

export type Query = {
  __typename?: 'Query';
  checklistByDate: Checklist;
  checklistByMonth: Checklist;
  dashboardScores: Array<DashboardScore>;
  department: Department;
  departmentByInvitationCode?: Maybe<Department>;
  departments: Array<Department>;
  ecoChecklistByDate: EcoChecklist;
  ecoChecklistByMonth: EcoChecklist;
  ecoChecklistScoreByMonth: EcoChecklistTotalScore;
  engagementChecklist: EngagementChecklist;
  engagementChecklistScore: EngagementChecklistTotalScore;
  exercise: Exercise;
  exerciseGroup: ExerciseGroup;
  exerciseGroups: Array<ExerciseGroup>;
  exercises: Array<Exercise>;
  food: Food;
  foods: Array<Food>;
  generateLicenseYojyoTestContentsSignedUrl: Scalars['String'];
  generateYojyoVideoContentSignedUrl: SignedUrl;
  invoiceStatus: Array<UsersOnInvoiceStatus>;
  kokokara: Kokokara;
  kokokaraForShort: Kokokara;
  licenseTest: LicenseTest;
  licenseYojyoTestContent: LicenseTestContent;
  licenseYojyoTestContents: Array<LicenseTestContent>;
  licenseYojyoTests: Array<LicenseTest>;
  lifestyleByDate: Lifestyle;
  lifestyleScoreByDate: Score;
  lifestylesByUserId: Array<Lifestyle>;
  managerMe: ManagerMe;
  me: Me;
  nutrient: Nutrient;
  nutrients: Array<Nutrient>;
  okotoba: Okotoba;
  okotobaForShort: Okotoba;
  omikuji: Omikuji;
  omikujis: Array<Omikuji>;
  paymentMethods: Array<PaymentMethod>;
  randomOmikuji: Omikuji;
  room: Room;
  rooms: Array<Room>;
  snack: Snack;
  snacks: Array<Snack>;
  treatment: Treatment;
  treatments: Array<Treatment>;
  user: User;
  userWithLatestKokokara: UserWithKokokara;
  users: Array<User>;
  usersWithLatestKokokara: Array<UserWithKokokara>;
  yojyoVideoContent: YojyoVideoContent;
  yojyoVideoContentCategories: Array<YojyoVideoContentCategory>;
  yojyomail: Yojyomail;
  yojyomailForShort: Yojyomail;
};


export type QueryChecklistByDateArgs = {
  where: ChecklistWhereDateUniqueInput;
};


export type QueryChecklistByMonthArgs = {
  where: ChecklistWhereDateUniqueInput;
};


export type QueryDepartmentArgs = {
  where: FindDepartmentWhereInput;
};


export type QueryDepartmentByInvitationCodeArgs = {
  where: FindDepartmentByInvitationCodeWhereInput;
};


export type QueryEcoChecklistByDateArgs = {
  where: EcoChecklistWhereDateUniqueInput;
};


export type QueryEcoChecklistByMonthArgs = {
  where: EcoChecklistWhereDateUniqueInput;
};


export type QueryEcoChecklistScoreByMonthArgs = {
  where: EcoChecklistWhereUniqueInput;
};


export type QueryEngagementChecklistArgs = {
  where: EngagementChecklistWhereDateUniqueInput;
};


export type QueryEngagementChecklistScoreArgs = {
  where: EngagementChecklistWhereUniqueInput;
};


export type QueryExerciseArgs = {
  where: ExerciseWhereUniqueInput;
};


export type QueryExerciseGroupArgs = {
  where: ExerciseGroupWhereUniqueInput;
};


export type QueryFoodArgs = {
  where: FoodWhereUniqueInput;
};


export type QueryGenerateLicenseYojyoTestContentsSignedUrlArgs = {
  id: Scalars['String'];
};


export type QueryGenerateYojyoVideoContentSignedUrlArgs = {
  id: Scalars['String'];
};


export type QueryKokokaraArgs = {
  where: ChecklistWhereUniqueInput;
};


export type QueryKokokaraForShortArgs = {
  where: ChecklistWhereUniqueInput;
};


export type QueryLicenseTestArgs = {
  where: LicenseTestUniqueInput;
};


export type QueryLicenseYojyoTestContentArgs = {
  id: Scalars['String'];
};


export type QueryLicenseYojyoTestContentsArgs = {
  licenseType: Scalars['String'];
};


export type QueryLicenseYojyoTestsArgs = {
  where: LicenseTestWhereInput;
};


export type QueryLifestyleByDateArgs = {
  where: LifestyleWhereDateUniqueInput;
};


export type QueryLifestyleScoreByDateArgs = {
  where: LifestyleWhereDateUniqueInput;
};


export type QueryLifestylesByUserIdArgs = {
  where: LifestyleByUserIdWhereUniqueInput;
};


export type QueryNutrientArgs = {
  where: NutrientWhereUniqueInput;
};


export type QueryOmikujiArgs = {
  where: OmikujiWhereUniqueInput;
};


export type QueryRoomArgs = {
  where: RoomWhereUniqueInput;
};


export type QuerySnackArgs = {
  where: SnackWhereUniqueInput;
};


export type QueryTreatmentArgs = {
  where: TreatmentWhereUniqueInput;
};


export type QueryTreatmentsArgs = {
  where?: InputMaybe<TreatmentPatientWhereInput>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUserWithLatestKokokaraArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersWithLatestKokokaraArgs = {
  orderBy?: InputMaybe<UsersWithLatestKokokaraOrderByInput>;
  where?: InputMaybe<UsersWithLatestKokokaraWhereInput>;
};


export type QueryYojyoVideoContentArgs = {
  id: Scalars['ID'];
};

export enum RedFlag {
  ContinueDeterioratingMoreThanThreeDays = 'CONTINUE_DETERIORATING_MORE_THAN_THREE_DAYS',
  Dysuria = 'DYSURIA',
  MuscleMassReduction = 'MUSCLE_MASS_REDUCTION',
  Others = 'OTHERS',
  ViolentPain = 'VIOLENT_PAIN'
}

export type ResetPasswordInput = {
  onetimePassword: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
};

export type ResetPasswordStatus = {
  __typename?: 'ResetPasswordStatus';
  hasRequested: Scalars['Boolean'];
  id: Scalars['String'];
};

export type Room = {
  __typename?: 'Room';
  id: Scalars['ID'];
  lastMessageBody?: Maybe<Scalars['String']>;
  lastMessageSentAt?: Maybe<Scalars['DateTime']>;
  messages: Array<Message>;
  name: Scalars['String'];
  participants: Array<Participant>;
};

export type RoomWhereUniqueInput = {
  id: Scalars['ID'];
};

export type Score = {
  __typename?: 'Score';
  scores: Array<LifestyleScore>;
  totalScore: Scalars['Int'];
};

export type SetupIntentResult = {
  __typename?: 'SetupIntentResult';
  clientSecret: Scalars['String'];
};

export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type SignedUrl = {
  __typename?: 'SignedUrl';
  url: Scalars['String'];
};

export enum SleepDisruption {
  Once = 'ONCE',
  Overthree = 'OVERTHREE',
  Twice = 'TWICE'
}

export enum SleepQuality {
  Bad = 'BAD',
  Good = 'GOOD',
  Normal = 'NORMAL'
}

export type Snack = {
  __typename?: 'Snack';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  meals: Array<SnacksOnMeals>;
  /** 間食品目名 */
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SnackWhereUniqueInput = {
  id: Scalars['ID'];
};

export type SnacksOnMeals = {
  __typename?: 'SnacksOnMeals';
  meal: Meal;
  mealId: Scalars['ID'];
  snack: Snack;
  snackId: Scalars['ID'];
};

export enum SpinalCurvature {
  Cervicalspine = 'CERVICALSPINE',
  Lumbarspine = 'LUMBARSPINE',
  Normal = 'NORMAL',
  Thoracicspine = 'THORACICSPINE'
}

export enum StoolCondition {
  Good = 'GOOD',
  Hard = 'HARD',
  Normal = 'NORMAL',
  Soft = 'SOFT'
}

export enum Symptom {
  BreathingProblemsCough = 'BREATHING_PROBLEMS_COUGH',
  BreathingProblemsDifficultyBreathing = 'BREATHING_PROBLEMS_DIFFICULTY_BREATHING',
  BreathingProblemsThroatDiscomfort = 'BREATHING_PROBLEMS_THROAT_DISCOMFORT',
  EarProblemsDifficultyHearing = 'EAR_PROBLEMS_DIFFICULTY_HEARING',
  EarProblemsHearingProblems = 'EAR_PROBLEMS_HEARING_PROBLEMS',
  FemaleProblemsAbnormalHemorrhage = 'FEMALE_PROBLEMS_ABNORMAL_HEMORRHAGE',
  FemaleProblemsBreastSymptoms = 'FEMALE_PROBLEMS_BREAST_SYMPTOMS',
  FemaleProblemsMissedPeriods = 'FEMALE_PROBLEMS_MISSED_PERIODS',
  FemaleProblemsVaginaSymptoms = 'FEMALE_PROBLEMS_VAGINA_SYMPTOMS',
  MainProblemsConstipation = 'MAIN_PROBLEMS_CONSTIPATION',
  MainProblemsDizziness = 'MAIN_PROBLEMS_DIZZINESS',
  MainProblemsFatigue = 'MAIN_PROBLEMS_FATIGUE',
  MainProblemsInsomnia = 'MAIN_PROBLEMS_INSOMNIA',
  MainProblemsNumbnessDiscomfort = 'MAIN_PROBLEMS_NUMBNESS_DISCOMFORT',
  MainProblemsPain = 'MAIN_PROBLEMS_PAIN',
  MoodProblemsAnxiety = 'MOOD_PROBLEMS_ANXIETY',
  MovementProblemsDifficultyWalking = 'MOVEMENT_PROBLEMS_DIFFICULTY_WALKING',
  MovementProblemsTremors = 'MOVEMENT_PROBLEMS_TREMORS',
  OtherProblemsAnxietyDepression = 'OTHER_PROBLEMS_ANXIETY_DEPRESSION',
  OtherProblemsBloodySalivaAndSputum = 'OTHER_PROBLEMS_BLOODY_SALIVA_AND_SPUTUM',
  OtherProblemsDiarrheaConstipation = 'OTHER_PROBLEMS_DIARRHEA_CONSTIPATION',
  OtherProblemsDifficultyMoving = 'OTHER_PROBLEMS_DIFFICULTY_MOVING',
  OtherProblemsDifficultySwallowing = 'OTHER_PROBLEMS_DIFFICULTY_SWALLOWING',
  OtherProblemsDiscomfort = 'OTHER_PROBLEMS_DISCOMFORT',
  OtherProblemsFeelingWeek = 'OTHER_PROBLEMS_FEELING_WEEK',
  OtherProblemsFever = 'OTHER_PROBLEMS_FEVER',
  OtherProblemsForgetfulnessBadMemories = 'OTHER_PROBLEMS_FORGETFULNESS_BAD_MEMORIES',
  OtherProblemsFrequentHairLoss = 'OTHER_PROBLEMS_FREQUENT_HAIR_LOSS',
  OtherProblemsFrequentNightSweats = 'OTHER_PROBLEMS_FREQUENT_NIGHT_SWEATS',
  OtherProblemsNauseaVomiting = 'OTHER_PROBLEMS_NAUSEA_VOMITING',
  OtherProblemsNumbness = 'OTHER_PROBLEMS_NUMBNESS',
  OtherProblemsOther = 'OTHER_PROBLEMS_OTHER',
  OtherProblemsPalpitation = 'OTHER_PROBLEMS_PALPITATION',
  OtherProblemsSwelling = 'OTHER_PROBLEMS_SWELLING',
  OtherProblemsVomiting = 'OTHER_PROBLEMS_VOMITING',
  SkinProblemsItch = 'SKIN_PROBLEMS_ITCH',
  SkinProblemsSkinBoils = 'SKIN_PROBLEMS_SKIN_BOILS',
  StomachProblemsDiarrhea = 'STOMACH_PROBLEMS_DIARRHEA',
  StomachProblemsHeartburnFlarulence = 'STOMACH_PROBLEMS_HEARTBURN_FLARULENCE',
  UrinaryProblemsHematuria = 'URINARY_PROBLEMS_HEMATURIA',
  UrinaryProblemsUrinaryPain = 'URINARY_PROBLEMS_URINARY_PAIN',
  UrinaryProblemsUrineLeakage = 'URINARY_PROBLEMS_URINE_LEAKAGE'
}

export enum SymptomArea {
  AbleToPoint = 'ABLE_TO_POINT',
  ClearArea = 'CLEAR_AREA',
  Other = 'OTHER',
  UnclearArea = 'UNCLEAR_AREA'
}

export enum SymptomCause {
  Accident = 'ACCIDENT',
  Aging = 'AGING',
  Injury = 'INJURY',
  None = 'NONE',
  Others = 'OTHERS',
  Overwork = 'OVERWORK',
  Special = 'SPECIAL',
  Stress = 'STRESS'
}

export enum SymptomChange {
  Changed = 'CHANGED',
  OtherSymptomsOccur = 'OTHER_SYMPTOMS_OCCUR',
  Similar = 'SIMILAR'
}

export enum SymptomFeeling {
  Electric = 'ELECTRIC',
  Heavy = 'HEAVY',
  Other = 'OTHER',
  Piripiri = 'PIRIPIRI',
  Puffy = 'PUFFY',
  Tense = 'TENSE',
  Zukizuki = 'ZUKIZUKI'
}

export enum SymptomTiming {
  Always = 'ALWAYS',
  BeforeAndAfterEating = 'BEFORE_AND_AFTER_EATING',
  Other = 'OTHER',
  RegardlessOfMovement = 'REGARDLESS_OF_MOVEMENT',
  RelateToMood = 'RELATE_TO_MOOD',
  WhenStartMoving = 'WHEN_START_MOVING',
  WhileMoving = 'WHILE_MOVING'
}

export enum TenderPoint {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export enum TestLevel1 {
  ChangingWithMood = 'CHANGING_WITH_MOOD',
  Other = 'OTHER',
  SameSymptomOnLeftRight = 'SAME_SYMPTOM_ON_LEFT_RIGHT'
}

export enum TherapeuticEffectTiming {
  ADay = 'A_DAY',
  AFewDays = 'A_FEW_DAYS',
  AWeek = 'A_WEEK',
  MoreThanAWeek = 'MORE_THAN_A_WEEK'
}

export type TherapeuticPoint = {
  __typename?: 'TherapeuticPoint';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  nameFurigana: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum TongueCoating {
  None = 'NONE',
  Whitethickmoss = 'WHITETHICKMOSS',
  Whitethinmoss = 'WHITETHINMOSS',
  Yellowthickmoss = 'YELLOWTHICKMOSS',
  Yellowthinmoss = 'YELLOWTHINMOSS'
}

export enum TongueColor {
  Deepred = 'DEEPRED',
  Lightwhite = 'LIGHTWHITE',
  Normal = 'NORMAL',
  Purple = 'PURPLE',
  White = 'WHITE'
}

export enum TongueShape {
  Greattongue = 'GREATTONGUE',
  Normal = 'NORMAL',
  Oldtongue = 'OLDTONGUE',
  Skinnytongue = 'SKINNYTONGUE',
  Toothmark = 'TOOTHMARK'
}

export type Treatment = {
  __typename?: 'Treatment';
  /** 鍼灸治療の詳細 */
  acupunctureTreatmentMemo?: Maybe<Scalars['String']>;
  /** タバコ習慣の詳細 */
  alcoholHabitMemo?: Maybe<Scalars['String']>;
  /** 抗重力筋の圧痛1_大胸筋（中府） */
  antiG1GreaterPectoralMuscle?: Maybe<Array<TenderPoint>>;
  /** 抗重力筋の圧痛1_胸鎖乳突筋 */
  antiG1SternocleidomastoidMuscle?: Maybe<Array<TenderPoint>>;
  /** 抗重力筋の圧痛1_僧帽筋（肩井） */
  antiG1TrapeziusMuscle?: Maybe<Array<TenderPoint>>;
  /** 抗重力筋の圧痛2_腓腹筋（委中） */
  antiG2Gastrocnemius?: Maybe<Array<TenderPoint>>;
  /** 抗重力筋の圧痛2_ハムストリングス */
  antiG2Hamstring?: Maybe<Array<TenderPoint>>;
  /** 抗重力筋の圧痛2_腸腰筋（環跳） */
  antiG2Iliopsoas?: Maybe<Array<TenderPoint>>;
  /** 食欲 */
  appetite?: Maybe<Scalars['Int']>;
  /** 便通 */
  bowelMovement?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  /** 現病歴の詳細 */
  currentMedicalHistory?: Maybe<Scalars['String']>;
  /** チアノーゼ */
  cyanosis?: Maybe<Cyanosis>;
  diagnoses?: Maybe<Array<Diagnose>>;
  /** 予約時間（終了） */
  endTime: Scalars['DateTime'];
  /** 運動習慣の頻度 */
  exerciseHabitFrequency?: Maybe<HabitFrequency>;
  /** 家族歴の詳細 */
  familyMedicalHistory?: Maybe<Array<MedicalHistory>>;
  /** 鍼灸治療の有無 */
  hasAcupunctureTreatment?: Maybe<Scalars['Boolean']>;
  /** 飲酒習慣の有無 */
  hasAlcoholHabit?: Maybe<HasHabit>;
  /** 現病歴の有無 */
  hasCurrentMedicalHistory?: Maybe<Scalars['Boolean']>;
  /** 運動習慣の有無 */
  hasExerciseHabit?: Maybe<Scalars['Boolean']>;
  /** 家族歴の有無 */
  hasFamilyMedicalHistory?: Maybe<Scalars['Boolean']>;
  /** 病院受診の有無 */
  hasHospitalVisit?: Maybe<Scalars['Boolean']>;
  /** 服薬の有無 */
  hasMedication?: Maybe<Scalars['Boolean']>;
  /** 既往歴の有無 */
  hasPastMedicalHistory?: Maybe<Scalars['Boolean']>;
  /** 症状の有無 */
  hasSymptom?: Maybe<Scalars['Boolean']>;
  /** タバコ習慣の有無 */
  hasTabaccoHabit?: Maybe<HasHabit>;
  /** 健康行動の頻度 */
  healthHabitFrequency?: Maybe<HabitFrequency>;
  /** 健康行動 */
  healthHabits?: Maybe<Array<HealthHabit>>;
  /** 病院受診の詳細 */
  hospitalVisitMemo?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** 編集中フラグ */
  isEditing: Scalars['Boolean'];
  /** 初診フラグ */
  isFirst: Scalars['Boolean'];
  /** レッドフラッグ */
  isRed?: Maybe<Scalars['Boolean']>;
  /** イエローフラッグ */
  isYellow?: Maybe<Scalars['Boolean']>;
  /** 服薬の詳細 */
  medicationMemo?: Maybe<Scalars['String']>;
  office?: Maybe<Office>;
  officeId: Scalars['ID'];
  /** 既往歴の詳細 */
  pastMedicalHistory?: Maybe<Array<MedicalHistory>>;
  patientId?: Maybe<Scalars['ID']>;
  /** 患者メモ */
  patientMemo?: Maybe<Scalars['String']>;
  /** 趣味嗜好 */
  personality?: Maybe<Personality>;
  /** 診察時の体調 */
  physicalCondition?: Maybe<Scalars['Int']>;
  /** 予診票入力時刻 */
  prefilledAt?: Maybe<Scalars['DateTime']>;
  /** 妊娠の有無、可能性 */
  pregnancy?: Maybe<Pregnancy>;
  /** 脈拍 */
  pulse?: Maybe<Pulse>;
  /** レッドフラッグ候補 */
  redFlags?: Maybe<Array<RedFlag>>;
  /** 診察番号 */
  reservationConsultationNumber?: Maybe<Scalars['Int']>;
  /** 予約名 */
  reservationName: Scalars['String'];
  /** 予約電話番号 */
  reservationPhone?: Maybe<Scalars['String']>;
  /** 予約進捗状況 */
  reservationProgress: Scalars['Int'];
  /** 施術満足度 */
  satisfaction?: Maybe<Scalars['Int']>;
  /** 頭皮 */
  scalp?: Maybe<Scalars['Int']>;
  /** 睡眠 */
  sleepLength?: Maybe<Scalars['Float']>;
  /** 原穴の反応（手の甲）_合谷 */
  sourcePointBackHandGoukoku?: Maybe<Array<TenderPoint>>;
  /** 原穴の反応（手の甲_腕骨 */
  sourcePointBackHandWankotsu?: Maybe<Array<TenderPoint>>;
  /** 原穴の反応（手の甲）_陽池 */
  sourcePointBackHandYouchi?: Maybe<Array<TenderPoint>>;
  /** 原穴の反応（足の内側・甲）_太白 */
  sourcePointInsideFootTaihaku?: Maybe<Array<TenderPoint>>;
  /** 原穴の反応（足の内側・甲）_太渓 */
  sourcePointInsideFootTaikei?: Maybe<Array<TenderPoint>>;
  /** 原穴の反応（足の内側・甲）_太衝 */
  sourcePointInsideFootTaishou?: Maybe<Array<TenderPoint>>;
  /** 原穴の反応（足の外側・甲）_京骨 */
  sourcePointOutsideFootKeikotsu?: Maybe<Array<TenderPoint>>;
  /** 原穴の反応（足の外側・甲）_丘墟 */
  sourcePointOutsideFootKyukyo?: Maybe<Array<TenderPoint>>;
  /** 原穴の反応（足の外側・甲）_衝陽 */
  sourcePointOutsideFootShouyou?: Maybe<Array<TenderPoint>>;
  /** 原穴の反応（手掌側）_大陵 */
  sourcePointPalmDairyou?: Maybe<Array<TenderPoint>>;
  /** 原穴の反応（手掌側）_神門 */
  sourcePointPalmShinmon?: Maybe<Array<TenderPoint>>;
  /** 原穴の反応（手掌側）_太淵 */
  sourcePointPalmTaien?: Maybe<Array<TenderPoint>>;
  /** 脊椎の湾曲 */
  spinalCurvature?: Maybe<SpinalCurvature>;
  /** 予約時間（開始） */
  startTime: Scalars['DateTime'];
  /** 症状の範囲候補 */
  symptomArea?: Maybe<SymptomArea>;
  /** 主訴の変化 */
  symptomChange?: Maybe<SymptomChange>;
  /** 症状の感じ候補 */
  symptomFeelings?: Maybe<Array<SymptomFeeling>>;
  /** 症状発症のタイミング候補 */
  symptomTimings?: Maybe<Array<SymptomTiming>>;
  /** タバコ習慣の詳細 */
  tabaccoHabitMemo?: Maybe<Scalars['String']>;
  /** 問診レベル1候補 */
  testLevel1s?: Maybe<Array<TestLevel1>>;
  /** 治療効果 */
  therapeuticEffect?: Maybe<Scalars['Int']>;
  /** 治療効果の詳細 */
  therapeuticEffectMemo?: Maybe<Scalars['String']>;
  /** 治療継続期間 */
  therapeuticEffectTiming?: Maybe<TherapeuticEffectTiming>;
  /** 舌苔 */
  tongueCoating?: Maybe<TongueCoating>;
  /** 舌の形 */
  tongueShape?: Maybe<TongueShape>;
  /** 同一症状の治療回数 */
  totalTreatmentCount: Scalars['Int'];
  /** 診察時刻 */
  treatedAt?: Maybe<Scalars['DateTime']>;
  treatmentMemo?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  /** 予測診断使用フラグ */
  usePredicate: Scalars['Boolean'];
  /** YomogiPro使用フラグ */
  useYomogiPro: Scalars['Boolean'];
  user?: Maybe<ComoUser>;
  userId: Scalars['ID'];
  /** 来院目的 */
  visitingPurpose?: Maybe<VisitingPurpose>;
  /** イエローフラッグ候補 */
  yellowFlags?: Maybe<Array<YellowFlag>>;
};

export type TreatmentPatientWhereInput = {
  id?: InputMaybe<Scalars['ID']>;
  isEditing?: InputMaybe<Scalars['Boolean']>;
  isRed?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['ID']>;
  timeFrom?: InputMaybe<Scalars['DateTime']>;
  timeTo?: InputMaybe<Scalars['DateTime']>;
};

export type TreatmentTherapeuticPoint = {
  __typename?: 'TreatmentTherapeuticPoint';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  therapeuticPoint?: Maybe<TherapeuticPoint>;
  therapeuticPointId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['DateTime'];
};

export type TreatmentWhereUniqueInput = {
  id: Scalars['ID'];
};

export type UpdateChecklistInput = {
  /** 怒りを感じる */
  angry?: InputMaybe<MentalStatus>;
  /** 腹立たしい気分だ */
  annoyingMood?: InputMaybe<MentalStatus>;
  /** 身体の硬さ */
  bodyStiff?: InputMaybe<BodyStiff>;
  /** ふくらはぎの太さ */
  calfThickness?: InputMaybe<CalfThickness>;
  /** 一つのことに集中することができない */
  concentrateOneThing?: InputMaybe<MentalStatus>;
  /** 勉強（仕事）が手に付かない */
  concentrateWork?: InputMaybe<MentalStatus>;
  /** しゃがみ込み */
  crouching?: InputMaybe<Crouching>;
  /** 泣きたい気分だ */
  cry?: InputMaybe<MentalStatus>;
  /** 心が暗い */
  depressed?: InputMaybe<MentalStatus>;
  /** 難しいことを考えることができない */
  difficultThinking?: InputMaybe<MentalStatus>;
  /** 身体がだるい */
  feelingHeavy?: InputMaybe<MentalStatus>;
  /** 頭が痛い */
  headache?: InputMaybe<MentalStatus>;
  holdBreathTime?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** よく眠れない */
  insomnia?: InputMaybe<MentalStatus>;
  /** いらいらする */
  irritated?: InputMaybe<MentalStatus>;
  /** 根気がない */
  lackPatience?: InputMaybe<MentalStatus>;
  loggedAt: Scalars['DateTime'];
  /** さみしい気持ちだ */
  lonely?: InputMaybe<MentalStatus>;
  oneFootTime?: InputMaybe<Scalars['Float']>;
  /** 誰かに怒りをぶつけたい */
  outburstAnger?: InputMaybe<MentalStatus>;
  pulse?: InputMaybe<Scalars['Float']>;
  /** 悲しい */
  sad?: InputMaybe<MentalStatus>;
  tandemTime?: InputMaybe<Scalars['Float']>;
  /** 疲れやすい */
  tiringEasily?: InputMaybe<MentalStatus>;
  /** 舌の色 */
  tongueColor?: InputMaybe<TongueColor>;
  userId: Scalars['ID'];
};

export type UpdateCompletedYojyoTestInput = {
  yojyoInstructorTestId?: InputMaybe<Scalars['ID']>;
  yojyoLicenseTestId?: InputMaybe<Scalars['ID']>;
};

export type UpdateDepartmentInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateEcoChecklistInput = {
  airConditionerUsage?: InputMaybe<Scalars['Float']>;
  daytimeExercise?: InputMaybe<Scalars['Float']>;
  domesticFood?: InputMaybe<Scalars['Float']>;
  eatingOutFood?: InputMaybe<Scalars['Float']>;
  electronicDeviceUsage?: InputMaybe<Scalars['Float']>;
  equipmentExercise?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  indoorHoliday?: InputMaybe<Scalars['Float']>;
  localFood?: InputMaybe<Scalars['Float']>;
  loggedAt: Scalars['DateTime'];
  outdoorExercise?: InputMaybe<Scalars['Float']>;
  publicTransportUsage?: InputMaybe<Scalars['Float']>;
  seasonalFood?: InputMaybe<Scalars['Float']>;
  userId: Scalars['ID'];
};

export type UpdateEngagementChecklistInput = {
  bat1?: InputMaybe<Scalars['Float']>;
  bat2?: InputMaybe<Scalars['Float']>;
  bat3?: InputMaybe<Scalars['Float']>;
  bat4?: InputMaybe<Scalars['Float']>;
  bat5?: InputMaybe<Scalars['Float']>;
  bat6?: InputMaybe<Scalars['Float']>;
  bat7?: InputMaybe<Scalars['Float']>;
  bat8?: InputMaybe<Scalars['Float']>;
  bat9?: InputMaybe<Scalars['Float']>;
  bat10?: InputMaybe<Scalars['Float']>;
  bat11?: InputMaybe<Scalars['Float']>;
  bat12?: InputMaybe<Scalars['Float']>;
  bat13?: InputMaybe<Scalars['Float']>;
  bat14?: InputMaybe<Scalars['Float']>;
  bat15?: InputMaybe<Scalars['Float']>;
  bat16?: InputMaybe<Scalars['Float']>;
  bat17?: InputMaybe<Scalars['Float']>;
  bat18?: InputMaybe<Scalars['Float']>;
  bat19?: InputMaybe<Scalars['Float']>;
  bat20?: InputMaybe<Scalars['Float']>;
  bat21?: InputMaybe<Scalars['Float']>;
  bat22?: InputMaybe<Scalars['Float']>;
  bat23?: InputMaybe<Scalars['Float']>;
  bat24?: InputMaybe<Scalars['Float']>;
  bat25?: InputMaybe<Scalars['Float']>;
  bat26?: InputMaybe<Scalars['Float']>;
  bat27?: InputMaybe<Scalars['Float']>;
  bat28?: InputMaybe<Scalars['Float']>;
  bat29?: InputMaybe<Scalars['Float']>;
  bat30?: InputMaybe<Scalars['Float']>;
  bat31?: InputMaybe<Scalars['Float']>;
  bat32?: InputMaybe<Scalars['Float']>;
  bat33?: InputMaybe<Scalars['Float']>;
  fssb1?: InputMaybe<Scalars['Float']>;
  fssb2?: InputMaybe<Scalars['Float']>;
  fssb3?: InputMaybe<Scalars['Float']>;
  fssb4?: InputMaybe<Scalars['Float']>;
  fssb5?: InputMaybe<Scalars['Float']>;
  fssb6?: InputMaybe<Scalars['Float']>;
  fssb7?: InputMaybe<Scalars['Float']>;
  fssb8?: InputMaybe<Scalars['Float']>;
  fssb9?: InputMaybe<Scalars['Float']>;
  fssb10?: InputMaybe<Scalars['Float']>;
  fssb11?: InputMaybe<Scalars['Float']>;
  fssb12?: InputMaybe<Scalars['Float']>;
  fssb13?: InputMaybe<Scalars['Float']>;
  fssb14?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  loggedAt: Scalars['DateTime'];
  mos1?: InputMaybe<Scalars['Float']>;
  mos2?: InputMaybe<Scalars['Float']>;
  mos3?: InputMaybe<Scalars['Float']>;
  mos4?: InputMaybe<Scalars['Float']>;
  mos5?: InputMaybe<Scalars['Float']>;
  mos6?: InputMaybe<Scalars['Float']>;
  mos7?: InputMaybe<Scalars['Float']>;
  mos8?: InputMaybe<Scalars['Float']>;
  mos9?: InputMaybe<Scalars['Float']>;
  mos10?: InputMaybe<Scalars['Float']>;
  mos11?: InputMaybe<Scalars['Float']>;
  mos12?: InputMaybe<Scalars['Float']>;
  mos13?: InputMaybe<Scalars['Float']>;
  mos14?: InputMaybe<Scalars['Float']>;
  mos15?: InputMaybe<Scalars['Float']>;
  mos16?: InputMaybe<Scalars['Float']>;
  mos17?: InputMaybe<Scalars['Float']>;
  mos18?: InputMaybe<Scalars['Float']>;
  mos19?: InputMaybe<Scalars['Float']>;
  mos20?: InputMaybe<Scalars['Float']>;
  mos21?: InputMaybe<Scalars['Float']>;
  mos22?: InputMaybe<Scalars['Float']>;
  mos23?: InputMaybe<Scalars['Float']>;
  mos24?: InputMaybe<Scalars['Float']>;
  mos25?: InputMaybe<Scalars['Float']>;
  mos26?: InputMaybe<Scalars['Float']>;
  mos27?: InputMaybe<Scalars['Float']>;
  mos28?: InputMaybe<Scalars['Float']>;
  mos29?: InputMaybe<Scalars['Float']>;
  mos30?: InputMaybe<Scalars['Float']>;
  mos31?: InputMaybe<Scalars['Float']>;
  mos32?: InputMaybe<Scalars['Float']>;
  mos33?: InputMaybe<Scalars['Float']>;
  mos34?: InputMaybe<Scalars['Float']>;
  mos35?: InputMaybe<Scalars['Float']>;
  mos36?: InputMaybe<Scalars['Float']>;
  mos37?: InputMaybe<Scalars['Float']>;
  mos38?: InputMaybe<Scalars['Float']>;
  mos39?: InputMaybe<Scalars['Float']>;
  mos40?: InputMaybe<Scalars['Float']>;
  mos41?: InputMaybe<Scalars['Float']>;
  mos42?: InputMaybe<Scalars['Float']>;
  mos43?: InputMaybe<Scalars['Float']>;
  mos44?: InputMaybe<Scalars['Float']>;
  mos45?: InputMaybe<Scalars['Float']>;
  mos46?: InputMaybe<Scalars['Float']>;
  mos47?: InputMaybe<Scalars['Float']>;
  mos48?: InputMaybe<Scalars['Float']>;
  mos49?: InputMaybe<Scalars['Float']>;
  mos50?: InputMaybe<Scalars['Float']>;
  mos51?: InputMaybe<Scalars['Float']>;
  req1?: InputMaybe<Scalars['Float']>;
  req2?: InputMaybe<Scalars['Float']>;
  req3?: InputMaybe<Scalars['Float']>;
  req4?: InputMaybe<Scalars['Float']>;
  req5?: InputMaybe<Scalars['Float']>;
  req6?: InputMaybe<Scalars['Float']>;
  req7?: InputMaybe<Scalars['Float']>;
  req8?: InputMaybe<Scalars['Float']>;
  req9?: InputMaybe<Scalars['Float']>;
  req10?: InputMaybe<Scalars['Float']>;
  req11?: InputMaybe<Scalars['Float']>;
  req12?: InputMaybe<Scalars['Float']>;
  req13?: InputMaybe<Scalars['Float']>;
  req14?: InputMaybe<Scalars['Float']>;
  req15?: InputMaybe<Scalars['Float']>;
  req16?: InputMaybe<Scalars['Float']>;
  userId: Scalars['ID'];
  uwes1?: InputMaybe<Scalars['Float']>;
  uwes2?: InputMaybe<Scalars['Float']>;
  uwes3?: InputMaybe<Scalars['Float']>;
  workSpace1?: InputMaybe<Scalars['Float']>;
  workSpace2?: InputMaybe<Scalars['Float']>;
};

export type UpdateLifestyleInput = {
  bedtime?: InputMaybe<Scalars['DateTime']>;
  dream?: InputMaybe<Scalars['Boolean']>;
  duringMenstruation?: InputMaybe<Scalars['Boolean']>;
  exercisesOnLifestyles: Array<UpsertExercisesOnLifestylesInput>;
  fatigue?: InputMaybe<Scalars['Float']>;
  feeling?: InputMaybe<Scalars['Float']>;
  healthStatus?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lifestyleMemo?: InputMaybe<Scalars['String']>;
  meals: Array<UpsertMealInput>;
  menstruationCondition?: InputMaybe<MenstruationCondition>;
  sleepDisruption?: InputMaybe<SleepDisruption>;
  sleepQuality?: InputMaybe<SleepQuality>;
  stoolCondition?: InputMaybe<StoolCondition>;
  symptom?: InputMaybe<Symptom>;
  symptomMemo?: InputMaybe<Scalars['String']>;
  symptomOnset?: InputMaybe<Scalars['Boolean']>;
  wakeupTime?: InputMaybe<Scalars['DateTime']>;
  weight?: InputMaybe<Scalars['String']>;
};

export type UpdateManagerInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  address?: InputMaybe<Scalars['String']>;
  birth?: InputMaybe<Scalars['DateTime']>;
  bodyDisorder?: InputMaybe<BodyDisorder>;
  currentDisease?: InputMaybe<CurrentDisease>;
  healthGoal?: InputMaybe<HealthGoal>;
  height?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  nameFurigana?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Sex>;
  usingPurpose?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['String']>;
};

export type UpdateYojyoTestNumberInput = {
  licenseType: LicenseType;
};

export type UpsertExercisesOnLifestylesInput = {
  exerciseAmount: Scalars['Int'];
  exerciseId: Scalars['ID'];
};

export type UpsertFoodsOnMealsInput = {
  foodId: Scalars['ID'];
};

export type UpsertMealInput = {
  foodsOnMeals: Array<UpsertFoodsOnMealsInput>;
  id: Scalars['ID'];
  mealTiming: MealTiming;
  nutrientsOnMeals: Array<UpsertNutrientsOnMealsInput>;
  snacksOnMeals: Array<UpsertSnacksOnMealsInput>;
};

export type UpsertNutrientsOnMealsInput = {
  nutrientId: Scalars['ID'];
  nutrientIntake: NutrientIntake;
};

export type UpsertSnacksOnMealsInput = {
  snackId: Scalars['ID'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Scalars['String']>;
  birth?: Maybe<Scalars['DateTime']>;
  bodyDisorder?: Maybe<BodyDisorder>;
  checklists: Array<Checklist>;
  comoId?: Maybe<Scalars['String']>;
  completedYojyoInstructorTestIds?: Maybe<Array<Scalars['String']>>;
  completedYojyoLicenseTestIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['DateTime'];
  currentDisease?: Maybe<CurrentDisease>;
  departments: Array<DepartmentsOnUsers>;
  ecoChecklists: Array<EcoChecklist>;
  hadYojyoInstructorTestAt?: Maybe<Scalars['DateTime']>;
  hadYojyoLicenseTestAt?: Maybe<Scalars['DateTime']>;
  healthGoal?: Maybe<HealthGoal>;
  height?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isOnetimePasswordChecked: Scalars['Boolean'];
  lifestyles: Array<Lifestyle>;
  loginedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nameFurigana?: Maybe<Scalars['String']>;
  onetimePassword?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  sex?: Maybe<Sex>;
  updatedAt: Scalars['DateTime'];
  usingPurpose?: Maybe<UsingPurpose>;
  weight?: Maybe<Scalars['String']>;
  yojyoInstructorTestNumber?: Maybe<Scalars['String']>;
  yojyoLicenseTestNumber?: Maybe<Scalars['String']>;
};

export type UserWhereUniqueInput = {
  id: Scalars['ID'];
};

export type UserWithKokokara = {
  __typename?: 'UserWithKokokara';
  address?: Maybe<Scalars['String']>;
  birth?: Maybe<Scalars['DateTime']>;
  bodyDisorder?: Maybe<BodyDisorder>;
  checklists: Array<Checklist>;
  comoId?: Maybe<Scalars['String']>;
  completedYojyoInstructorTestIds?: Maybe<Array<Scalars['String']>>;
  completedYojyoLicenseTestIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['DateTime'];
  currentDisease?: Maybe<CurrentDisease>;
  departments: Array<DepartmentsOnUsers>;
  ecoChecklists: Array<EcoChecklist>;
  hadYojyoInstructorTestAt?: Maybe<Scalars['DateTime']>;
  hadYojyoLicenseTestAt?: Maybe<Scalars['DateTime']>;
  healthGoal?: Maybe<HealthGoal>;
  height?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isOnetimePasswordChecked: Scalars['Boolean'];
  kokokara?: Maybe<Kokokara>;
  lifestyles: Array<Lifestyle>;
  loginedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nameFurigana?: Maybe<Scalars['String']>;
  onetimePassword?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  phone: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  sex?: Maybe<Sex>;
  updatedAt: Scalars['DateTime'];
  usingPurpose?: Maybe<UsingPurpose>;
  weight?: Maybe<Scalars['String']>;
  yojyoInstructorTestNumber?: Maybe<Scalars['String']>;
  yojyoLicenseTestNumber?: Maybe<Scalars['String']>;
};

export type UsersOnInvoiceStatus = {
  __typename?: 'UsersOnInvoiceStatus';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  invoiceId: Scalars['String'];
  priceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['ID']>;
  yomogiId?: Maybe<Scalars['String']>;
};

export type UsersWithLatestKokokaraOrderByInput = {
  birth?: InputMaybe<Scalars['String']>;
  checklistsCreatedAt?: InputMaybe<Scalars['String']>;
  departmentName?: InputMaybe<Scalars['String']>;
  kokokaraCharacteristicL?: InputMaybe<Scalars['String']>;
  kokokaraTotalScore?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UsersWithLatestKokokaraWhereInput = {
  birth?: InputMaybe<Scalars['DateTime']>;
  checklistsCreatedAt?: InputMaybe<Scalars['DateTime']>;
  departmentName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  kokokaraCharacteristicL?: InputMaybe<Scalars['Float']>;
  kokokaraTotalScore?: InputMaybe<Scalars['Float']>;
  managerId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum UsingPurpose {
  Maintenance = 'MAINTENANCE',
  Management = 'MANAGEMENT',
  Recovery = 'RECOVERY'
}

export enum VisitingPurpose {
  HealthManagement = 'HEALTH_MANAGEMENT',
  Others = 'OTHERS',
  Therapy = 'THERAPY'
}

export enum YellowFlag {
  AnxietyAlways = 'ANXIETY_ALWAYS',
  DepressedAlways = 'DEPRESSED_ALWAYS',
  IrregularWorktime = 'IRREGULAR_WORKTIME',
  NecessityForRest = 'NECESSITY_FOR_REST',
  NoMovement = 'NO_MOVEMENT',
  Others = 'OTHERS',
  RestrictingBehaviorForIllness = 'RESTRICTING_BEHAVIOR_FOR_ILLNESS',
  RestTillFullRecovery = 'REST_TILL_FULL_RECOVERY',
  WorkHard = 'WORK_HARD'
}

export type YojyoVideoContent = {
  __typename?: 'YojyoVideoContent';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  file: Scalars['String'];
  id: Scalars['ID'];
  thumbnail: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  yojyoVideoContentCategory?: Maybe<YojyoVideoContentCategory>;
  yojyoVideoContentCategoryId: Scalars['String'];
};

export type YojyoVideoContentCategory = {
  __typename?: 'YojyoVideoContentCategory';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  yojyoVideoContents?: Maybe<Array<YojyoVideoContent>>;
};

export type Yojyomail = {
  __typename?: 'Yojyomail';
  ageRange: AgeRange;
  characteristicL: YomogiProCharacteristicL;
  content: Scalars['String'];
  eyecatch: MicroCmsImage;
  hashtags: Array<Hashtag>;
  id: Scalars['ID'];
  month: Scalars['Float'];
  title: Scalars['String'];
};

export enum YomogiProCharacteristicL {
  Accel = 'ACCEL',
  Engine = 'ENGINE',
  Gasoline = 'GASOLINE'
}

export enum YomogiProCharacteristicS {
  Balance = 'BALANCE',
  Lowerlimbs = 'LOWERLIMBS',
  Muscle = 'MUSCLE',
  Nutrition = 'NUTRITION',
  Rhythm = 'RHYTHM',
  Scalp = 'SCALP',
  Strength = 'STRENGTH',
  Upperlimbs = 'UPPERLIMBS',
  Vital = 'VITAL'
}

export type YomogiProScore = {
  __typename?: 'YomogiProScore';
  characteristicL: YomogiProCharacteristicL;
  characteristicS: YomogiProCharacteristicS;
  data: Scalars['Int'];
  label: Scalars['String'];
};

export type ChecklistCoreFragment = { __typename?: 'Checklist', id: string, createdAt: any, updatedAt: any, loggedAt: any, tandemTime?: number | null, bodyStiff?: BodyStiff | null, crouching?: Crouching | null, oneFootTime?: number | null, calfThickness?: CalfThickness | null, pulse?: number | null, tongueColor?: TongueColor | null, holdBreathTime?: number | null, irritated?: MentalStatus | null, angry?: MentalStatus | null, annoyingMood?: MentalStatus | null, outburstAnger?: MentalStatus | null, tiringEasily?: MentalStatus | null, feelingHeavy?: MentalStatus | null, insomnia?: MentalStatus | null, headache?: MentalStatus | null, sad?: MentalStatus | null, lonely?: MentalStatus | null, cry?: MentalStatus | null, depressed?: MentalStatus | null, concentrateWork?: MentalStatus | null, concentrateOneThing?: MentalStatus | null, lackPatience?: MentalStatus | null, difficultThinking?: MentalStatus | null, userId: string, user: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, phone: string, password: string } };

export type ChecklistUpdateFragment = { __typename?: 'Checklist', id: string, loggedAt: any, userId: string, tandemTime?: number | null, bodyStiff?: BodyStiff | null, crouching?: Crouching | null, oneFootTime?: number | null, calfThickness?: CalfThickness | null, pulse?: number | null, tongueColor?: TongueColor | null, holdBreathTime?: number | null, irritated?: MentalStatus | null, angry?: MentalStatus | null, annoyingMood?: MentalStatus | null, outburstAnger?: MentalStatus | null, tiringEasily?: MentalStatus | null, feelingHeavy?: MentalStatus | null, insomnia?: MentalStatus | null, headache?: MentalStatus | null, sad?: MentalStatus | null, lonely?: MentalStatus | null, cry?: MentalStatus | null, depressed?: MentalStatus | null, concentrateWork?: MentalStatus | null, concentrateOneThing?: MentalStatus | null, lackPatience?: MentalStatus | null, difficultThinking?: MentalStatus | null };

export type DepartmentCoreFragment = { __typename?: 'Department', id: string, name: string };

export type EcoChecklistCoreFragment = { __typename?: 'EcoChecklist', id: string, createdAt: any, updatedAt: any, loggedAt: any, seasonalFood?: number | null, domesticFood?: number | null, localFood?: number | null, eatingOutFood?: number | null, outdoorExercise?: number | null, equipmentExercise?: number | null, daytimeExercise?: number | null, publicTransportUsage?: number | null, electronicDeviceUsage?: number | null, airConditionerUsage?: number | null, indoorHoliday?: number | null, userId: string, user: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, phone: string, password: string } };

export type EcoChecklistUpdateFragment = { __typename?: 'EcoChecklist', id: string, loggedAt: any, userId: string, seasonalFood?: number | null, domesticFood?: number | null, localFood?: number | null, eatingOutFood?: number | null, outdoorExercise?: number | null, equipmentExercise?: number | null, daytimeExercise?: number | null, publicTransportUsage?: number | null, electronicDeviceUsage?: number | null, airConditionerUsage?: number | null, indoorHoliday?: number | null };

export type EngagementChecklistCoreFragment = { __typename?: 'EngagementChecklist', id: string, createdAt: any, updatedAt: any, loggedAt: any, uwes1?: number | null, uwes2?: number | null, uwes3?: number | null, bat1?: number | null, bat2?: number | null, bat3?: number | null, bat4?: number | null, bat5?: number | null, bat6?: number | null, bat7?: number | null, bat8?: number | null, bat9?: number | null, bat10?: number | null, bat11?: number | null, bat12?: number | null, bat13?: number | null, bat14?: number | null, bat15?: number | null, bat16?: number | null, bat17?: number | null, bat18?: number | null, bat19?: number | null, bat20?: number | null, bat21?: number | null, bat22?: number | null, bat23?: number | null, bat24?: number | null, bat25?: number | null, bat26?: number | null, bat27?: number | null, bat28?: number | null, bat29?: number | null, bat30?: number | null, bat31?: number | null, bat32?: number | null, bat33?: number | null, req1?: number | null, req2?: number | null, req3?: number | null, req4?: number | null, req5?: number | null, req6?: number | null, req7?: number | null, req8?: number | null, req9?: number | null, req10?: number | null, req11?: number | null, req12?: number | null, req13?: number | null, req14?: number | null, req15?: number | null, req16?: number | null, fssb1?: number | null, fssb2?: number | null, fssb3?: number | null, fssb4?: number | null, fssb5?: number | null, fssb6?: number | null, fssb7?: number | null, fssb8?: number | null, fssb9?: number | null, fssb10?: number | null, fssb11?: number | null, fssb12?: number | null, fssb13?: number | null, fssb14?: number | null, mos1?: number | null, mos2?: number | null, mos3?: number | null, mos4?: number | null, mos5?: number | null, mos6?: number | null, mos7?: number | null, mos8?: number | null, mos9?: number | null, mos10?: number | null, mos11?: number | null, mos12?: number | null, mos13?: number | null, mos14?: number | null, mos15?: number | null, mos16?: number | null, mos17?: number | null, mos18?: number | null, mos19?: number | null, mos20?: number | null, mos21?: number | null, mos22?: number | null, mos23?: number | null, mos24?: number | null, mos25?: number | null, mos26?: number | null, mos27?: number | null, mos28?: number | null, mos29?: number | null, mos30?: number | null, mos31?: number | null, mos32?: number | null, mos33?: number | null, mos34?: number | null, mos35?: number | null, mos36?: number | null, mos37?: number | null, mos38?: number | null, mos39?: number | null, mos40?: number | null, mos41?: number | null, mos42?: number | null, mos43?: number | null, mos44?: number | null, mos45?: number | null, mos46?: number | null, mos47?: number | null, mos48?: number | null, mos49?: number | null, mos50?: number | null, mos51?: number | null, workSpace1?: number | null, workSpace2?: number | null, userId: string, user: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, phone: string, password: string } };

export type EngagementChecklistUpdateFragment = { __typename?: 'EngagementChecklist', id: string, loggedAt: any, userId: string, uwes1?: number | null, uwes2?: number | null, uwes3?: number | null, bat1?: number | null, bat2?: number | null, bat3?: number | null, bat4?: number | null, bat5?: number | null, bat6?: number | null, bat7?: number | null, bat8?: number | null, bat9?: number | null, bat10?: number | null, bat11?: number | null, bat12?: number | null, bat13?: number | null, bat14?: number | null, bat15?: number | null, bat16?: number | null, bat17?: number | null, bat18?: number | null, bat19?: number | null, bat20?: number | null, bat21?: number | null, bat22?: number | null, bat23?: number | null, bat24?: number | null, bat25?: number | null, bat26?: number | null, bat27?: number | null, bat28?: number | null, bat29?: number | null, bat30?: number | null, bat31?: number | null, bat32?: number | null, bat33?: number | null, req1?: number | null, req2?: number | null, req3?: number | null, req4?: number | null, req5?: number | null, req6?: number | null, req7?: number | null, req8?: number | null, req9?: number | null, req10?: number | null, req11?: number | null, req12?: number | null, req13?: number | null, req14?: number | null, req15?: number | null, req16?: number | null, fssb1?: number | null, fssb2?: number | null, fssb3?: number | null, fssb4?: number | null, fssb5?: number | null, fssb6?: number | null, fssb7?: number | null, fssb8?: number | null, fssb9?: number | null, fssb10?: number | null, fssb11?: number | null, fssb12?: number | null, fssb13?: number | null, fssb14?: number | null, mos1?: number | null, mos2?: number | null, mos3?: number | null, mos4?: number | null, mos5?: number | null, mos6?: number | null, mos7?: number | null, mos8?: number | null, mos9?: number | null, mos10?: number | null, mos11?: number | null, mos12?: number | null, mos13?: number | null, mos14?: number | null, mos15?: number | null, mos16?: number | null, mos17?: number | null, mos18?: number | null, mos19?: number | null, mos20?: number | null, mos21?: number | null, mos22?: number | null, mos23?: number | null, mos24?: number | null, mos25?: number | null, mos26?: number | null, mos27?: number | null, mos28?: number | null, mos29?: number | null, mos30?: number | null, mos31?: number | null, mos32?: number | null, mos33?: number | null, mos34?: number | null, mos35?: number | null, mos36?: number | null, mos37?: number | null, mos38?: number | null, mos39?: number | null, mos40?: number | null, mos41?: number | null, mos42?: number | null, mos43?: number | null, mos44?: number | null, mos45?: number | null, mos46?: number | null, mos47?: number | null, mos48?: number | null, mos49?: number | null, mos50?: number | null, mos51?: number | null, workSpace1?: number | null, workSpace2?: number | null };

export type ExerciseCoreFragment = { __typename?: 'Exercise', id: string, createdAt: any, updatedAt: any, placedAt: number, name: string, exerciseGroupId: string, exerciseGroup: { __typename?: 'ExerciseGroup', id: string, createdAt: any, updatedAt: any, name: string } };

export type FoodCoreFragment = { __typename?: 'Food', id: string, createdAt: any, updatedAt: any, name: string };

export type LifestyleCoreFragment = { __typename?: 'Lifestyle', id: string, createdAt: any, updatedAt: any, loggedAt: any, height?: string | null, weight?: string | null, symptomOnset?: boolean | null, symptom?: Symptom | null, symptomMemo?: string | null, healthStatus?: number | null, fatigue?: number | null, feeling?: number | null, bedtime?: any | null, wakeupTime?: any | null, sleepQuality?: SleepQuality | null, sleepDisruption?: SleepDisruption | null, dream?: boolean | null, stoolCondition?: StoolCondition | null, duringMenstruation?: boolean | null, menstruationCondition?: MenstruationCondition | null, lifestyleMemo?: string | null, userId: string };

export type LifestyleUpdateFragment = { __typename?: 'Lifestyle', id: string, height?: string | null, weight?: string | null, symptomOnset?: boolean | null, symptom?: Symptom | null, symptomMemo?: string | null, healthStatus?: number | null, fatigue?: number | null, feeling?: number | null, bedtime?: any | null, wakeupTime?: any | null, sleepQuality?: SleepQuality | null, sleepDisruption?: SleepDisruption | null, dream?: boolean | null, stoolCondition?: StoolCondition | null, duringMenstruation?: boolean | null, menstruationCondition?: MenstruationCondition | null, lifestyleMemo?: string | null, meals: Array<{ __typename?: 'Meal', id: string, lifestyleId: string, mealTiming: MealTiming, nutrientsOnMeals: Array<{ __typename?: 'NutrientsOnMeals', nutrientIntake: NutrientIntake, mealId: string, nutrientId: string, nutrient: { __typename?: 'Nutrient', id: string, name: string } }>, foodsOnMeals: Array<{ __typename?: 'FoodsOnMeals', mealId: string, foodId: string, food: { __typename?: 'Food', id: string, name: string } }>, snacksOnMeals: Array<{ __typename?: 'SnacksOnMeals', mealId: string, snackId: string, snack: { __typename?: 'Snack', id: string, name: string } }> }>, exercisesOnLifestyles: Array<{ __typename?: 'ExercisesOnLifestyles', exerciseAmount: number, lifestyleId: string, exerciseId: string, exercise: { __typename?: 'Exercise', id: string, name: string, exerciseGroup: { __typename?: 'ExerciseGroup', id: string, name: string } } }> };

export type MessageCoreFragment = { __typename?: 'Message', id: string, body: string, sentBy: string, sentAt: any, roomId: string };

export type NutrientCoreFragment = { __typename?: 'Nutrient', id: string, createdAt: any, updatedAt: any, name: string };

export type OkotobaCoreFragment = { __typename?: 'Okotoba', id: string, title: string, content: string, characteristicL: YomogiProCharacteristicL, healthScoreRange: HealthScoreRange, eyecatch: { __typename?: 'MicroCmsImage', url: string, height: number, width: number } };

export type OmikujiCoreFragment = { __typename?: 'Omikuji', id: string, omikujiNumber: number, season: string, twentyFourSolarTerms: string, totalCondition: string, bodyCondition: string, mentalCondition: string, healthAdvice: string, recommendedFood: string, recommendedPressurePoint: string };

export type RoomCoreFragment = { __typename?: 'Room', id: string, name: string, lastMessageBody?: string | null, lastMessageSentAt?: any | null, participants: Array<{ __typename?: 'Participant', participantId: string, name: string, roomId: string }>, messages: Array<{ __typename?: 'Message', id: string, body: string, sentBy: string, sentAt: any, roomId: string }> };

export type SnackCoreFragment = { __typename?: 'Snack', id: string, createdAt: any, updatedAt: any, name: string };

export type TreatmentForQueryFragment = { __typename?: 'Treatment', id: string, startTime: any, endTime: any, reservationName: string, reservationPhone?: string | null, reservationProgress: number, treatedAt?: any | null, physicalCondition?: number | null, patientMemo?: string | null, visitingPurpose?: VisitingPurpose | null, hasSymptom?: boolean | null, treatmentMemo?: string | null, hasCurrentMedicalHistory?: boolean | null, currentMedicalHistory?: string | null, hasPastMedicalHistory?: boolean | null, pastMedicalHistory?: Array<MedicalHistory> | null, hasFamilyMedicalHistory?: boolean | null, familyMedicalHistory?: Array<MedicalHistory> | null, sleepLength?: number | null, appetite?: number | null, bowelMovement?: number | null, redFlags?: Array<RedFlag> | null, isRed?: boolean | null, yellowFlags?: Array<YellowFlag> | null, isYellow?: boolean | null, testLevel1s?: Array<TestLevel1> | null, symptomArea?: SymptomArea | null, symptomFeelings?: Array<SymptomFeeling> | null, symptomTimings?: Array<SymptomTiming> | null, hasExerciseHabit?: boolean | null, exerciseHabitFrequency?: HabitFrequency | null, healthHabits?: Array<HealthHabit> | null, healthHabitFrequency?: HabitFrequency | null, personality?: Personality | null, hasTabaccoHabit?: HasHabit | null, tabaccoHabitMemo?: string | null, hasAlcoholHabit?: HasHabit | null, alcoholHabitMemo?: string | null, pregnancy?: Pregnancy | null, hasHospitalVisit?: boolean | null, hospitalVisitMemo?: string | null, hasMedication?: boolean | null, medicationMemo?: string | null, hasAcupunctureTreatment?: boolean | null, acupunctureTreatmentMemo?: string | null, totalTreatmentCount: number, isEditing: boolean, isFirst: boolean, therapeuticEffect?: number | null, therapeuticEffectTiming?: TherapeuticEffectTiming | null, satisfaction?: number | null, therapeuticEffectMemo?: string | null, userId: string, officeId: string, patientId?: string | null, tongueShape?: TongueShape | null, antiG1GreaterPectoralMuscle?: Array<TenderPoint> | null, antiG1SternocleidomastoidMuscle?: Array<TenderPoint> | null, antiG1TrapeziusMuscle?: Array<TenderPoint> | null, antiG2Gastrocnemius?: Array<TenderPoint> | null, antiG2Hamstring?: Array<TenderPoint> | null, antiG2Iliopsoas?: Array<TenderPoint> | null, cyanosis?: Cyanosis | null, pulse?: Pulse | null, sourcePointBackHandGoukoku?: Array<TenderPoint> | null, sourcePointBackHandWankotsu?: Array<TenderPoint> | null, sourcePointBackHandYouchi?: Array<TenderPoint> | null, sourcePointInsideFootTaihaku?: Array<TenderPoint> | null, sourcePointInsideFootTaikei?: Array<TenderPoint> | null, sourcePointInsideFootTaishou?: Array<TenderPoint> | null, sourcePointOutsideFootKeikotsu?: Array<TenderPoint> | null, sourcePointOutsideFootKyukyo?: Array<TenderPoint> | null, sourcePointOutsideFootShouyou?: Array<TenderPoint> | null, sourcePointPalmDairyou?: Array<TenderPoint> | null, sourcePointPalmShinmon?: Array<TenderPoint> | null, sourcePointPalmTaien?: Array<TenderPoint> | null, spinalCurvature?: SpinalCurvature | null, tongueCoating?: TongueCoating | null, scalp?: number | null, user?: { __typename?: 'ComoUser', id: string, name: string } | null, office?: { __typename?: 'Office', id: string, name: string } | null, diagnoses?: Array<{ __typename?: 'Diagnose', id: string, diseaseId?: string | null, priority: number, symptom?: Symptom | null, otherSymptomMemo?: string | null, questionMemo?: string | null, questionSecretMemo?: string | null, symptomCause?: SymptomCause | null, bodyPart?: BodyPart | null, onsetTiming?: OnsetTiming | null, isRelated: boolean, disease?: { __typename?: 'Disease', id: string, name: string } | null, treatmentTherapeuticPoints: Array<{ __typename?: 'TreatmentTherapeuticPoint', id: string, therapeuticPoint?: { __typename?: 'TherapeuticPoint', id: string, name: string, nameFurigana: string } | null }> }> | null };

export type UserCoreFragment = { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, height?: string | null, weight?: string | null, phone: string, usingPurpose?: UsingPurpose | null, currentDisease?: CurrentDisease | null, bodyDisorder?: BodyDisorder | null, healthGoal?: HealthGoal | null, password: string };

export type YojyoVideoContentCoreFragment = { __typename?: 'YojyoVideoContent', id: string, title: string, file: string, thumbnail: string, description: string, yojyoVideoContentCategory?: { __typename?: 'YojyoVideoContentCategory', title: string } | null };

export type YojyoVideoContentCategoryCoreFragment = { __typename?: 'YojyoVideoContentCategory', id: string, title: string, yojyoVideoContents?: Array<{ __typename?: 'YojyoVideoContent', id: string, title: string, thumbnail: string }> | null };

export type UpdateChecklistByDateMutationVariables = Exact<{
  input: UpdateChecklistInput;
}>;


export type UpdateChecklistByDateMutation = { __typename?: 'Mutation', updateChecklistByDate: { __typename?: 'Checklist', id: string, loggedAt: any, userId: string, tandemTime?: number | null, bodyStiff?: BodyStiff | null, crouching?: Crouching | null, oneFootTime?: number | null, calfThickness?: CalfThickness | null, pulse?: number | null, tongueColor?: TongueColor | null, holdBreathTime?: number | null, irritated?: MentalStatus | null, angry?: MentalStatus | null, annoyingMood?: MentalStatus | null, outburstAnger?: MentalStatus | null, tiringEasily?: MentalStatus | null, feelingHeavy?: MentalStatus | null, insomnia?: MentalStatus | null, headache?: MentalStatus | null, sad?: MentalStatus | null, lonely?: MentalStatus | null, cry?: MentalStatus | null, depressed?: MentalStatus | null, concentrateWork?: MentalStatus | null, concentrateOneThing?: MentalStatus | null, lackPatience?: MentalStatus | null, difficultThinking?: MentalStatus | null } };

export type UpdateChecklistByMonthMutationVariables = Exact<{
  input: UpdateChecklistInput;
}>;


export type UpdateChecklistByMonthMutation = { __typename?: 'Mutation', updateChecklistByMonth: { __typename?: 'Checklist', id: string, loggedAt: any, userId: string, tandemTime?: number | null, bodyStiff?: BodyStiff | null, crouching?: Crouching | null, oneFootTime?: number | null, calfThickness?: CalfThickness | null, pulse?: number | null, tongueColor?: TongueColor | null, holdBreathTime?: number | null, irritated?: MentalStatus | null, angry?: MentalStatus | null, annoyingMood?: MentalStatus | null, outburstAnger?: MentalStatus | null, tiringEasily?: MentalStatus | null, feelingHeavy?: MentalStatus | null, insomnia?: MentalStatus | null, headache?: MentalStatus | null, sad?: MentalStatus | null, lonely?: MentalStatus | null, cry?: MentalStatus | null, depressed?: MentalStatus | null, concentrateWork?: MentalStatus | null, concentrateOneThing?: MentalStatus | null, lackPatience?: MentalStatus | null, difficultThinking?: MentalStatus | null } };

export type CreateDepartmentsOnUsersMutationVariables = Exact<{
  input: CreateDepartmentsOnUsersInput;
}>;


export type CreateDepartmentsOnUsersMutation = { __typename?: 'Mutation', createDepartmentsOnUsers: { __typename?: 'DepartmentsOnUsers', department?: { __typename?: 'Department', id: string, name: string, manager?: { __typename?: 'Manager', name?: string | null } | null } | null } };

export type DeleteDepartmentsOnUsersMutationVariables = Exact<{
  input: CreateDepartmentsOnUsersInput;
}>;


export type DeleteDepartmentsOnUsersMutation = { __typename?: 'Mutation', deleteDepartmentsOnUsers: { __typename?: 'DepartmentsOnUsers', departmentId: string } };

export type UpdateEcoChecklistByDateMutationVariables = Exact<{
  input: UpdateEcoChecklistInput;
}>;


export type UpdateEcoChecklistByDateMutation = { __typename?: 'Mutation', updateEcoChecklistByDate: { __typename?: 'EcoChecklist', id: string, loggedAt: any, userId: string, seasonalFood?: number | null, domesticFood?: number | null, localFood?: number | null, eatingOutFood?: number | null, outdoorExercise?: number | null, equipmentExercise?: number | null, daytimeExercise?: number | null, publicTransportUsage?: number | null, electronicDeviceUsage?: number | null, airConditionerUsage?: number | null, indoorHoliday?: number | null } };

export type UpdateEcoChecklistByMonthMutationVariables = Exact<{
  input: UpdateEcoChecklistInput;
}>;


export type UpdateEcoChecklistByMonthMutation = { __typename?: 'Mutation', updateEcoChecklistByMonth: { __typename?: 'EcoChecklist', id: string, loggedAt: any, userId: string, seasonalFood?: number | null, domesticFood?: number | null, localFood?: number | null, eatingOutFood?: number | null, outdoorExercise?: number | null, equipmentExercise?: number | null, daytimeExercise?: number | null, publicTransportUsage?: number | null, electronicDeviceUsage?: number | null, airConditionerUsage?: number | null, indoorHoliday?: number | null } };

export type UpdateEngagementChecklistMutationVariables = Exact<{
  input: UpdateEngagementChecklistInput;
}>;


export type UpdateEngagementChecklistMutation = { __typename?: 'Mutation', updateEngagementChecklist: { __typename?: 'EngagementChecklist', id: string, loggedAt: any, userId: string, uwes1?: number | null, uwes2?: number | null, uwes3?: number | null, bat1?: number | null, bat2?: number | null, bat3?: number | null, bat4?: number | null, bat5?: number | null, bat6?: number | null, bat7?: number | null, bat8?: number | null, bat9?: number | null, bat10?: number | null, bat11?: number | null, bat12?: number | null, bat13?: number | null, bat14?: number | null, bat15?: number | null, bat16?: number | null, bat17?: number | null, bat18?: number | null, bat19?: number | null, bat20?: number | null, bat21?: number | null, bat22?: number | null, bat23?: number | null, bat24?: number | null, bat25?: number | null, bat26?: number | null, bat27?: number | null, bat28?: number | null, bat29?: number | null, bat30?: number | null, bat31?: number | null, bat32?: number | null, bat33?: number | null, req1?: number | null, req2?: number | null, req3?: number | null, req4?: number | null, req5?: number | null, req6?: number | null, req7?: number | null, req8?: number | null, req9?: number | null, req10?: number | null, req11?: number | null, req12?: number | null, req13?: number | null, req14?: number | null, req15?: number | null, req16?: number | null, fssb1?: number | null, fssb2?: number | null, fssb3?: number | null, fssb4?: number | null, fssb5?: number | null, fssb6?: number | null, fssb7?: number | null, fssb8?: number | null, fssb9?: number | null, fssb10?: number | null, fssb11?: number | null, fssb12?: number | null, fssb13?: number | null, fssb14?: number | null, mos1?: number | null, mos2?: number | null, mos3?: number | null, mos4?: number | null, mos5?: number | null, mos6?: number | null, mos7?: number | null, mos8?: number | null, mos9?: number | null, mos10?: number | null, mos11?: number | null, mos12?: number | null, mos13?: number | null, mos14?: number | null, mos15?: number | null, mos16?: number | null, mos17?: number | null, mos18?: number | null, mos19?: number | null, mos20?: number | null, mos21?: number | null, mos22?: number | null, mos23?: number | null, mos24?: number | null, mos25?: number | null, mos26?: number | null, mos27?: number | null, mos28?: number | null, mos29?: number | null, mos30?: number | null, mos31?: number | null, mos32?: number | null, mos33?: number | null, mos34?: number | null, mos35?: number | null, mos36?: number | null, mos37?: number | null, mos38?: number | null, mos39?: number | null, mos40?: number | null, mos41?: number | null, mos42?: number | null, mos43?: number | null, mos44?: number | null, mos45?: number | null, mos46?: number | null, mos47?: number | null, mos48?: number | null, mos49?: number | null, mos50?: number | null, mos51?: number | null, workSpace1?: number | null, workSpace2?: number | null } };

export type UpdateLifestyleByDateMutationVariables = Exact<{
  input: UpdateLifestyleInput;
}>;


export type UpdateLifestyleByDateMutation = { __typename?: 'Mutation', updateLifestyleByDate: { __typename?: 'Lifestyle', id: string, height?: string | null, weight?: string | null, symptomOnset?: boolean | null, symptom?: Symptom | null, symptomMemo?: string | null, healthStatus?: number | null, fatigue?: number | null, feeling?: number | null, bedtime?: any | null, wakeupTime?: any | null, sleepQuality?: SleepQuality | null, sleepDisruption?: SleepDisruption | null, dream?: boolean | null, stoolCondition?: StoolCondition | null, duringMenstruation?: boolean | null, menstruationCondition?: MenstruationCondition | null, lifestyleMemo?: string | null, meals: Array<{ __typename?: 'Meal', id: string, lifestyleId: string, mealTiming: MealTiming, nutrientsOnMeals: Array<{ __typename?: 'NutrientsOnMeals', nutrientIntake: NutrientIntake, mealId: string, nutrientId: string, nutrient: { __typename?: 'Nutrient', id: string, name: string } }>, foodsOnMeals: Array<{ __typename?: 'FoodsOnMeals', mealId: string, foodId: string, food: { __typename?: 'Food', id: string, name: string } }>, snacksOnMeals: Array<{ __typename?: 'SnacksOnMeals', mealId: string, snackId: string, snack: { __typename?: 'Snack', id: string, name: string } }> }>, exercisesOnLifestyles: Array<{ __typename?: 'ExercisesOnLifestyles', exerciseAmount: number, lifestyleId: string, exerciseId: string, exercise: { __typename?: 'Exercise', id: string, name: string, exerciseGroup: { __typename?: 'ExerciseGroup', id: string, name: string } } }> } };

export type LoginMutationVariables = Exact<{
  input: AuthLoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AccessToken', accessToken: string } };

export type RegisterMutationVariables = Exact<{
  input: AuthRegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'AccessToken', accessToken: string } };

export type RequestResetPasswordMutationVariables = Exact<{
  phone: Scalars['String'];
}>;


export type RequestResetPasswordMutation = { __typename?: 'Mutation', requestResetPassword: { __typename?: 'ResetPasswordStatus', id: string, hasRequested: boolean } };

export type CheckOnetimePasswordMutationVariables = Exact<{
  input: CheckOnetimePasswordInput;
}>;


export type CheckOnetimePasswordMutation = { __typename?: 'Mutation', checkOnetimePassword: { __typename?: 'OnetimePasswordStatus', isValid: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'AccessToken', accessToken: string } };

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'Message', id: string, body: string, sentBy: string, sentAt: any, roomId: string } };

export type CreateSetupIntentMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type CreateSetupIntentMutation = { __typename?: 'Mutation', createSetupIntent: { __typename?: 'SetupIntentResult', clientSecret: string } };

export type CreateInvoiceMutationVariables = Exact<{
  priceId: Scalars['String'];
  email: Scalars['String'];
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice: { __typename?: 'InvoiceResult', clientSecret: string, invoiceId: string, priceId: string } };

export type UpdatePaymentMethodMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdatePaymentMethodMutation = { __typename?: 'Mutation', updatePaymentMethod: boolean };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, height?: string | null, weight?: string | null, phone: string, usingPurpose?: UsingPurpose | null, currentDisease?: CurrentDisease | null, bodyDisorder?: BodyDisorder | null, healthGoal?: HealthGoal | null, password: string } };

export type RemoveUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, height?: string | null, weight?: string | null, phone: string, usingPurpose?: UsingPurpose | null, currentDisease?: CurrentDisease | null, bodyDisorder?: BodyDisorder | null, healthGoal?: HealthGoal | null, password: string } };

export type UpdateCompletedYojyoTestIdsMutationVariables = Exact<{
  input: UpdateCompletedYojyoTestInput;
}>;


export type UpdateCompletedYojyoTestIdsMutation = { __typename?: 'Mutation', updateCompletedYojyoTestIds: boolean };

export type UpdateYojyoTestNumberMutationVariables = Exact<{
  input: UpdateYojyoTestNumberInput;
}>;


export type UpdateYojyoTestNumberMutation = { __typename?: 'Mutation', updateYojyoTestNumber: boolean };

export type ChecklistByDateQueryVariables = Exact<{
  where: ChecklistWhereDateUniqueInput;
}>;


export type ChecklistByDateQuery = { __typename?: 'Query', checklistByDate: { __typename?: 'Checklist', id: string, createdAt: any, updatedAt: any, loggedAt: any, tandemTime?: number | null, bodyStiff?: BodyStiff | null, crouching?: Crouching | null, oneFootTime?: number | null, calfThickness?: CalfThickness | null, pulse?: number | null, tongueColor?: TongueColor | null, holdBreathTime?: number | null, irritated?: MentalStatus | null, angry?: MentalStatus | null, annoyingMood?: MentalStatus | null, outburstAnger?: MentalStatus | null, tiringEasily?: MentalStatus | null, feelingHeavy?: MentalStatus | null, insomnia?: MentalStatus | null, headache?: MentalStatus | null, sad?: MentalStatus | null, lonely?: MentalStatus | null, cry?: MentalStatus | null, depressed?: MentalStatus | null, concentrateWork?: MentalStatus | null, concentrateOneThing?: MentalStatus | null, lackPatience?: MentalStatus | null, difficultThinking?: MentalStatus | null, userId: string, user: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, phone: string, password: string } } };

export type ChecklistByMonthQueryVariables = Exact<{
  where: ChecklistWhereDateUniqueInput;
}>;


export type ChecklistByMonthQuery = { __typename?: 'Query', checklistByMonth: { __typename?: 'Checklist', id: string, createdAt: any, updatedAt: any, loggedAt: any, tandemTime?: number | null, bodyStiff?: BodyStiff | null, crouching?: Crouching | null, oneFootTime?: number | null, calfThickness?: CalfThickness | null, pulse?: number | null, tongueColor?: TongueColor | null, holdBreathTime?: number | null, irritated?: MentalStatus | null, angry?: MentalStatus | null, annoyingMood?: MentalStatus | null, outburstAnger?: MentalStatus | null, tiringEasily?: MentalStatus | null, feelingHeavy?: MentalStatus | null, insomnia?: MentalStatus | null, headache?: MentalStatus | null, sad?: MentalStatus | null, lonely?: MentalStatus | null, cry?: MentalStatus | null, depressed?: MentalStatus | null, concentrateWork?: MentalStatus | null, concentrateOneThing?: MentalStatus | null, lackPatience?: MentalStatus | null, difficultThinking?: MentalStatus | null, userId: string, user: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, phone: string, password: string } } };

export type KokokaraQueryVariables = Exact<{
  where: ChecklistWhereUniqueInput;
}>;


export type KokokaraQuery = { __typename?: 'Query', kokokara: { __typename?: 'Kokokara', totalScore: number, characteristicL: YomogiProCharacteristicL, characteristicS: YomogiProCharacteristicS, checklistId: string, scores: Array<{ __typename?: 'KokokaraScore', label: string, data: number, characteristicL: YomogiProCharacteristicL, characteristicS: YomogiProCharacteristicS }> } };

export type KokokaraForShortQueryVariables = Exact<{
  where: ChecklistWhereUniqueInput;
}>;


export type KokokaraForShortQuery = { __typename?: 'Query', kokokaraForShort: { __typename?: 'Kokokara', totalScore: number, characteristicL: YomogiProCharacteristicL, characteristicS: YomogiProCharacteristicS, checklistId: string, scores: Array<{ __typename?: 'KokokaraScore', label: string, data: number, characteristicL: YomogiProCharacteristicL, characteristicS: YomogiProCharacteristicS }> } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'Me', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, height?: string | null, weight?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, phone: string, password: string, comoId?: string | null, completedYojyoLicenseTestIds?: Array<string> | null, hadYojyoLicenseTestAt?: any | null, yojyoLicenseTestNumber?: string | null, completedYojyoInstructorTestIds?: Array<string> | null, hadYojyoInstructorTestAt?: any | null, yojyoInstructorTestNumber?: string | null } };

export type DepartmentByInvitationCodeQueryVariables = Exact<{
  where: FindDepartmentByInvitationCodeWhereInput;
}>;


export type DepartmentByInvitationCodeQuery = { __typename?: 'Query', departmentByInvitationCode?: { __typename?: 'Department', id: string, name: string, manager?: { __typename?: 'Manager', name?: string | null } | null } | null };

export type EcoChecklistByDateQueryVariables = Exact<{
  where: EcoChecklistWhereDateUniqueInput;
}>;


export type EcoChecklistByDateQuery = { __typename?: 'Query', ecoChecklistByDate: { __typename?: 'EcoChecklist', id: string, createdAt: any, updatedAt: any, loggedAt: any, seasonalFood?: number | null, domesticFood?: number | null, localFood?: number | null, eatingOutFood?: number | null, outdoorExercise?: number | null, equipmentExercise?: number | null, daytimeExercise?: number | null, publicTransportUsage?: number | null, electronicDeviceUsage?: number | null, airConditionerUsage?: number | null, indoorHoliday?: number | null, userId: string, user: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, phone: string, password: string } } };

export type EcoChecklistByMonthQueryVariables = Exact<{
  where: EcoChecklistWhereDateUniqueInput;
}>;


export type EcoChecklistByMonthQuery = { __typename?: 'Query', ecoChecklistByMonth: { __typename?: 'EcoChecklist', id: string, createdAt: any, updatedAt: any, loggedAt: any, seasonalFood?: number | null, domesticFood?: number | null, localFood?: number | null, eatingOutFood?: number | null, outdoorExercise?: number | null, equipmentExercise?: number | null, daytimeExercise?: number | null, publicTransportUsage?: number | null, electronicDeviceUsage?: number | null, airConditionerUsage?: number | null, indoorHoliday?: number | null, userId: string, user: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, phone: string, password: string } } };

export type EcoChecklistScoreByMonthQueryVariables = Exact<{
  where: EcoChecklistWhereUniqueInput;
}>;


export type EcoChecklistScoreByMonthQuery = { __typename?: 'Query', ecoChecklistScoreByMonth: { __typename?: 'EcoChecklistTotalScore', totalScore: number, scores: Array<{ __typename?: 'EcoChecklistScore', label: string, data: number }> } };

export type EngagementChecklistQueryVariables = Exact<{
  where: EngagementChecklistWhereDateUniqueInput;
}>;


export type EngagementChecklistQuery = { __typename?: 'Query', engagementChecklist: { __typename?: 'EngagementChecklist', id: string, createdAt: any, updatedAt: any, loggedAt: any, uwes1?: number | null, uwes2?: number | null, uwes3?: number | null, bat1?: number | null, bat2?: number | null, bat3?: number | null, bat4?: number | null, bat5?: number | null, bat6?: number | null, bat7?: number | null, bat8?: number | null, bat9?: number | null, bat10?: number | null, bat11?: number | null, bat12?: number | null, bat13?: number | null, bat14?: number | null, bat15?: number | null, bat16?: number | null, bat17?: number | null, bat18?: number | null, bat19?: number | null, bat20?: number | null, bat21?: number | null, bat22?: number | null, bat23?: number | null, bat24?: number | null, bat25?: number | null, bat26?: number | null, bat27?: number | null, bat28?: number | null, bat29?: number | null, bat30?: number | null, bat31?: number | null, bat32?: number | null, bat33?: number | null, req1?: number | null, req2?: number | null, req3?: number | null, req4?: number | null, req5?: number | null, req6?: number | null, req7?: number | null, req8?: number | null, req9?: number | null, req10?: number | null, req11?: number | null, req12?: number | null, req13?: number | null, req14?: number | null, req15?: number | null, req16?: number | null, fssb1?: number | null, fssb2?: number | null, fssb3?: number | null, fssb4?: number | null, fssb5?: number | null, fssb6?: number | null, fssb7?: number | null, fssb8?: number | null, fssb9?: number | null, fssb10?: number | null, fssb11?: number | null, fssb12?: number | null, fssb13?: number | null, fssb14?: number | null, mos1?: number | null, mos2?: number | null, mos3?: number | null, mos4?: number | null, mos5?: number | null, mos6?: number | null, mos7?: number | null, mos8?: number | null, mos9?: number | null, mos10?: number | null, mos11?: number | null, mos12?: number | null, mos13?: number | null, mos14?: number | null, mos15?: number | null, mos16?: number | null, mos17?: number | null, mos18?: number | null, mos19?: number | null, mos20?: number | null, mos21?: number | null, mos22?: number | null, mos23?: number | null, mos24?: number | null, mos25?: number | null, mos26?: number | null, mos27?: number | null, mos28?: number | null, mos29?: number | null, mos30?: number | null, mos31?: number | null, mos32?: number | null, mos33?: number | null, mos34?: number | null, mos35?: number | null, mos36?: number | null, mos37?: number | null, mos38?: number | null, mos39?: number | null, mos40?: number | null, mos41?: number | null, mos42?: number | null, mos43?: number | null, mos44?: number | null, mos45?: number | null, mos46?: number | null, mos47?: number | null, mos48?: number | null, mos49?: number | null, mos50?: number | null, mos51?: number | null, workSpace1?: number | null, workSpace2?: number | null, userId: string, user: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, phone: string, password: string } } };

export type EngagementChecklistScoreQueryVariables = Exact<{
  where: EngagementChecklistWhereUniqueInput;
}>;


export type EngagementChecklistScoreQuery = { __typename?: 'Query', engagementChecklistScore: { __typename?: 'EngagementChecklistTotalScore', totalScore: number, scores: Array<{ __typename?: 'EngagementChecklistScore', label: string, data: number }> } };

export type ExercisesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExercisesQuery = { __typename?: 'Query', exercises: Array<{ __typename?: 'Exercise', id: string, createdAt: any, updatedAt: any, placedAt: number, name: string, exerciseGroupId: string, exerciseGroup: { __typename?: 'ExerciseGroup', id: string, createdAt: any, updatedAt: any, name: string } }> };

export type FoodsQueryVariables = Exact<{ [key: string]: never; }>;


export type FoodsQuery = { __typename?: 'Query', foods: Array<{ __typename?: 'Food', id: string, createdAt: any, updatedAt: any, name: string }> };

export type GenerateYojyoVideoContentSignedUrlQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GenerateYojyoVideoContentSignedUrlQuery = { __typename?: 'Query', generateYojyoVideoContentSignedUrl: { __typename?: 'SignedUrl', url: string } };

export type LicenseYojyoTestsQueryVariables = Exact<{
  where: LicenseTestWhereInput;
}>;


export type LicenseYojyoTestsQuery = { __typename?: 'Query', licenseYojyoTests: Array<{ __typename?: 'LicenseTest', id: string, question: string, choice: Array<string>, answer: Array<string>, explanation?: string | null, licenseType: LicenseType, licenseTestContentId?: string | null }> };

export type LicenseYojyoTestContentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type LicenseYojyoTestContentQuery = { __typename?: 'Query', licenseYojyoTestContent: { __typename?: 'LicenseTestContent', id: string, title: string, description: string, file: string, thumbnail?: string | null, placedAt?: number | null, licenseType: LicenseType } };

export type LicenseYojyoTestContentsQueryVariables = Exact<{
  licenseType: Scalars['String'];
}>;


export type LicenseYojyoTestContentsQuery = { __typename?: 'Query', licenseYojyoTestContents: Array<{ __typename?: 'LicenseTestContent', id: string, title: string, description: string, file: string, thumbnail?: string | null, placedAt?: number | null, licenseType: LicenseType }> };

export type GenerateLicenseYojyoTestContentsSignedUrlQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GenerateLicenseYojyoTestContentsSignedUrlQuery = { __typename?: 'Query', generateLicenseYojyoTestContentsSignedUrl: string };

export type LifestyleByDateQueryVariables = Exact<{
  where: LifestyleWhereDateUniqueInput;
}>;


export type LifestyleByDateQuery = { __typename?: 'Query', lifestyleByDate: { __typename?: 'Lifestyle', id: string, createdAt: any, updatedAt: any, loggedAt: any, height?: string | null, weight?: string | null, symptomOnset?: boolean | null, symptom?: Symptom | null, symptomMemo?: string | null, healthStatus?: number | null, fatigue?: number | null, feeling?: number | null, bedtime?: any | null, wakeupTime?: any | null, sleepQuality?: SleepQuality | null, sleepDisruption?: SleepDisruption | null, dream?: boolean | null, stoolCondition?: StoolCondition | null, duringMenstruation?: boolean | null, menstruationCondition?: MenstruationCondition | null, lifestyleMemo?: string | null, userId: string, meals: Array<{ __typename?: 'Meal', id: string, lifestyleId: string, mealTiming: MealTiming, nutrientsOnMeals: Array<{ __typename?: 'NutrientsOnMeals', nutrientIntake: NutrientIntake, mealId: string, nutrientId: string, nutrient: { __typename?: 'Nutrient', id: string, name: string } }>, foodsOnMeals: Array<{ __typename?: 'FoodsOnMeals', mealId: string, foodId: string, food: { __typename?: 'Food', id: string, name: string } }>, snacksOnMeals: Array<{ __typename?: 'SnacksOnMeals', mealId: string, snackId: string, snack: { __typename?: 'Snack', id: string, name: string } }> }>, exercisesOnLifestyles: Array<{ __typename?: 'ExercisesOnLifestyles', exerciseAmount: number, lifestyleId: string, exerciseId: string, exercise: { __typename?: 'Exercise', id: string, name: string, exerciseGroup: { __typename?: 'ExerciseGroup', id: string, name: string } } }> } };

export type LifestylesByUserIdQueryVariables = Exact<{
  where: LifestyleByUserIdWhereUniqueInput;
}>;


export type LifestylesByUserIdQuery = { __typename?: 'Query', lifestylesByUserId: Array<{ __typename?: 'Lifestyle', id: string, createdAt: any, updatedAt: any, loggedAt: any, height?: string | null, weight?: string | null, symptomOnset?: boolean | null, symptom?: Symptom | null, symptomMemo?: string | null, healthStatus?: number | null, fatigue?: number | null, feeling?: number | null, bedtime?: any | null, wakeupTime?: any | null, sleepQuality?: SleepQuality | null, sleepDisruption?: SleepDisruption | null, dream?: boolean | null, stoolCondition?: StoolCondition | null, duringMenstruation?: boolean | null, menstruationCondition?: MenstruationCondition | null, lifestyleMemo?: string | null, userId: string, meals: Array<{ __typename?: 'Meal', id: string, lifestyleId: string, mealTiming: MealTiming, nutrientsOnMeals: Array<{ __typename?: 'NutrientsOnMeals', nutrientIntake: NutrientIntake, mealId: string, nutrientId: string, nutrient: { __typename?: 'Nutrient', id: string, name: string } }>, foodsOnMeals: Array<{ __typename?: 'FoodsOnMeals', mealId: string, foodId: string, food: { __typename?: 'Food', id: string, name: string } }>, snacksOnMeals: Array<{ __typename?: 'SnacksOnMeals', mealId: string, snackId: string, snack: { __typename?: 'Snack', id: string, name: string } }> }>, exercisesOnLifestyles: Array<{ __typename?: 'ExercisesOnLifestyles', exerciseAmount: number, lifestyleId: string, exerciseId: string, exercise: { __typename?: 'Exercise', id: string, name: string, exerciseGroup: { __typename?: 'ExerciseGroup', id: string, name: string } } }> }> };

export type LifestyleScoreByDateQueryVariables = Exact<{
  where: LifestyleWhereDateUniqueInput;
}>;


export type LifestyleScoreByDateQuery = { __typename?: 'Query', lifestyleScoreByDate: { __typename?: 'Score', totalScore: number, scores: Array<{ __typename?: 'LifestyleScore', label: string, data: number }> } };

export type NutrientsQueryVariables = Exact<{ [key: string]: never; }>;


export type NutrientsQuery = { __typename?: 'Query', nutrients: Array<{ __typename?: 'Nutrient', id: string, createdAt: any, updatedAt: any, name: string }> };

export type OkotobaQueryVariables = Exact<{ [key: string]: never; }>;


export type OkotobaQuery = { __typename?: 'Query', okotoba: { __typename?: 'Okotoba', id: string, title: string, content: string, characteristicL: YomogiProCharacteristicL, healthScoreRange: HealthScoreRange, eyecatch: { __typename?: 'MicroCmsImage', url: string, height: number, width: number } } };

export type OkotobaForShortQueryVariables = Exact<{ [key: string]: never; }>;


export type OkotobaForShortQuery = { __typename?: 'Query', okotobaForShort: { __typename?: 'Okotoba', id: string, title: string, content: string, characteristicL: YomogiProCharacteristicL, healthScoreRange: HealthScoreRange, eyecatch: { __typename?: 'MicroCmsImage', url: string, height: number, width: number } } };

export type RandomOmikujiQueryVariables = Exact<{ [key: string]: never; }>;


export type RandomOmikujiQuery = { __typename?: 'Query', randomOmikuji: { __typename?: 'Omikuji', id: string, omikujiNumber: number, season: string, twentyFourSolarTerms: string, totalCondition: string, bodyCondition: string, mentalCondition: string, healthAdvice: string, recommendedFood: string, recommendedPressurePoint: string } };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentMethod', id: string, card: { __typename?: 'PaymentMethodCard', brand: string, expMonth: number, expYear: number, last4: string } }> };

export type InvoiceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type InvoiceStatusQuery = { __typename?: 'Query', invoiceStatus: Array<{ __typename?: 'UsersOnInvoiceStatus', id: string, createdAt: any, updatedAt: any, priceId: string, invoiceId: string, userId?: string | null, yomogiId?: string | null }> };

export type RoomQueryVariables = Exact<{
  where: RoomWhereUniqueInput;
}>;


export type RoomQuery = { __typename?: 'Query', room: { __typename?: 'Room', id: string, name: string, lastMessageBody?: string | null, lastMessageSentAt?: any | null, participants: Array<{ __typename?: 'Participant', participantId: string, name: string, roomId: string }>, messages: Array<{ __typename?: 'Message', id: string, body: string, sentBy: string, sentAt: any, roomId: string }> } };

export type RoomsQueryVariables = Exact<{ [key: string]: never; }>;


export type RoomsQuery = { __typename?: 'Query', rooms: Array<{ __typename?: 'Room', id: string, name: string, lastMessageBody?: string | null, lastMessageSentAt?: any | null, participants: Array<{ __typename?: 'Participant', participantId: string, name: string, roomId: string }>, messages: Array<{ __typename?: 'Message', id: string, body: string, sentBy: string, sentAt: any, roomId: string }> }> };

export type SnacksQueryVariables = Exact<{ [key: string]: never; }>;


export type SnacksQuery = { __typename?: 'Query', snacks: Array<{ __typename?: 'Snack', id: string, createdAt: any, updatedAt: any, name: string }> };

export type TreatmentQueryVariables = Exact<{
  where: TreatmentWhereUniqueInput;
}>;


export type TreatmentQuery = { __typename?: 'Query', treatment: { __typename?: 'Treatment', id: string, startTime: any, endTime: any, reservationName: string, reservationPhone?: string | null, reservationProgress: number, treatedAt?: any | null, physicalCondition?: number | null, patientMemo?: string | null, visitingPurpose?: VisitingPurpose | null, hasSymptom?: boolean | null, treatmentMemo?: string | null, hasCurrentMedicalHistory?: boolean | null, currentMedicalHistory?: string | null, hasPastMedicalHistory?: boolean | null, pastMedicalHistory?: Array<MedicalHistory> | null, hasFamilyMedicalHistory?: boolean | null, familyMedicalHistory?: Array<MedicalHistory> | null, sleepLength?: number | null, appetite?: number | null, bowelMovement?: number | null, redFlags?: Array<RedFlag> | null, isRed?: boolean | null, yellowFlags?: Array<YellowFlag> | null, isYellow?: boolean | null, testLevel1s?: Array<TestLevel1> | null, symptomArea?: SymptomArea | null, symptomFeelings?: Array<SymptomFeeling> | null, symptomTimings?: Array<SymptomTiming> | null, hasExerciseHabit?: boolean | null, exerciseHabitFrequency?: HabitFrequency | null, healthHabits?: Array<HealthHabit> | null, healthHabitFrequency?: HabitFrequency | null, personality?: Personality | null, hasTabaccoHabit?: HasHabit | null, tabaccoHabitMemo?: string | null, hasAlcoholHabit?: HasHabit | null, alcoholHabitMemo?: string | null, pregnancy?: Pregnancy | null, hasHospitalVisit?: boolean | null, hospitalVisitMemo?: string | null, hasMedication?: boolean | null, medicationMemo?: string | null, hasAcupunctureTreatment?: boolean | null, acupunctureTreatmentMemo?: string | null, totalTreatmentCount: number, isEditing: boolean, isFirst: boolean, therapeuticEffect?: number | null, therapeuticEffectTiming?: TherapeuticEffectTiming | null, satisfaction?: number | null, therapeuticEffectMemo?: string | null, userId: string, officeId: string, patientId?: string | null, tongueShape?: TongueShape | null, antiG1GreaterPectoralMuscle?: Array<TenderPoint> | null, antiG1SternocleidomastoidMuscle?: Array<TenderPoint> | null, antiG1TrapeziusMuscle?: Array<TenderPoint> | null, antiG2Gastrocnemius?: Array<TenderPoint> | null, antiG2Hamstring?: Array<TenderPoint> | null, antiG2Iliopsoas?: Array<TenderPoint> | null, cyanosis?: Cyanosis | null, pulse?: Pulse | null, sourcePointBackHandGoukoku?: Array<TenderPoint> | null, sourcePointBackHandWankotsu?: Array<TenderPoint> | null, sourcePointBackHandYouchi?: Array<TenderPoint> | null, sourcePointInsideFootTaihaku?: Array<TenderPoint> | null, sourcePointInsideFootTaikei?: Array<TenderPoint> | null, sourcePointInsideFootTaishou?: Array<TenderPoint> | null, sourcePointOutsideFootKeikotsu?: Array<TenderPoint> | null, sourcePointOutsideFootKyukyo?: Array<TenderPoint> | null, sourcePointOutsideFootShouyou?: Array<TenderPoint> | null, sourcePointPalmDairyou?: Array<TenderPoint> | null, sourcePointPalmShinmon?: Array<TenderPoint> | null, sourcePointPalmTaien?: Array<TenderPoint> | null, spinalCurvature?: SpinalCurvature | null, tongueCoating?: TongueCoating | null, scalp?: number | null, user?: { __typename?: 'ComoUser', id: string, name: string } | null, office?: { __typename?: 'Office', id: string, name: string } | null, diagnoses?: Array<{ __typename?: 'Diagnose', id: string, diseaseId?: string | null, priority: number, symptom?: Symptom | null, otherSymptomMemo?: string | null, questionMemo?: string | null, questionSecretMemo?: string | null, symptomCause?: SymptomCause | null, bodyPart?: BodyPart | null, onsetTiming?: OnsetTiming | null, isRelated: boolean, disease?: { __typename?: 'Disease', id: string, name: string } | null, treatmentTherapeuticPoints: Array<{ __typename?: 'TreatmentTherapeuticPoint', id: string, therapeuticPoint?: { __typename?: 'TherapeuticPoint', id: string, name: string, nameFurigana: string } | null }> }> | null } };

export type TreatmentsQueryVariables = Exact<{
  where: TreatmentPatientWhereInput;
}>;


export type TreatmentsQuery = { __typename?: 'Query', treatments: Array<{ __typename?: 'Treatment', id: string, startTime: any, endTime: any, reservationName: string, reservationPhone?: string | null, reservationProgress: number, treatedAt?: any | null, physicalCondition?: number | null, patientMemo?: string | null, visitingPurpose?: VisitingPurpose | null, hasSymptom?: boolean | null, treatmentMemo?: string | null, hasCurrentMedicalHistory?: boolean | null, currentMedicalHistory?: string | null, hasPastMedicalHistory?: boolean | null, pastMedicalHistory?: Array<MedicalHistory> | null, hasFamilyMedicalHistory?: boolean | null, familyMedicalHistory?: Array<MedicalHistory> | null, sleepLength?: number | null, appetite?: number | null, bowelMovement?: number | null, redFlags?: Array<RedFlag> | null, isRed?: boolean | null, yellowFlags?: Array<YellowFlag> | null, isYellow?: boolean | null, testLevel1s?: Array<TestLevel1> | null, symptomArea?: SymptomArea | null, symptomFeelings?: Array<SymptomFeeling> | null, symptomTimings?: Array<SymptomTiming> | null, hasExerciseHabit?: boolean | null, exerciseHabitFrequency?: HabitFrequency | null, healthHabits?: Array<HealthHabit> | null, healthHabitFrequency?: HabitFrequency | null, personality?: Personality | null, hasTabaccoHabit?: HasHabit | null, tabaccoHabitMemo?: string | null, hasAlcoholHabit?: HasHabit | null, alcoholHabitMemo?: string | null, pregnancy?: Pregnancy | null, hasHospitalVisit?: boolean | null, hospitalVisitMemo?: string | null, hasMedication?: boolean | null, medicationMemo?: string | null, hasAcupunctureTreatment?: boolean | null, acupunctureTreatmentMemo?: string | null, totalTreatmentCount: number, isEditing: boolean, isFirst: boolean, therapeuticEffect?: number | null, therapeuticEffectTiming?: TherapeuticEffectTiming | null, satisfaction?: number | null, therapeuticEffectMemo?: string | null, userId: string, officeId: string, patientId?: string | null, tongueShape?: TongueShape | null, antiG1GreaterPectoralMuscle?: Array<TenderPoint> | null, antiG1SternocleidomastoidMuscle?: Array<TenderPoint> | null, antiG1TrapeziusMuscle?: Array<TenderPoint> | null, antiG2Gastrocnemius?: Array<TenderPoint> | null, antiG2Hamstring?: Array<TenderPoint> | null, antiG2Iliopsoas?: Array<TenderPoint> | null, cyanosis?: Cyanosis | null, pulse?: Pulse | null, sourcePointBackHandGoukoku?: Array<TenderPoint> | null, sourcePointBackHandWankotsu?: Array<TenderPoint> | null, sourcePointBackHandYouchi?: Array<TenderPoint> | null, sourcePointInsideFootTaihaku?: Array<TenderPoint> | null, sourcePointInsideFootTaikei?: Array<TenderPoint> | null, sourcePointInsideFootTaishou?: Array<TenderPoint> | null, sourcePointOutsideFootKeikotsu?: Array<TenderPoint> | null, sourcePointOutsideFootKyukyo?: Array<TenderPoint> | null, sourcePointOutsideFootShouyou?: Array<TenderPoint> | null, sourcePointPalmDairyou?: Array<TenderPoint> | null, sourcePointPalmShinmon?: Array<TenderPoint> | null, sourcePointPalmTaien?: Array<TenderPoint> | null, spinalCurvature?: SpinalCurvature | null, tongueCoating?: TongueCoating | null, scalp?: number | null, user?: { __typename?: 'ComoUser', id: string, name: string } | null, office?: { __typename?: 'Office', id: string, name: string } | null, diagnoses?: Array<{ __typename?: 'Diagnose', id: string, diseaseId?: string | null, priority: number, symptom?: Symptom | null, otherSymptomMemo?: string | null, questionMemo?: string | null, questionSecretMemo?: string | null, symptomCause?: SymptomCause | null, bodyPart?: BodyPart | null, onsetTiming?: OnsetTiming | null, isRelated: boolean, disease?: { __typename?: 'Disease', id: string, name: string } | null, treatmentTherapeuticPoints: Array<{ __typename?: 'TreatmentTherapeuticPoint', id: string, therapeuticPoint?: { __typename?: 'TherapeuticPoint', id: string, name: string, nameFurigana: string } | null }> }> | null }> };

export type UserQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, createdAt: any, updatedAt: any, loginedAt?: any | null, name?: string | null, nameFurigana?: string | null, birth?: any | null, sex?: Sex | null, postalCode?: string | null, address?: string | null, height?: string | null, weight?: string | null, phone: string, usingPurpose?: UsingPurpose | null, currentDisease?: CurrentDisease | null, bodyDisorder?: BodyDisorder | null, healthGoal?: HealthGoal | null, password: string, departments: Array<{ __typename?: 'DepartmentsOnUsers', department?: { __typename?: 'Department', id: string, name: string, manager?: { __typename?: 'Manager', name?: string | null } | null } | null }> } };

export type YojyoVideoContentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type YojyoVideoContentQuery = { __typename?: 'Query', yojyoVideoContent: { __typename?: 'YojyoVideoContent', id: string, title: string, file: string, thumbnail: string, description: string, yojyoVideoContentCategory?: { __typename?: 'YojyoVideoContentCategory', title: string } | null } };

export type YojyoVideoContentCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type YojyoVideoContentCategoriesQuery = { __typename?: 'Query', yojyoVideoContentCategories: Array<{ __typename?: 'YojyoVideoContentCategory', id: string, title: string, yojyoVideoContents?: Array<{ __typename?: 'YojyoVideoContent', id: string, title: string, thumbnail: string }> | null }> };

export type YojyomailQueryVariables = Exact<{ [key: string]: never; }>;


export type YojyomailQuery = { __typename?: 'Query', yojyomail: { __typename?: 'Yojyomail', id: string, title: string, content: string, month: number, characteristicL: YomogiProCharacteristicL, ageRange: AgeRange, eyecatch: { __typename?: 'MicroCmsImage', url: string, height: number, width: number }, hashtags: Array<{ __typename?: 'Hashtag', id: string, name: string }> } };

export type YojyomailForShortQueryVariables = Exact<{ [key: string]: never; }>;


export type YojyomailForShortQuery = { __typename?: 'Query', yojyomailForShort: { __typename?: 'Yojyomail', id: string, title: string, content: string, month: number, characteristicL: YomogiProCharacteristicL, ageRange: AgeRange, eyecatch: { __typename?: 'MicroCmsImage', url: string, height: number, width: number }, hashtags: Array<{ __typename?: 'Hashtag', id: string, name: string }> } };

export const ChecklistCoreFragmentDoc = gql`
    fragment ChecklistCore on Checklist {
  id
  createdAt
  updatedAt
  loggedAt
  tandemTime
  bodyStiff
  crouching
  oneFootTime
  calfThickness
  pulse
  tongueColor
  holdBreathTime
  irritated
  angry
  annoyingMood
  outburstAnger
  tiringEasily
  feelingHeavy
  insomnia
  headache
  sad
  lonely
  cry
  depressed
  concentrateWork
  concentrateOneThing
  lackPatience
  difficultThinking
  userId
  user {
    id
    createdAt
    updatedAt
    loginedAt
    name
    nameFurigana
    birth
    sex
    postalCode
    address
    phone
    password
  }
}
    `;
export const ChecklistUpdateFragmentDoc = gql`
    fragment ChecklistUpdate on Checklist {
  id
  loggedAt
  userId
  tandemTime
  bodyStiff
  crouching
  oneFootTime
  calfThickness
  pulse
  tongueColor
  holdBreathTime
  irritated
  angry
  annoyingMood
  outburstAnger
  tiringEasily
  feelingHeavy
  insomnia
  headache
  sad
  lonely
  cry
  depressed
  concentrateWork
  concentrateOneThing
  lackPatience
  difficultThinking
}
    `;
export const DepartmentCoreFragmentDoc = gql`
    fragment DepartmentCore on Department {
  id
  name
}
    `;
export const EcoChecklistCoreFragmentDoc = gql`
    fragment EcoChecklistCore on EcoChecklist {
  id
  createdAt
  updatedAt
  loggedAt
  seasonalFood
  domesticFood
  localFood
  eatingOutFood
  outdoorExercise
  equipmentExercise
  daytimeExercise
  publicTransportUsage
  electronicDeviceUsage
  airConditionerUsage
  indoorHoliday
  userId
  user {
    id
    createdAt
    updatedAt
    loginedAt
    name
    nameFurigana
    birth
    sex
    postalCode
    address
    phone
    password
  }
}
    `;
export const EcoChecklistUpdateFragmentDoc = gql`
    fragment EcoChecklistUpdate on EcoChecklist {
  id
  loggedAt
  userId
  seasonalFood
  domesticFood
  localFood
  eatingOutFood
  outdoorExercise
  equipmentExercise
  daytimeExercise
  publicTransportUsage
  electronicDeviceUsage
  airConditionerUsage
  indoorHoliday
}
    `;
export const EngagementChecklistCoreFragmentDoc = gql`
    fragment EngagementChecklistCore on EngagementChecklist {
  id
  createdAt
  updatedAt
  loggedAt
  uwes1
  uwes2
  uwes3
  bat1
  bat2
  bat3
  bat4
  bat5
  bat6
  bat7
  bat8
  bat9
  bat10
  bat11
  bat12
  bat13
  bat14
  bat15
  bat16
  bat17
  bat18
  bat19
  bat20
  bat21
  bat22
  bat23
  bat24
  bat25
  bat26
  bat27
  bat28
  bat29
  bat30
  bat31
  bat32
  bat33
  req1
  req2
  req3
  req4
  req5
  req6
  req7
  req8
  req9
  req10
  req11
  req12
  req13
  req14
  req15
  req16
  fssb1
  fssb2
  fssb3
  fssb4
  fssb5
  fssb6
  fssb7
  fssb8
  fssb9
  fssb10
  fssb11
  fssb12
  fssb13
  fssb14
  mos1
  mos2
  mos3
  mos4
  mos5
  mos6
  mos7
  mos8
  mos9
  mos10
  mos11
  mos12
  mos13
  mos14
  mos15
  mos16
  mos17
  mos18
  mos19
  mos20
  mos21
  mos22
  mos23
  mos24
  mos25
  mos26
  mos27
  mos28
  mos29
  mos30
  mos31
  mos32
  mos33
  mos34
  mos35
  mos36
  mos37
  mos38
  mos39
  mos40
  mos41
  mos42
  mos43
  mos44
  mos45
  mos46
  mos47
  mos48
  mos49
  mos50
  mos51
  workSpace1
  workSpace2
  userId
  user {
    id
    createdAt
    updatedAt
    loginedAt
    name
    nameFurigana
    birth
    sex
    postalCode
    address
    phone
    password
  }
}
    `;
export const EngagementChecklistUpdateFragmentDoc = gql`
    fragment EngagementChecklistUpdate on EngagementChecklist {
  id
  loggedAt
  userId
  uwes1
  uwes2
  uwes3
  bat1
  bat2
  bat3
  bat4
  bat5
  bat6
  bat7
  bat8
  bat9
  bat10
  bat11
  bat12
  bat13
  bat14
  bat15
  bat16
  bat17
  bat18
  bat19
  bat20
  bat21
  bat22
  bat23
  bat24
  bat25
  bat26
  bat27
  bat28
  bat29
  bat30
  bat31
  bat32
  bat33
  req1
  req2
  req3
  req4
  req5
  req6
  req7
  req8
  req9
  req10
  req11
  req12
  req13
  req14
  req15
  req16
  fssb1
  fssb2
  fssb3
  fssb4
  fssb5
  fssb6
  fssb7
  fssb8
  fssb9
  fssb10
  fssb11
  fssb12
  fssb13
  fssb14
  mos1
  mos2
  mos3
  mos4
  mos5
  mos6
  mos7
  mos8
  mos9
  mos10
  mos11
  mos12
  mos13
  mos14
  mos15
  mos16
  mos17
  mos18
  mos19
  mos20
  mos21
  mos22
  mos23
  mos24
  mos25
  mos26
  mos27
  mos28
  mos29
  mos30
  mos31
  mos32
  mos33
  mos34
  mos35
  mos36
  mos37
  mos38
  mos39
  mos40
  mos41
  mos42
  mos43
  mos44
  mos45
  mos46
  mos47
  mos48
  mos49
  mos50
  mos51
  workSpace1
  workSpace2
}
    `;
export const ExerciseCoreFragmentDoc = gql`
    fragment ExerciseCore on Exercise {
  id
  createdAt
  updatedAt
  placedAt
  name
  exerciseGroupId
  exerciseGroup {
    id
    createdAt
    updatedAt
    name
  }
}
    `;
export const FoodCoreFragmentDoc = gql`
    fragment FoodCore on Food {
  id
  createdAt
  updatedAt
  name
}
    `;
export const LifestyleCoreFragmentDoc = gql`
    fragment LifestyleCore on Lifestyle {
  id
  createdAt
  updatedAt
  loggedAt
  height
  weight
  symptomOnset
  symptom
  symptomMemo
  healthStatus
  fatigue
  feeling
  bedtime
  wakeupTime
  sleepQuality
  sleepDisruption
  dream
  stoolCondition
  duringMenstruation
  menstruationCondition
  lifestyleMemo
  userId
}
    `;
export const LifestyleUpdateFragmentDoc = gql`
    fragment LifestyleUpdate on Lifestyle {
  id
  height
  weight
  symptomOnset
  symptom
  symptomMemo
  healthStatus
  fatigue
  feeling
  bedtime
  wakeupTime
  sleepQuality
  sleepDisruption
  dream
  stoolCondition
  duringMenstruation
  menstruationCondition
  lifestyleMemo
  meals {
    id
    lifestyleId
    mealTiming
    nutrientsOnMeals {
      nutrientIntake
      mealId
      nutrientId
      nutrient {
        id
        name
      }
    }
    foodsOnMeals {
      mealId
      foodId
      food {
        id
        name
      }
    }
    snacksOnMeals {
      mealId
      snackId
      snack {
        id
        name
      }
    }
  }
  exercisesOnLifestyles {
    exerciseAmount
    lifestyleId
    exerciseId
    exercise {
      id
      name
      exerciseGroup {
        id
        name
      }
    }
  }
}
    `;
export const MessageCoreFragmentDoc = gql`
    fragment MessageCore on Message {
  id
  body
  sentBy
  sentAt
  roomId
}
    `;
export const NutrientCoreFragmentDoc = gql`
    fragment NutrientCore on Nutrient {
  id
  createdAt
  updatedAt
  name
}
    `;
export const OkotobaCoreFragmentDoc = gql`
    fragment OkotobaCore on Okotoba {
  id
  title
  content
  eyecatch {
    url
    height
    width
  }
  characteristicL
  healthScoreRange
}
    `;
export const OmikujiCoreFragmentDoc = gql`
    fragment OmikujiCore on Omikuji {
  id
  omikujiNumber
  season
  twentyFourSolarTerms
  totalCondition
  bodyCondition
  mentalCondition
  healthAdvice
  recommendedFood
  recommendedPressurePoint
}
    `;
export const RoomCoreFragmentDoc = gql`
    fragment RoomCore on Room {
  id
  name
  lastMessageBody
  lastMessageSentAt
  participants {
    participantId
    name
    roomId
  }
  messages {
    id
    body
    sentBy
    sentAt
    roomId
  }
}
    `;
export const SnackCoreFragmentDoc = gql`
    fragment SnackCore on Snack {
  id
  createdAt
  updatedAt
  name
}
    `;
export const TreatmentForQueryFragmentDoc = gql`
    fragment TreatmentForQuery on Treatment {
  id
  startTime
  endTime
  reservationName
  reservationPhone
  reservationProgress
  treatedAt
  physicalCondition
  patientMemo
  visitingPurpose
  hasSymptom
  treatmentMemo
  hasCurrentMedicalHistory
  currentMedicalHistory
  hasPastMedicalHistory
  pastMedicalHistory
  hasFamilyMedicalHistory
  familyMedicalHistory
  sleepLength
  appetite
  bowelMovement
  redFlags
  isRed
  yellowFlags
  isYellow
  testLevel1s
  symptomArea
  symptomFeelings
  symptomTimings
  hasExerciseHabit
  exerciseHabitFrequency
  healthHabits
  healthHabitFrequency
  personality
  hasTabaccoHabit
  tabaccoHabitMemo
  hasAlcoholHabit
  alcoholHabitMemo
  pregnancy
  hasHospitalVisit
  hospitalVisitMemo
  hasMedication
  medicationMemo
  hasAcupunctureTreatment
  acupunctureTreatmentMemo
  totalTreatmentCount
  isEditing
  isFirst
  therapeuticEffect
  therapeuticEffectTiming
  satisfaction
  therapeuticEffectMemo
  userId
  officeId
  patientId
  tongueShape
  antiG1GreaterPectoralMuscle
  antiG1SternocleidomastoidMuscle
  antiG1TrapeziusMuscle
  antiG2Gastrocnemius
  antiG2Hamstring
  antiG2Iliopsoas
  cyanosis
  pulse
  sourcePointBackHandGoukoku
  sourcePointBackHandWankotsu
  sourcePointBackHandYouchi
  sourcePointInsideFootTaihaku
  sourcePointInsideFootTaikei
  sourcePointInsideFootTaishou
  sourcePointOutsideFootKeikotsu
  sourcePointOutsideFootKyukyo
  sourcePointOutsideFootShouyou
  sourcePointPalmDairyou
  sourcePointPalmShinmon
  sourcePointPalmTaien
  spinalCurvature
  tongueCoating
  scalp
  user {
    id
    name
  }
  office {
    id
    name
  }
  diagnoses {
    id
    diseaseId
    priority
    symptom
    otherSymptomMemo
    questionMemo
    questionSecretMemo
    symptomCause
    bodyPart
    onsetTiming
    isRelated
    disease {
      id
      name
    }
    treatmentTherapeuticPoints {
      id
      therapeuticPoint {
        id
        name
        nameFurigana
      }
    }
  }
}
    `;
export const UserCoreFragmentDoc = gql`
    fragment UserCore on User {
  id
  createdAt
  updatedAt
  loginedAt
  name
  nameFurigana
  birth
  sex
  postalCode
  address
  height
  weight
  phone
  usingPurpose
  currentDisease
  bodyDisorder
  healthGoal
  password
}
    `;
export const YojyoVideoContentCoreFragmentDoc = gql`
    fragment YojyoVideoContentCore on YojyoVideoContent {
  id
  title
  file
  thumbnail
  description
  yojyoVideoContentCategory {
    title
  }
}
    `;
export const YojyoVideoContentCategoryCoreFragmentDoc = gql`
    fragment YojyoVideoContentCategoryCore on YojyoVideoContentCategory {
  id
  title
  yojyoVideoContents {
    id
    title
    thumbnail
  }
}
    `;
export const UpdateChecklistByDateDocument = gql`
    mutation updateChecklistByDate($input: UpdateChecklistInput!) {
  updateChecklistByDate(input: $input) {
    ...ChecklistUpdate
  }
}
    ${ChecklistUpdateFragmentDoc}`;
export type UpdateChecklistByDateMutationFn = Apollo.MutationFunction<UpdateChecklistByDateMutation, UpdateChecklistByDateMutationVariables>;

/**
 * __useUpdateChecklistByDateMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistByDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistByDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistByDateMutation, { data, loading, error }] = useUpdateChecklistByDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChecklistByDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChecklistByDateMutation, UpdateChecklistByDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChecklistByDateMutation, UpdateChecklistByDateMutationVariables>(UpdateChecklistByDateDocument, options);
      }
export type UpdateChecklistByDateMutationHookResult = ReturnType<typeof useUpdateChecklistByDateMutation>;
export type UpdateChecklistByDateMutationResult = Apollo.MutationResult<UpdateChecklistByDateMutation>;
export type UpdateChecklistByDateMutationOptions = Apollo.BaseMutationOptions<UpdateChecklistByDateMutation, UpdateChecklistByDateMutationVariables>;
export const UpdateChecklistByMonthDocument = gql`
    mutation updateChecklistByMonth($input: UpdateChecklistInput!) {
  updateChecklistByMonth(input: $input) {
    ...ChecklistUpdate
  }
}
    ${ChecklistUpdateFragmentDoc}`;
export type UpdateChecklistByMonthMutationFn = Apollo.MutationFunction<UpdateChecklistByMonthMutation, UpdateChecklistByMonthMutationVariables>;

/**
 * __useUpdateChecklistByMonthMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistByMonthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistByMonthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistByMonthMutation, { data, loading, error }] = useUpdateChecklistByMonthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChecklistByMonthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChecklistByMonthMutation, UpdateChecklistByMonthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChecklistByMonthMutation, UpdateChecklistByMonthMutationVariables>(UpdateChecklistByMonthDocument, options);
      }
export type UpdateChecklistByMonthMutationHookResult = ReturnType<typeof useUpdateChecklistByMonthMutation>;
export type UpdateChecklistByMonthMutationResult = Apollo.MutationResult<UpdateChecklistByMonthMutation>;
export type UpdateChecklistByMonthMutationOptions = Apollo.BaseMutationOptions<UpdateChecklistByMonthMutation, UpdateChecklistByMonthMutationVariables>;
export const CreateDepartmentsOnUsersDocument = gql`
    mutation createDepartmentsOnUsers($input: CreateDepartmentsOnUsersInput!) {
  createDepartmentsOnUsers(input: $input) {
    department {
      id
      name
      manager {
        name
      }
    }
  }
}
    `;
export type CreateDepartmentsOnUsersMutationFn = Apollo.MutationFunction<CreateDepartmentsOnUsersMutation, CreateDepartmentsOnUsersMutationVariables>;

/**
 * __useCreateDepartmentsOnUsersMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentsOnUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentsOnUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartmentsOnUsersMutation, { data, loading, error }] = useCreateDepartmentsOnUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDepartmentsOnUsersMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepartmentsOnUsersMutation, CreateDepartmentsOnUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDepartmentsOnUsersMutation, CreateDepartmentsOnUsersMutationVariables>(CreateDepartmentsOnUsersDocument, options);
      }
export type CreateDepartmentsOnUsersMutationHookResult = ReturnType<typeof useCreateDepartmentsOnUsersMutation>;
export type CreateDepartmentsOnUsersMutationResult = Apollo.MutationResult<CreateDepartmentsOnUsersMutation>;
export type CreateDepartmentsOnUsersMutationOptions = Apollo.BaseMutationOptions<CreateDepartmentsOnUsersMutation, CreateDepartmentsOnUsersMutationVariables>;
export const DeleteDepartmentsOnUsersDocument = gql`
    mutation deleteDepartmentsOnUsers($input: CreateDepartmentsOnUsersInput!) {
  deleteDepartmentsOnUsers(input: $input) {
    departmentId
  }
}
    `;
export type DeleteDepartmentsOnUsersMutationFn = Apollo.MutationFunction<DeleteDepartmentsOnUsersMutation, DeleteDepartmentsOnUsersMutationVariables>;

/**
 * __useDeleteDepartmentsOnUsersMutation__
 *
 * To run a mutation, you first call `useDeleteDepartmentsOnUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDepartmentsOnUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDepartmentsOnUsersMutation, { data, loading, error }] = useDeleteDepartmentsOnUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDepartmentsOnUsersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDepartmentsOnUsersMutation, DeleteDepartmentsOnUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDepartmentsOnUsersMutation, DeleteDepartmentsOnUsersMutationVariables>(DeleteDepartmentsOnUsersDocument, options);
      }
export type DeleteDepartmentsOnUsersMutationHookResult = ReturnType<typeof useDeleteDepartmentsOnUsersMutation>;
export type DeleteDepartmentsOnUsersMutationResult = Apollo.MutationResult<DeleteDepartmentsOnUsersMutation>;
export type DeleteDepartmentsOnUsersMutationOptions = Apollo.BaseMutationOptions<DeleteDepartmentsOnUsersMutation, DeleteDepartmentsOnUsersMutationVariables>;
export const UpdateEcoChecklistByDateDocument = gql`
    mutation updateEcoChecklistByDate($input: UpdateEcoChecklistInput!) {
  updateEcoChecklistByDate(input: $input) {
    ...EcoChecklistUpdate
  }
}
    ${EcoChecklistUpdateFragmentDoc}`;
export type UpdateEcoChecklistByDateMutationFn = Apollo.MutationFunction<UpdateEcoChecklistByDateMutation, UpdateEcoChecklistByDateMutationVariables>;

/**
 * __useUpdateEcoChecklistByDateMutation__
 *
 * To run a mutation, you first call `useUpdateEcoChecklistByDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEcoChecklistByDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEcoChecklistByDateMutation, { data, loading, error }] = useUpdateEcoChecklistByDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEcoChecklistByDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEcoChecklistByDateMutation, UpdateEcoChecklistByDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEcoChecklistByDateMutation, UpdateEcoChecklistByDateMutationVariables>(UpdateEcoChecklistByDateDocument, options);
      }
export type UpdateEcoChecklistByDateMutationHookResult = ReturnType<typeof useUpdateEcoChecklistByDateMutation>;
export type UpdateEcoChecklistByDateMutationResult = Apollo.MutationResult<UpdateEcoChecklistByDateMutation>;
export type UpdateEcoChecklistByDateMutationOptions = Apollo.BaseMutationOptions<UpdateEcoChecklistByDateMutation, UpdateEcoChecklistByDateMutationVariables>;
export const UpdateEcoChecklistByMonthDocument = gql`
    mutation updateEcoChecklistByMonth($input: UpdateEcoChecklistInput!) {
  updateEcoChecklistByMonth(input: $input) {
    ...EcoChecklistUpdate
  }
}
    ${EcoChecklistUpdateFragmentDoc}`;
export type UpdateEcoChecklistByMonthMutationFn = Apollo.MutationFunction<UpdateEcoChecklistByMonthMutation, UpdateEcoChecklistByMonthMutationVariables>;

/**
 * __useUpdateEcoChecklistByMonthMutation__
 *
 * To run a mutation, you first call `useUpdateEcoChecklistByMonthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEcoChecklistByMonthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEcoChecklistByMonthMutation, { data, loading, error }] = useUpdateEcoChecklistByMonthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEcoChecklistByMonthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEcoChecklistByMonthMutation, UpdateEcoChecklistByMonthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEcoChecklistByMonthMutation, UpdateEcoChecklistByMonthMutationVariables>(UpdateEcoChecklistByMonthDocument, options);
      }
export type UpdateEcoChecklistByMonthMutationHookResult = ReturnType<typeof useUpdateEcoChecklistByMonthMutation>;
export type UpdateEcoChecklistByMonthMutationResult = Apollo.MutationResult<UpdateEcoChecklistByMonthMutation>;
export type UpdateEcoChecklistByMonthMutationOptions = Apollo.BaseMutationOptions<UpdateEcoChecklistByMonthMutation, UpdateEcoChecklistByMonthMutationVariables>;
export const UpdateEngagementChecklistDocument = gql`
    mutation updateEngagementChecklist($input: UpdateEngagementChecklistInput!) {
  updateEngagementChecklist(input: $input) {
    ...EngagementChecklistUpdate
  }
}
    ${EngagementChecklistUpdateFragmentDoc}`;
export type UpdateEngagementChecklistMutationFn = Apollo.MutationFunction<UpdateEngagementChecklistMutation, UpdateEngagementChecklistMutationVariables>;

/**
 * __useUpdateEngagementChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementChecklistMutation, { data, loading, error }] = useUpdateEngagementChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEngagementChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEngagementChecklistMutation, UpdateEngagementChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEngagementChecklistMutation, UpdateEngagementChecklistMutationVariables>(UpdateEngagementChecklistDocument, options);
      }
export type UpdateEngagementChecklistMutationHookResult = ReturnType<typeof useUpdateEngagementChecklistMutation>;
export type UpdateEngagementChecklistMutationResult = Apollo.MutationResult<UpdateEngagementChecklistMutation>;
export type UpdateEngagementChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateEngagementChecklistMutation, UpdateEngagementChecklistMutationVariables>;
export const UpdateLifestyleByDateDocument = gql`
    mutation updateLifestyleByDate($input: UpdateLifestyleInput!) {
  updateLifestyleByDate(input: $input) {
    ...LifestyleUpdate
  }
}
    ${LifestyleUpdateFragmentDoc}`;
export type UpdateLifestyleByDateMutationFn = Apollo.MutationFunction<UpdateLifestyleByDateMutation, UpdateLifestyleByDateMutationVariables>;

/**
 * __useUpdateLifestyleByDateMutation__
 *
 * To run a mutation, you first call `useUpdateLifestyleByDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLifestyleByDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLifestyleByDateMutation, { data, loading, error }] = useUpdateLifestyleByDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLifestyleByDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLifestyleByDateMutation, UpdateLifestyleByDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLifestyleByDateMutation, UpdateLifestyleByDateMutationVariables>(UpdateLifestyleByDateDocument, options);
      }
export type UpdateLifestyleByDateMutationHookResult = ReturnType<typeof useUpdateLifestyleByDateMutation>;
export type UpdateLifestyleByDateMutationResult = Apollo.MutationResult<UpdateLifestyleByDateMutation>;
export type UpdateLifestyleByDateMutationOptions = Apollo.BaseMutationOptions<UpdateLifestyleByDateMutation, UpdateLifestyleByDateMutationVariables>;
export const LoginDocument = gql`
    mutation login($input: AuthLoginInput!) {
  login(input: $input) {
    accessToken
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = gql`
    mutation register($input: AuthRegisterInput!) {
  register(input: $input) {
    accessToken
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RequestResetPasswordDocument = gql`
    mutation requestResetPassword($phone: String!) {
  requestResetPassword(phone: $phone) {
    id
    hasRequested
  }
}
    `;
export type RequestResetPasswordMutationFn = Apollo.MutationFunction<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>(RequestResetPasswordDocument, options);
      }
export type RequestResetPasswordMutationHookResult = ReturnType<typeof useRequestResetPasswordMutation>;
export type RequestResetPasswordMutationResult = Apollo.MutationResult<RequestResetPasswordMutation>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;
export const CheckOnetimePasswordDocument = gql`
    mutation checkOnetimePassword($input: CheckOnetimePasswordInput!) {
  checkOnetimePassword(input: $input) {
    isValid
  }
}
    `;
export type CheckOnetimePasswordMutationFn = Apollo.MutationFunction<CheckOnetimePasswordMutation, CheckOnetimePasswordMutationVariables>;

/**
 * __useCheckOnetimePasswordMutation__
 *
 * To run a mutation, you first call `useCheckOnetimePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckOnetimePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkOnetimePasswordMutation, { data, loading, error }] = useCheckOnetimePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckOnetimePasswordMutation(baseOptions?: Apollo.MutationHookOptions<CheckOnetimePasswordMutation, CheckOnetimePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckOnetimePasswordMutation, CheckOnetimePasswordMutationVariables>(CheckOnetimePasswordDocument, options);
      }
export type CheckOnetimePasswordMutationHookResult = ReturnType<typeof useCheckOnetimePasswordMutation>;
export type CheckOnetimePasswordMutationResult = Apollo.MutationResult<CheckOnetimePasswordMutation>;
export type CheckOnetimePasswordMutationOptions = Apollo.BaseMutationOptions<CheckOnetimePasswordMutation, CheckOnetimePasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    accessToken
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const CreateMessageDocument = gql`
    mutation createMessage($input: CreateMessageInput!) {
  createMessage(input: $input) {
    ...MessageCore
  }
}
    ${MessageCoreFragmentDoc}`;
export type CreateMessageMutationFn = Apollo.MutationFunction<CreateMessageMutation, CreateMessageMutationVariables>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageMutation, CreateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument, options);
      }
export type CreateMessageMutationHookResult = ReturnType<typeof useCreateMessageMutation>;
export type CreateMessageMutationResult = Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<CreateMessageMutation, CreateMessageMutationVariables>;
export const CreateSetupIntentDocument = gql`
    mutation createSetupIntent($email: String!) {
  createSetupIntent(email: $email) {
    clientSecret
  }
}
    `;
export type CreateSetupIntentMutationFn = Apollo.MutationFunction<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;

/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(CreateSetupIntentDocument, options);
      }
export type CreateSetupIntentMutationHookResult = ReturnType<typeof useCreateSetupIntentMutation>;
export type CreateSetupIntentMutationResult = Apollo.MutationResult<CreateSetupIntentMutation>;
export type CreateSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;
export const CreateInvoiceDocument = gql`
    mutation createInvoice($priceId: String!, $email: String!) {
  createInvoice(priceId: $priceId, email: $email) {
    clientSecret
    invoiceId
    priceId
  }
}
    `;
export type CreateInvoiceMutationFn = Apollo.MutationFunction<CreateInvoiceMutation, CreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      priceId: // value for 'priceId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument, options);
      }
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = Apollo.MutationResult<CreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const UpdatePaymentMethodDocument = gql`
    mutation updatePaymentMethod {
  updatePaymentMethod
}
    `;
export type UpdatePaymentMethodMutationFn = Apollo.MutationFunction<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>(UpdatePaymentMethodDocument, options);
      }
export type UpdatePaymentMethodMutationHookResult = ReturnType<typeof useUpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationResult = Apollo.MutationResult<UpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ...UserCore
  }
}
    ${UserCoreFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const RemoveUserDocument = gql`
    mutation removeUser($id: ID!) {
  removeUser(id: $id) {
    ...UserCore
  }
}
    ${UserCoreFragmentDoc}`;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const UpdateCompletedYojyoTestIdsDocument = gql`
    mutation updateCompletedYojyoTestIds($input: UpdateCompletedYojyoTestInput!) {
  updateCompletedYojyoTestIds(input: $input)
}
    `;
export type UpdateCompletedYojyoTestIdsMutationFn = Apollo.MutationFunction<UpdateCompletedYojyoTestIdsMutation, UpdateCompletedYojyoTestIdsMutationVariables>;

/**
 * __useUpdateCompletedYojyoTestIdsMutation__
 *
 * To run a mutation, you first call `useUpdateCompletedYojyoTestIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompletedYojyoTestIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompletedYojyoTestIdsMutation, { data, loading, error }] = useUpdateCompletedYojyoTestIdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompletedYojyoTestIdsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompletedYojyoTestIdsMutation, UpdateCompletedYojyoTestIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompletedYojyoTestIdsMutation, UpdateCompletedYojyoTestIdsMutationVariables>(UpdateCompletedYojyoTestIdsDocument, options);
      }
export type UpdateCompletedYojyoTestIdsMutationHookResult = ReturnType<typeof useUpdateCompletedYojyoTestIdsMutation>;
export type UpdateCompletedYojyoTestIdsMutationResult = Apollo.MutationResult<UpdateCompletedYojyoTestIdsMutation>;
export type UpdateCompletedYojyoTestIdsMutationOptions = Apollo.BaseMutationOptions<UpdateCompletedYojyoTestIdsMutation, UpdateCompletedYojyoTestIdsMutationVariables>;
export const UpdateYojyoTestNumberDocument = gql`
    mutation updateYojyoTestNumber($input: UpdateYojyoTestNumberInput!) {
  updateYojyoTestNumber(input: $input)
}
    `;
export type UpdateYojyoTestNumberMutationFn = Apollo.MutationFunction<UpdateYojyoTestNumberMutation, UpdateYojyoTestNumberMutationVariables>;

/**
 * __useUpdateYojyoTestNumberMutation__
 *
 * To run a mutation, you first call `useUpdateYojyoTestNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateYojyoTestNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateYojyoTestNumberMutation, { data, loading, error }] = useUpdateYojyoTestNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateYojyoTestNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateYojyoTestNumberMutation, UpdateYojyoTestNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateYojyoTestNumberMutation, UpdateYojyoTestNumberMutationVariables>(UpdateYojyoTestNumberDocument, options);
      }
export type UpdateYojyoTestNumberMutationHookResult = ReturnType<typeof useUpdateYojyoTestNumberMutation>;
export type UpdateYojyoTestNumberMutationResult = Apollo.MutationResult<UpdateYojyoTestNumberMutation>;
export type UpdateYojyoTestNumberMutationOptions = Apollo.BaseMutationOptions<UpdateYojyoTestNumberMutation, UpdateYojyoTestNumberMutationVariables>;
export const ChecklistByDateDocument = gql`
    query checklistByDate($where: ChecklistWhereDateUniqueInput!) {
  checklistByDate(where: $where) {
    ...ChecklistCore
  }
}
    ${ChecklistCoreFragmentDoc}`;

/**
 * __useChecklistByDateQuery__
 *
 * To run a query within a React component, call `useChecklistByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistByDateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useChecklistByDateQuery(baseOptions: Apollo.QueryHookOptions<ChecklistByDateQuery, ChecklistByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChecklistByDateQuery, ChecklistByDateQueryVariables>(ChecklistByDateDocument, options);
      }
export function useChecklistByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChecklistByDateQuery, ChecklistByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChecklistByDateQuery, ChecklistByDateQueryVariables>(ChecklistByDateDocument, options);
        }
export type ChecklistByDateQueryHookResult = ReturnType<typeof useChecklistByDateQuery>;
export type ChecklistByDateLazyQueryHookResult = ReturnType<typeof useChecklistByDateLazyQuery>;
export type ChecklistByDateQueryResult = Apollo.QueryResult<ChecklistByDateQuery, ChecklistByDateQueryVariables>;
export const ChecklistByMonthDocument = gql`
    query checklistByMonth($where: ChecklistWhereDateUniqueInput!) {
  checklistByMonth(where: $where) {
    ...ChecklistCore
  }
}
    ${ChecklistCoreFragmentDoc}`;

/**
 * __useChecklistByMonthQuery__
 *
 * To run a query within a React component, call `useChecklistByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistByMonthQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useChecklistByMonthQuery(baseOptions: Apollo.QueryHookOptions<ChecklistByMonthQuery, ChecklistByMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChecklistByMonthQuery, ChecklistByMonthQueryVariables>(ChecklistByMonthDocument, options);
      }
export function useChecklistByMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChecklistByMonthQuery, ChecklistByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChecklistByMonthQuery, ChecklistByMonthQueryVariables>(ChecklistByMonthDocument, options);
        }
export type ChecklistByMonthQueryHookResult = ReturnType<typeof useChecklistByMonthQuery>;
export type ChecklistByMonthLazyQueryHookResult = ReturnType<typeof useChecklistByMonthLazyQuery>;
export type ChecklistByMonthQueryResult = Apollo.QueryResult<ChecklistByMonthQuery, ChecklistByMonthQueryVariables>;
export const KokokaraDocument = gql`
    query kokokara($where: ChecklistWhereUniqueInput!) {
  kokokara(where: $where) {
    scores {
      label
      data
      characteristicL
      characteristicS
    }
    totalScore
    characteristicL
    characteristicS
    checklistId
  }
}
    `;

/**
 * __useKokokaraQuery__
 *
 * To run a query within a React component, call `useKokokaraQuery` and pass it any options that fit your needs.
 * When your component renders, `useKokokaraQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKokokaraQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useKokokaraQuery(baseOptions: Apollo.QueryHookOptions<KokokaraQuery, KokokaraQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KokokaraQuery, KokokaraQueryVariables>(KokokaraDocument, options);
      }
export function useKokokaraLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KokokaraQuery, KokokaraQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KokokaraQuery, KokokaraQueryVariables>(KokokaraDocument, options);
        }
export type KokokaraQueryHookResult = ReturnType<typeof useKokokaraQuery>;
export type KokokaraLazyQueryHookResult = ReturnType<typeof useKokokaraLazyQuery>;
export type KokokaraQueryResult = Apollo.QueryResult<KokokaraQuery, KokokaraQueryVariables>;
export const KokokaraForShortDocument = gql`
    query kokokaraForShort($where: ChecklistWhereUniqueInput!) {
  kokokaraForShort(where: $where) {
    scores {
      label
      data
      characteristicL
      characteristicS
    }
    totalScore
    characteristicL
    characteristicS
    checklistId
  }
}
    `;

/**
 * __useKokokaraForShortQuery__
 *
 * To run a query within a React component, call `useKokokaraForShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useKokokaraForShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKokokaraForShortQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useKokokaraForShortQuery(baseOptions: Apollo.QueryHookOptions<KokokaraForShortQuery, KokokaraForShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KokokaraForShortQuery, KokokaraForShortQueryVariables>(KokokaraForShortDocument, options);
      }
export function useKokokaraForShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KokokaraForShortQuery, KokokaraForShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KokokaraForShortQuery, KokokaraForShortQueryVariables>(KokokaraForShortDocument, options);
        }
export type KokokaraForShortQueryHookResult = ReturnType<typeof useKokokaraForShortQuery>;
export type KokokaraForShortLazyQueryHookResult = ReturnType<typeof useKokokaraForShortLazyQuery>;
export type KokokaraForShortQueryResult = Apollo.QueryResult<KokokaraForShortQuery, KokokaraForShortQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    id
    createdAt
    updatedAt
    loginedAt
    name
    nameFurigana
    height
    weight
    birth
    sex
    postalCode
    address
    phone
    password
    comoId
    completedYojyoLicenseTestIds
    hadYojyoLicenseTestAt
    yojyoLicenseTestNumber
    completedYojyoInstructorTestIds
    hadYojyoInstructorTestAt
    yojyoInstructorTestNumber
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const DepartmentByInvitationCodeDocument = gql`
    query departmentByInvitationCode($where: FindDepartmentByInvitationCodeWhereInput!) {
  departmentByInvitationCode(where: $where) {
    ...DepartmentCore
    manager {
      name
    }
  }
}
    ${DepartmentCoreFragmentDoc}`;

/**
 * __useDepartmentByInvitationCodeQuery__
 *
 * To run a query within a React component, call `useDepartmentByInvitationCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentByInvitationCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentByInvitationCodeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDepartmentByInvitationCodeQuery(baseOptions: Apollo.QueryHookOptions<DepartmentByInvitationCodeQuery, DepartmentByInvitationCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepartmentByInvitationCodeQuery, DepartmentByInvitationCodeQueryVariables>(DepartmentByInvitationCodeDocument, options);
      }
export function useDepartmentByInvitationCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepartmentByInvitationCodeQuery, DepartmentByInvitationCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepartmentByInvitationCodeQuery, DepartmentByInvitationCodeQueryVariables>(DepartmentByInvitationCodeDocument, options);
        }
export type DepartmentByInvitationCodeQueryHookResult = ReturnType<typeof useDepartmentByInvitationCodeQuery>;
export type DepartmentByInvitationCodeLazyQueryHookResult = ReturnType<typeof useDepartmentByInvitationCodeLazyQuery>;
export type DepartmentByInvitationCodeQueryResult = Apollo.QueryResult<DepartmentByInvitationCodeQuery, DepartmentByInvitationCodeQueryVariables>;
export const EcoChecklistByDateDocument = gql`
    query ecoChecklistByDate($where: EcoChecklistWhereDateUniqueInput!) {
  ecoChecklistByDate(where: $where) {
    ...EcoChecklistCore
  }
}
    ${EcoChecklistCoreFragmentDoc}`;

/**
 * __useEcoChecklistByDateQuery__
 *
 * To run a query within a React component, call `useEcoChecklistByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcoChecklistByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcoChecklistByDateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEcoChecklistByDateQuery(baseOptions: Apollo.QueryHookOptions<EcoChecklistByDateQuery, EcoChecklistByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EcoChecklistByDateQuery, EcoChecklistByDateQueryVariables>(EcoChecklistByDateDocument, options);
      }
export function useEcoChecklistByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EcoChecklistByDateQuery, EcoChecklistByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EcoChecklistByDateQuery, EcoChecklistByDateQueryVariables>(EcoChecklistByDateDocument, options);
        }
export type EcoChecklistByDateQueryHookResult = ReturnType<typeof useEcoChecklistByDateQuery>;
export type EcoChecklistByDateLazyQueryHookResult = ReturnType<typeof useEcoChecklistByDateLazyQuery>;
export type EcoChecklistByDateQueryResult = Apollo.QueryResult<EcoChecklistByDateQuery, EcoChecklistByDateQueryVariables>;
export const EcoChecklistByMonthDocument = gql`
    query ecoChecklistByMonth($where: EcoChecklistWhereDateUniqueInput!) {
  ecoChecklistByMonth(where: $where) {
    ...EcoChecklistCore
  }
}
    ${EcoChecklistCoreFragmentDoc}`;

/**
 * __useEcoChecklistByMonthQuery__
 *
 * To run a query within a React component, call `useEcoChecklistByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcoChecklistByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcoChecklistByMonthQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEcoChecklistByMonthQuery(baseOptions: Apollo.QueryHookOptions<EcoChecklistByMonthQuery, EcoChecklistByMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EcoChecklistByMonthQuery, EcoChecklistByMonthQueryVariables>(EcoChecklistByMonthDocument, options);
      }
export function useEcoChecklistByMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EcoChecklistByMonthQuery, EcoChecklistByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EcoChecklistByMonthQuery, EcoChecklistByMonthQueryVariables>(EcoChecklistByMonthDocument, options);
        }
export type EcoChecklistByMonthQueryHookResult = ReturnType<typeof useEcoChecklistByMonthQuery>;
export type EcoChecklistByMonthLazyQueryHookResult = ReturnType<typeof useEcoChecklistByMonthLazyQuery>;
export type EcoChecklistByMonthQueryResult = Apollo.QueryResult<EcoChecklistByMonthQuery, EcoChecklistByMonthQueryVariables>;
export const EcoChecklistScoreByMonthDocument = gql`
    query ecoChecklistScoreByMonth($where: EcoChecklistWhereUniqueInput!) {
  ecoChecklistScoreByMonth(where: $where) {
    scores {
      label
      data
    }
    totalScore
  }
}
    `;

/**
 * __useEcoChecklistScoreByMonthQuery__
 *
 * To run a query within a React component, call `useEcoChecklistScoreByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcoChecklistScoreByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcoChecklistScoreByMonthQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEcoChecklistScoreByMonthQuery(baseOptions: Apollo.QueryHookOptions<EcoChecklistScoreByMonthQuery, EcoChecklistScoreByMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EcoChecklistScoreByMonthQuery, EcoChecklistScoreByMonthQueryVariables>(EcoChecklistScoreByMonthDocument, options);
      }
export function useEcoChecklistScoreByMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EcoChecklistScoreByMonthQuery, EcoChecklistScoreByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EcoChecklistScoreByMonthQuery, EcoChecklistScoreByMonthQueryVariables>(EcoChecklistScoreByMonthDocument, options);
        }
export type EcoChecklistScoreByMonthQueryHookResult = ReturnType<typeof useEcoChecklistScoreByMonthQuery>;
export type EcoChecklistScoreByMonthLazyQueryHookResult = ReturnType<typeof useEcoChecklistScoreByMonthLazyQuery>;
export type EcoChecklistScoreByMonthQueryResult = Apollo.QueryResult<EcoChecklistScoreByMonthQuery, EcoChecklistScoreByMonthQueryVariables>;
export const EngagementChecklistDocument = gql`
    query engagementChecklist($where: EngagementChecklistWhereDateUniqueInput!) {
  engagementChecklist(where: $where) {
    ...EngagementChecklistCore
  }
}
    ${EngagementChecklistCoreFragmentDoc}`;

/**
 * __useEngagementChecklistQuery__
 *
 * To run a query within a React component, call `useEngagementChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementChecklistQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEngagementChecklistQuery(baseOptions: Apollo.QueryHookOptions<EngagementChecklistQuery, EngagementChecklistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementChecklistQuery, EngagementChecklistQueryVariables>(EngagementChecklistDocument, options);
      }
export function useEngagementChecklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementChecklistQuery, EngagementChecklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementChecklistQuery, EngagementChecklistQueryVariables>(EngagementChecklistDocument, options);
        }
export type EngagementChecklistQueryHookResult = ReturnType<typeof useEngagementChecklistQuery>;
export type EngagementChecklistLazyQueryHookResult = ReturnType<typeof useEngagementChecklistLazyQuery>;
export type EngagementChecklistQueryResult = Apollo.QueryResult<EngagementChecklistQuery, EngagementChecklistQueryVariables>;
export const EngagementChecklistScoreDocument = gql`
    query engagementChecklistScore($where: EngagementChecklistWhereUniqueInput!) {
  engagementChecklistScore(where: $where) {
    scores {
      label
      data
    }
    totalScore
  }
}
    `;

/**
 * __useEngagementChecklistScoreQuery__
 *
 * To run a query within a React component, call `useEngagementChecklistScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementChecklistScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementChecklistScoreQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEngagementChecklistScoreQuery(baseOptions: Apollo.QueryHookOptions<EngagementChecklistScoreQuery, EngagementChecklistScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementChecklistScoreQuery, EngagementChecklistScoreQueryVariables>(EngagementChecklistScoreDocument, options);
      }
export function useEngagementChecklistScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementChecklistScoreQuery, EngagementChecklistScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementChecklistScoreQuery, EngagementChecklistScoreQueryVariables>(EngagementChecklistScoreDocument, options);
        }
export type EngagementChecklistScoreQueryHookResult = ReturnType<typeof useEngagementChecklistScoreQuery>;
export type EngagementChecklistScoreLazyQueryHookResult = ReturnType<typeof useEngagementChecklistScoreLazyQuery>;
export type EngagementChecklistScoreQueryResult = Apollo.QueryResult<EngagementChecklistScoreQuery, EngagementChecklistScoreQueryVariables>;
export const ExercisesDocument = gql`
    query exercises {
  exercises {
    ...ExerciseCore
  }
}
    ${ExerciseCoreFragmentDoc}`;

/**
 * __useExercisesQuery__
 *
 * To run a query within a React component, call `useExercisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExercisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExercisesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExercisesQuery(baseOptions?: Apollo.QueryHookOptions<ExercisesQuery, ExercisesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExercisesQuery, ExercisesQueryVariables>(ExercisesDocument, options);
      }
export function useExercisesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExercisesQuery, ExercisesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExercisesQuery, ExercisesQueryVariables>(ExercisesDocument, options);
        }
export type ExercisesQueryHookResult = ReturnType<typeof useExercisesQuery>;
export type ExercisesLazyQueryHookResult = ReturnType<typeof useExercisesLazyQuery>;
export type ExercisesQueryResult = Apollo.QueryResult<ExercisesQuery, ExercisesQueryVariables>;
export const FoodsDocument = gql`
    query foods {
  foods {
    ...FoodCore
  }
}
    ${FoodCoreFragmentDoc}`;

/**
 * __useFoodsQuery__
 *
 * To run a query within a React component, call `useFoodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFoodsQuery(baseOptions?: Apollo.QueryHookOptions<FoodsQuery, FoodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FoodsQuery, FoodsQueryVariables>(FoodsDocument, options);
      }
export function useFoodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FoodsQuery, FoodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FoodsQuery, FoodsQueryVariables>(FoodsDocument, options);
        }
export type FoodsQueryHookResult = ReturnType<typeof useFoodsQuery>;
export type FoodsLazyQueryHookResult = ReturnType<typeof useFoodsLazyQuery>;
export type FoodsQueryResult = Apollo.QueryResult<FoodsQuery, FoodsQueryVariables>;
export const GenerateYojyoVideoContentSignedUrlDocument = gql`
    query generateYojyoVideoContentSignedUrl($id: String!) {
  generateYojyoVideoContentSignedUrl(id: $id) {
    ... on SignedUrl {
      url
    }
  }
}
    `;

/**
 * __useGenerateYojyoVideoContentSignedUrlQuery__
 *
 * To run a query within a React component, call `useGenerateYojyoVideoContentSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateYojyoVideoContentSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateYojyoVideoContentSignedUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateYojyoVideoContentSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GenerateYojyoVideoContentSignedUrlQuery, GenerateYojyoVideoContentSignedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateYojyoVideoContentSignedUrlQuery, GenerateYojyoVideoContentSignedUrlQueryVariables>(GenerateYojyoVideoContentSignedUrlDocument, options);
      }
export function useGenerateYojyoVideoContentSignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateYojyoVideoContentSignedUrlQuery, GenerateYojyoVideoContentSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateYojyoVideoContentSignedUrlQuery, GenerateYojyoVideoContentSignedUrlQueryVariables>(GenerateYojyoVideoContentSignedUrlDocument, options);
        }
export type GenerateYojyoVideoContentSignedUrlQueryHookResult = ReturnType<typeof useGenerateYojyoVideoContentSignedUrlQuery>;
export type GenerateYojyoVideoContentSignedUrlLazyQueryHookResult = ReturnType<typeof useGenerateYojyoVideoContentSignedUrlLazyQuery>;
export type GenerateYojyoVideoContentSignedUrlQueryResult = Apollo.QueryResult<GenerateYojyoVideoContentSignedUrlQuery, GenerateYojyoVideoContentSignedUrlQueryVariables>;
export const LicenseYojyoTestsDocument = gql`
    query licenseYojyoTests($where: LicenseTestWhereInput!) {
  licenseYojyoTests(where: $where) {
    id
    question
    choice
    answer
    explanation
    licenseType
    licenseTestContentId
  }
}
    `;

/**
 * __useLicenseYojyoTestsQuery__
 *
 * To run a query within a React component, call `useLicenseYojyoTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseYojyoTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseYojyoTestsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLicenseYojyoTestsQuery(baseOptions: Apollo.QueryHookOptions<LicenseYojyoTestsQuery, LicenseYojyoTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicenseYojyoTestsQuery, LicenseYojyoTestsQueryVariables>(LicenseYojyoTestsDocument, options);
      }
export function useLicenseYojyoTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicenseYojyoTestsQuery, LicenseYojyoTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicenseYojyoTestsQuery, LicenseYojyoTestsQueryVariables>(LicenseYojyoTestsDocument, options);
        }
export type LicenseYojyoTestsQueryHookResult = ReturnType<typeof useLicenseYojyoTestsQuery>;
export type LicenseYojyoTestsLazyQueryHookResult = ReturnType<typeof useLicenseYojyoTestsLazyQuery>;
export type LicenseYojyoTestsQueryResult = Apollo.QueryResult<LicenseYojyoTestsQuery, LicenseYojyoTestsQueryVariables>;
export const LicenseYojyoTestContentDocument = gql`
    query licenseYojyoTestContent($id: String!) {
  licenseYojyoTestContent(id: $id) {
    id
    title
    description
    file
    thumbnail
    placedAt
    licenseType
  }
}
    `;

/**
 * __useLicenseYojyoTestContentQuery__
 *
 * To run a query within a React component, call `useLicenseYojyoTestContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseYojyoTestContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseYojyoTestContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLicenseYojyoTestContentQuery(baseOptions: Apollo.QueryHookOptions<LicenseYojyoTestContentQuery, LicenseYojyoTestContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicenseYojyoTestContentQuery, LicenseYojyoTestContentQueryVariables>(LicenseYojyoTestContentDocument, options);
      }
export function useLicenseYojyoTestContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicenseYojyoTestContentQuery, LicenseYojyoTestContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicenseYojyoTestContentQuery, LicenseYojyoTestContentQueryVariables>(LicenseYojyoTestContentDocument, options);
        }
export type LicenseYojyoTestContentQueryHookResult = ReturnType<typeof useLicenseYojyoTestContentQuery>;
export type LicenseYojyoTestContentLazyQueryHookResult = ReturnType<typeof useLicenseYojyoTestContentLazyQuery>;
export type LicenseYojyoTestContentQueryResult = Apollo.QueryResult<LicenseYojyoTestContentQuery, LicenseYojyoTestContentQueryVariables>;
export const LicenseYojyoTestContentsDocument = gql`
    query licenseYojyoTestContents($licenseType: String!) {
  licenseYojyoTestContents(licenseType: $licenseType) {
    id
    title
    description
    file
    thumbnail
    placedAt
    licenseType
  }
}
    `;

/**
 * __useLicenseYojyoTestContentsQuery__
 *
 * To run a query within a React component, call `useLicenseYojyoTestContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseYojyoTestContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseYojyoTestContentsQuery({
 *   variables: {
 *      licenseType: // value for 'licenseType'
 *   },
 * });
 */
export function useLicenseYojyoTestContentsQuery(baseOptions: Apollo.QueryHookOptions<LicenseYojyoTestContentsQuery, LicenseYojyoTestContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicenseYojyoTestContentsQuery, LicenseYojyoTestContentsQueryVariables>(LicenseYojyoTestContentsDocument, options);
      }
export function useLicenseYojyoTestContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicenseYojyoTestContentsQuery, LicenseYojyoTestContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicenseYojyoTestContentsQuery, LicenseYojyoTestContentsQueryVariables>(LicenseYojyoTestContentsDocument, options);
        }
export type LicenseYojyoTestContentsQueryHookResult = ReturnType<typeof useLicenseYojyoTestContentsQuery>;
export type LicenseYojyoTestContentsLazyQueryHookResult = ReturnType<typeof useLicenseYojyoTestContentsLazyQuery>;
export type LicenseYojyoTestContentsQueryResult = Apollo.QueryResult<LicenseYojyoTestContentsQuery, LicenseYojyoTestContentsQueryVariables>;
export const GenerateLicenseYojyoTestContentsSignedUrlDocument = gql`
    query generateLicenseYojyoTestContentsSignedUrl($id: String!) {
  generateLicenseYojyoTestContentsSignedUrl(id: $id)
}
    `;

/**
 * __useGenerateLicenseYojyoTestContentsSignedUrlQuery__
 *
 * To run a query within a React component, call `useGenerateLicenseYojyoTestContentsSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateLicenseYojyoTestContentsSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateLicenseYojyoTestContentsSignedUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateLicenseYojyoTestContentsSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GenerateLicenseYojyoTestContentsSignedUrlQuery, GenerateLicenseYojyoTestContentsSignedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateLicenseYojyoTestContentsSignedUrlQuery, GenerateLicenseYojyoTestContentsSignedUrlQueryVariables>(GenerateLicenseYojyoTestContentsSignedUrlDocument, options);
      }
export function useGenerateLicenseYojyoTestContentsSignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateLicenseYojyoTestContentsSignedUrlQuery, GenerateLicenseYojyoTestContentsSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateLicenseYojyoTestContentsSignedUrlQuery, GenerateLicenseYojyoTestContentsSignedUrlQueryVariables>(GenerateLicenseYojyoTestContentsSignedUrlDocument, options);
        }
export type GenerateLicenseYojyoTestContentsSignedUrlQueryHookResult = ReturnType<typeof useGenerateLicenseYojyoTestContentsSignedUrlQuery>;
export type GenerateLicenseYojyoTestContentsSignedUrlLazyQueryHookResult = ReturnType<typeof useGenerateLicenseYojyoTestContentsSignedUrlLazyQuery>;
export type GenerateLicenseYojyoTestContentsSignedUrlQueryResult = Apollo.QueryResult<GenerateLicenseYojyoTestContentsSignedUrlQuery, GenerateLicenseYojyoTestContentsSignedUrlQueryVariables>;
export const LifestyleByDateDocument = gql`
    query lifestyleByDate($where: LifestyleWhereDateUniqueInput!) {
  lifestyleByDate(where: $where) {
    ...LifestyleCore
    ...LifestyleUpdate
  }
}
    ${LifestyleCoreFragmentDoc}
${LifestyleUpdateFragmentDoc}`;

/**
 * __useLifestyleByDateQuery__
 *
 * To run a query within a React component, call `useLifestyleByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifestyleByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifestyleByDateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLifestyleByDateQuery(baseOptions: Apollo.QueryHookOptions<LifestyleByDateQuery, LifestyleByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifestyleByDateQuery, LifestyleByDateQueryVariables>(LifestyleByDateDocument, options);
      }
export function useLifestyleByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifestyleByDateQuery, LifestyleByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifestyleByDateQuery, LifestyleByDateQueryVariables>(LifestyleByDateDocument, options);
        }
export type LifestyleByDateQueryHookResult = ReturnType<typeof useLifestyleByDateQuery>;
export type LifestyleByDateLazyQueryHookResult = ReturnType<typeof useLifestyleByDateLazyQuery>;
export type LifestyleByDateQueryResult = Apollo.QueryResult<LifestyleByDateQuery, LifestyleByDateQueryVariables>;
export const LifestylesByUserIdDocument = gql`
    query lifestylesByUserId($where: LifestyleByUserIdWhereUniqueInput!) {
  lifestylesByUserId(where: $where) {
    ...LifestyleCore
    ...LifestyleUpdate
  }
}
    ${LifestyleCoreFragmentDoc}
${LifestyleUpdateFragmentDoc}`;

/**
 * __useLifestylesByUserIdQuery__
 *
 * To run a query within a React component, call `useLifestylesByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifestylesByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifestylesByUserIdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLifestylesByUserIdQuery(baseOptions: Apollo.QueryHookOptions<LifestylesByUserIdQuery, LifestylesByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifestylesByUserIdQuery, LifestylesByUserIdQueryVariables>(LifestylesByUserIdDocument, options);
      }
export function useLifestylesByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifestylesByUserIdQuery, LifestylesByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifestylesByUserIdQuery, LifestylesByUserIdQueryVariables>(LifestylesByUserIdDocument, options);
        }
export type LifestylesByUserIdQueryHookResult = ReturnType<typeof useLifestylesByUserIdQuery>;
export type LifestylesByUserIdLazyQueryHookResult = ReturnType<typeof useLifestylesByUserIdLazyQuery>;
export type LifestylesByUserIdQueryResult = Apollo.QueryResult<LifestylesByUserIdQuery, LifestylesByUserIdQueryVariables>;
export const LifestyleScoreByDateDocument = gql`
    query lifestyleScoreByDate($where: LifestyleWhereDateUniqueInput!) {
  lifestyleScoreByDate(where: $where) {
    scores {
      label
      data
    }
    totalScore
  }
}
    `;

/**
 * __useLifestyleScoreByDateQuery__
 *
 * To run a query within a React component, call `useLifestyleScoreByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifestyleScoreByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifestyleScoreByDateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLifestyleScoreByDateQuery(baseOptions: Apollo.QueryHookOptions<LifestyleScoreByDateQuery, LifestyleScoreByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifestyleScoreByDateQuery, LifestyleScoreByDateQueryVariables>(LifestyleScoreByDateDocument, options);
      }
export function useLifestyleScoreByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifestyleScoreByDateQuery, LifestyleScoreByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifestyleScoreByDateQuery, LifestyleScoreByDateQueryVariables>(LifestyleScoreByDateDocument, options);
        }
export type LifestyleScoreByDateQueryHookResult = ReturnType<typeof useLifestyleScoreByDateQuery>;
export type LifestyleScoreByDateLazyQueryHookResult = ReturnType<typeof useLifestyleScoreByDateLazyQuery>;
export type LifestyleScoreByDateQueryResult = Apollo.QueryResult<LifestyleScoreByDateQuery, LifestyleScoreByDateQueryVariables>;
export const NutrientsDocument = gql`
    query nutrients {
  nutrients {
    ...NutrientCore
  }
}
    ${NutrientCoreFragmentDoc}`;

/**
 * __useNutrientsQuery__
 *
 * To run a query within a React component, call `useNutrientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutrientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutrientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNutrientsQuery(baseOptions?: Apollo.QueryHookOptions<NutrientsQuery, NutrientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NutrientsQuery, NutrientsQueryVariables>(NutrientsDocument, options);
      }
export function useNutrientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NutrientsQuery, NutrientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NutrientsQuery, NutrientsQueryVariables>(NutrientsDocument, options);
        }
export type NutrientsQueryHookResult = ReturnType<typeof useNutrientsQuery>;
export type NutrientsLazyQueryHookResult = ReturnType<typeof useNutrientsLazyQuery>;
export type NutrientsQueryResult = Apollo.QueryResult<NutrientsQuery, NutrientsQueryVariables>;
export const OkotobaDocument = gql`
    query okotoba {
  okotoba {
    ...OkotobaCore
  }
}
    ${OkotobaCoreFragmentDoc}`;

/**
 * __useOkotobaQuery__
 *
 * To run a query within a React component, call `useOkotobaQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkotobaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkotobaQuery({
 *   variables: {
 *   },
 * });
 */
export function useOkotobaQuery(baseOptions?: Apollo.QueryHookOptions<OkotobaQuery, OkotobaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OkotobaQuery, OkotobaQueryVariables>(OkotobaDocument, options);
      }
export function useOkotobaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OkotobaQuery, OkotobaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OkotobaQuery, OkotobaQueryVariables>(OkotobaDocument, options);
        }
export type OkotobaQueryHookResult = ReturnType<typeof useOkotobaQuery>;
export type OkotobaLazyQueryHookResult = ReturnType<typeof useOkotobaLazyQuery>;
export type OkotobaQueryResult = Apollo.QueryResult<OkotobaQuery, OkotobaQueryVariables>;
export const OkotobaForShortDocument = gql`
    query okotobaForShort {
  okotobaForShort {
    ...OkotobaCore
  }
}
    ${OkotobaCoreFragmentDoc}`;

/**
 * __useOkotobaForShortQuery__
 *
 * To run a query within a React component, call `useOkotobaForShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkotobaForShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkotobaForShortQuery({
 *   variables: {
 *   },
 * });
 */
export function useOkotobaForShortQuery(baseOptions?: Apollo.QueryHookOptions<OkotobaForShortQuery, OkotobaForShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OkotobaForShortQuery, OkotobaForShortQueryVariables>(OkotobaForShortDocument, options);
      }
export function useOkotobaForShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OkotobaForShortQuery, OkotobaForShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OkotobaForShortQuery, OkotobaForShortQueryVariables>(OkotobaForShortDocument, options);
        }
export type OkotobaForShortQueryHookResult = ReturnType<typeof useOkotobaForShortQuery>;
export type OkotobaForShortLazyQueryHookResult = ReturnType<typeof useOkotobaForShortLazyQuery>;
export type OkotobaForShortQueryResult = Apollo.QueryResult<OkotobaForShortQuery, OkotobaForShortQueryVariables>;
export const RandomOmikujiDocument = gql`
    query randomOmikuji {
  randomOmikuji {
    ...OmikujiCore
  }
}
    ${OmikujiCoreFragmentDoc}`;

/**
 * __useRandomOmikujiQuery__
 *
 * To run a query within a React component, call `useRandomOmikujiQuery` and pass it any options that fit your needs.
 * When your component renders, `useRandomOmikujiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRandomOmikujiQuery({
 *   variables: {
 *   },
 * });
 */
export function useRandomOmikujiQuery(baseOptions?: Apollo.QueryHookOptions<RandomOmikujiQuery, RandomOmikujiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RandomOmikujiQuery, RandomOmikujiQueryVariables>(RandomOmikujiDocument, options);
      }
export function useRandomOmikujiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RandomOmikujiQuery, RandomOmikujiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RandomOmikujiQuery, RandomOmikujiQueryVariables>(RandomOmikujiDocument, options);
        }
export type RandomOmikujiQueryHookResult = ReturnType<typeof useRandomOmikujiQuery>;
export type RandomOmikujiLazyQueryHookResult = ReturnType<typeof useRandomOmikujiLazyQuery>;
export type RandomOmikujiQueryResult = Apollo.QueryResult<RandomOmikujiQuery, RandomOmikujiQueryVariables>;
export const PaymentMethodsDocument = gql`
    query paymentMethods {
  paymentMethods {
    id
    card {
      brand
      expMonth
      expYear
      last4
    }
  }
}
    `;

/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
      }
export function usePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
        }
export type PaymentMethodsQueryHookResult = ReturnType<typeof usePaymentMethodsQuery>;
export type PaymentMethodsLazyQueryHookResult = ReturnType<typeof usePaymentMethodsLazyQuery>;
export type PaymentMethodsQueryResult = Apollo.QueryResult<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const InvoiceStatusDocument = gql`
    query invoiceStatus {
  invoiceStatus {
    id
    createdAt
    updatedAt
    priceId
    invoiceId
    userId
    yomogiId
  }
}
    `;

/**
 * __useInvoiceStatusQuery__
 *
 * To run a query within a React component, call `useInvoiceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvoiceStatusQuery(baseOptions?: Apollo.QueryHookOptions<InvoiceStatusQuery, InvoiceStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceStatusQuery, InvoiceStatusQueryVariables>(InvoiceStatusDocument, options);
      }
export function useInvoiceStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceStatusQuery, InvoiceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceStatusQuery, InvoiceStatusQueryVariables>(InvoiceStatusDocument, options);
        }
export type InvoiceStatusQueryHookResult = ReturnType<typeof useInvoiceStatusQuery>;
export type InvoiceStatusLazyQueryHookResult = ReturnType<typeof useInvoiceStatusLazyQuery>;
export type InvoiceStatusQueryResult = Apollo.QueryResult<InvoiceStatusQuery, InvoiceStatusQueryVariables>;
export const RoomDocument = gql`
    query room($where: RoomWhereUniqueInput!) {
  room(where: $where) {
    ...RoomCore
  }
}
    ${RoomCoreFragmentDoc}`;

/**
 * __useRoomQuery__
 *
 * To run a query within a React component, call `useRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRoomQuery(baseOptions: Apollo.QueryHookOptions<RoomQuery, RoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomQuery, RoomQueryVariables>(RoomDocument, options);
      }
export function useRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomQuery, RoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomQuery, RoomQueryVariables>(RoomDocument, options);
        }
export type RoomQueryHookResult = ReturnType<typeof useRoomQuery>;
export type RoomLazyQueryHookResult = ReturnType<typeof useRoomLazyQuery>;
export type RoomQueryResult = Apollo.QueryResult<RoomQuery, RoomQueryVariables>;
export const RoomsDocument = gql`
    query rooms {
  rooms {
    ...RoomCore
  }
}
    ${RoomCoreFragmentDoc}`;

/**
 * __useRoomsQuery__
 *
 * To run a query within a React component, call `useRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoomsQuery(baseOptions?: Apollo.QueryHookOptions<RoomsQuery, RoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomsQuery, RoomsQueryVariables>(RoomsDocument, options);
      }
export function useRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomsQuery, RoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomsQuery, RoomsQueryVariables>(RoomsDocument, options);
        }
export type RoomsQueryHookResult = ReturnType<typeof useRoomsQuery>;
export type RoomsLazyQueryHookResult = ReturnType<typeof useRoomsLazyQuery>;
export type RoomsQueryResult = Apollo.QueryResult<RoomsQuery, RoomsQueryVariables>;
export const SnacksDocument = gql`
    query snacks {
  snacks {
    ...SnackCore
  }
}
    ${SnackCoreFragmentDoc}`;

/**
 * __useSnacksQuery__
 *
 * To run a query within a React component, call `useSnacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnacksQuery({
 *   variables: {
 *   },
 * });
 */
export function useSnacksQuery(baseOptions?: Apollo.QueryHookOptions<SnacksQuery, SnacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnacksQuery, SnacksQueryVariables>(SnacksDocument, options);
      }
export function useSnacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnacksQuery, SnacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnacksQuery, SnacksQueryVariables>(SnacksDocument, options);
        }
export type SnacksQueryHookResult = ReturnType<typeof useSnacksQuery>;
export type SnacksLazyQueryHookResult = ReturnType<typeof useSnacksLazyQuery>;
export type SnacksQueryResult = Apollo.QueryResult<SnacksQuery, SnacksQueryVariables>;
export const TreatmentDocument = gql`
    query treatment($where: TreatmentWhereUniqueInput!) {
  treatment(where: $where) {
    ...TreatmentForQuery
  }
}
    ${TreatmentForQueryFragmentDoc}`;

/**
 * __useTreatmentQuery__
 *
 * To run a query within a React component, call `useTreatmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatmentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTreatmentQuery(baseOptions: Apollo.QueryHookOptions<TreatmentQuery, TreatmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatmentQuery, TreatmentQueryVariables>(TreatmentDocument, options);
      }
export function useTreatmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatmentQuery, TreatmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatmentQuery, TreatmentQueryVariables>(TreatmentDocument, options);
        }
export type TreatmentQueryHookResult = ReturnType<typeof useTreatmentQuery>;
export type TreatmentLazyQueryHookResult = ReturnType<typeof useTreatmentLazyQuery>;
export type TreatmentQueryResult = Apollo.QueryResult<TreatmentQuery, TreatmentQueryVariables>;
export const TreatmentsDocument = gql`
    query treatments($where: TreatmentPatientWhereInput!) {
  treatments(where: $where) {
    ...TreatmentForQuery
  }
}
    ${TreatmentForQueryFragmentDoc}`;

/**
 * __useTreatmentsQuery__
 *
 * To run a query within a React component, call `useTreatmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTreatmentsQuery(baseOptions: Apollo.QueryHookOptions<TreatmentsQuery, TreatmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatmentsQuery, TreatmentsQueryVariables>(TreatmentsDocument, options);
      }
export function useTreatmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatmentsQuery, TreatmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatmentsQuery, TreatmentsQueryVariables>(TreatmentsDocument, options);
        }
export type TreatmentsQueryHookResult = ReturnType<typeof useTreatmentsQuery>;
export type TreatmentsLazyQueryHookResult = ReturnType<typeof useTreatmentsLazyQuery>;
export type TreatmentsQueryResult = Apollo.QueryResult<TreatmentsQuery, TreatmentsQueryVariables>;
export const UserDocument = gql`
    query user($where: UserWhereUniqueInput!) {
  user(where: $where) {
    ...UserCore
    departments {
      department {
        id
        name
        manager {
          name
        }
      }
    }
  }
}
    ${UserCoreFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const YojyoVideoContentDocument = gql`
    query yojyoVideoContent($id: ID!) {
  yojyoVideoContent(id: $id) {
    ...YojyoVideoContentCore
  }
}
    ${YojyoVideoContentCoreFragmentDoc}`;

/**
 * __useYojyoVideoContentQuery__
 *
 * To run a query within a React component, call `useYojyoVideoContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useYojyoVideoContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYojyoVideoContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useYojyoVideoContentQuery(baseOptions: Apollo.QueryHookOptions<YojyoVideoContentQuery, YojyoVideoContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YojyoVideoContentQuery, YojyoVideoContentQueryVariables>(YojyoVideoContentDocument, options);
      }
export function useYojyoVideoContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YojyoVideoContentQuery, YojyoVideoContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YojyoVideoContentQuery, YojyoVideoContentQueryVariables>(YojyoVideoContentDocument, options);
        }
export type YojyoVideoContentQueryHookResult = ReturnType<typeof useYojyoVideoContentQuery>;
export type YojyoVideoContentLazyQueryHookResult = ReturnType<typeof useYojyoVideoContentLazyQuery>;
export type YojyoVideoContentQueryResult = Apollo.QueryResult<YojyoVideoContentQuery, YojyoVideoContentQueryVariables>;
export const YojyoVideoContentCategoriesDocument = gql`
    query yojyoVideoContentCategories {
  yojyoVideoContentCategories {
    ...YojyoVideoContentCategoryCore
  }
}
    ${YojyoVideoContentCategoryCoreFragmentDoc}`;

/**
 * __useYojyoVideoContentCategoriesQuery__
 *
 * To run a query within a React component, call `useYojyoVideoContentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useYojyoVideoContentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYojyoVideoContentCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useYojyoVideoContentCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<YojyoVideoContentCategoriesQuery, YojyoVideoContentCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YojyoVideoContentCategoriesQuery, YojyoVideoContentCategoriesQueryVariables>(YojyoVideoContentCategoriesDocument, options);
      }
export function useYojyoVideoContentCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YojyoVideoContentCategoriesQuery, YojyoVideoContentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YojyoVideoContentCategoriesQuery, YojyoVideoContentCategoriesQueryVariables>(YojyoVideoContentCategoriesDocument, options);
        }
export type YojyoVideoContentCategoriesQueryHookResult = ReturnType<typeof useYojyoVideoContentCategoriesQuery>;
export type YojyoVideoContentCategoriesLazyQueryHookResult = ReturnType<typeof useYojyoVideoContentCategoriesLazyQuery>;
export type YojyoVideoContentCategoriesQueryResult = Apollo.QueryResult<YojyoVideoContentCategoriesQuery, YojyoVideoContentCategoriesQueryVariables>;
export const YojyomailDocument = gql`
    query yojyomail {
  yojyomail {
    id
    title
    content
    eyecatch {
      url
      height
      width
    }
    hashtags {
      id
      name
    }
    month
    characteristicL
    ageRange
  }
}
    `;

/**
 * __useYojyomailQuery__
 *
 * To run a query within a React component, call `useYojyomailQuery` and pass it any options that fit your needs.
 * When your component renders, `useYojyomailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYojyomailQuery({
 *   variables: {
 *   },
 * });
 */
export function useYojyomailQuery(baseOptions?: Apollo.QueryHookOptions<YojyomailQuery, YojyomailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YojyomailQuery, YojyomailQueryVariables>(YojyomailDocument, options);
      }
export function useYojyomailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YojyomailQuery, YojyomailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YojyomailQuery, YojyomailQueryVariables>(YojyomailDocument, options);
        }
export type YojyomailQueryHookResult = ReturnType<typeof useYojyomailQuery>;
export type YojyomailLazyQueryHookResult = ReturnType<typeof useYojyomailLazyQuery>;
export type YojyomailQueryResult = Apollo.QueryResult<YojyomailQuery, YojyomailQueryVariables>;
export const YojyomailForShortDocument = gql`
    query yojyomailForShort {
  yojyomailForShort {
    id
    title
    content
    eyecatch {
      url
      height
      width
    }
    hashtags {
      id
      name
    }
    month
    characteristicL
    ageRange
  }
}
    `;

/**
 * __useYojyomailForShortQuery__
 *
 * To run a query within a React component, call `useYojyomailForShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useYojyomailForShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYojyomailForShortQuery({
 *   variables: {
 *   },
 * });
 */
export function useYojyomailForShortQuery(baseOptions?: Apollo.QueryHookOptions<YojyomailForShortQuery, YojyomailForShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YojyomailForShortQuery, YojyomailForShortQueryVariables>(YojyomailForShortDocument, options);
      }
export function useYojyomailForShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YojyomailForShortQuery, YojyomailForShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YojyomailForShortQuery, YojyomailForShortQueryVariables>(YojyomailForShortDocument, options);
        }
export type YojyomailForShortQueryHookResult = ReturnType<typeof useYojyomailForShortQuery>;
export type YojyomailForShortLazyQueryHookResult = ReturnType<typeof useYojyomailForShortLazyQuery>;
export type YojyomailForShortQueryResult = Apollo.QueryResult<YojyomailForShortQuery, YojyomailForShortQueryVariables>;